import React, { type SVGProps } from 'react';

export type SVGComponentProps = SVGProps<SVGSVGElement>;

import { PRIMARY_COLOR } from '../../../constants/global';
export interface ISVG extends SVGComponentProps {
	width?: string;
	height?: string;
	color?: string;
}

export const InfoSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '10'}
		height={height || '10'}
		viewBox='0 0 10 10'
		fill='none'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10ZM5.58125 4.1175L4.15 4.29688L4.09875 4.53438L4.38 4.58625C4.56375 4.63 4.6 4.69625 4.56 4.87938L4.09875 7.04687C3.9775 7.6075 4.16438 7.87125 4.60375 7.87125C4.94438 7.87125 5.34 7.71375 5.51938 7.4975L5.57437 7.2375C5.44937 7.3475 5.26687 7.39125 5.14562 7.39125C4.97375 7.39125 4.91125 7.27063 4.95562 7.05813L5.58125 4.1175ZM5 3.4375C5.16576 3.4375 5.32473 3.37165 5.44194 3.25444C5.55915 3.13723 5.625 2.97826 5.625 2.8125C5.625 2.64674 5.55915 2.48777 5.44194 2.37056C5.32473 2.25335 5.16576 2.1875 5 2.1875C4.83424 2.1875 4.67527 2.25335 4.55806 2.37056C4.44085 2.48777 4.375 2.64674 4.375 2.8125C4.375 2.97826 4.44085 3.13723 4.55806 3.25444C4.67527 3.37165 4.83424 3.4375 5 3.4375Z'
			fill={color || 'black'}
		/>
	</svg>
);

export const AlertSVG = () => (
	<svg
		width='15'
		height='15'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<mask
			id='mask0_3789_26'
			maskUnits='userSpaceOnUse'
			x='0'
			y='0'
			width='20'
			height='20'
		>
			<path
				d='M9.99967 19.1663C4.91634 19.1663 0.833008 15.083 0.833008 9.99967C0.833008 4.91634 4.91634 0.833008 9.99967 0.833008C15.083 0.833008 19.1663 4.91634 19.1663 9.99967C19.1663 15.083 15.083 19.1663 9.99967 19.1663ZM9.99967 2.49967C5.83301 2.49967 2.49967 5.83301 2.49967 9.99967C2.49967 14.1663 5.83301 17.4997 9.99967 17.4997C14.1663 17.4997 17.4997 14.1663 17.4997 9.99967C17.4997 5.83301 14.1663 2.49967 9.99967 2.49967Z'
				fill='#B92500'
			/>
			<path
				d='M9.99967 10.833C9.49967 10.833 9.16634 10.4997 9.16634 9.99967V6.66634C9.16634 6.16634 9.49967 5.83301 9.99967 5.83301C10.4997 5.83301 10.833 6.16634 10.833 6.66634V9.99967C10.833 10.4997 10.4997 10.833 9.99967 10.833Z'
				fill='#B92500'
			/>
			<path
				d='M9.99967 14.1663C9.74967 14.1663 9.58301 14.083 9.41634 13.9163C9.24967 13.7497 9.16634 13.583 9.16634 13.333C9.16634 13.2497 9.16634 13.083 9.24967 12.9997C9.33301 12.9163 9.33301 12.833 9.41634 12.7497C9.66634 12.4997 9.99967 12.4163 10.333 12.583C10.4163 12.583 10.4163 12.583 10.4997 12.6663C10.4997 12.6663 10.583 12.7497 10.6663 12.7497C10.7497 12.833 10.833 12.9163 10.833 12.9997C10.833 13.083 10.833 13.2497 10.833 13.333C10.833 13.4163 10.833 13.583 10.7497 13.6663C10.6663 13.7497 10.6663 13.833 10.583 13.9163C10.4163 14.083 10.2497 14.1663 9.99967 14.1663Z'
				fill='#B92500'
			/>
		</mask>
		<g mask='url(#mask0_3789_26)'>
			<rect
				width='20'
				height='20'
				fill='#1C1C1C'
			/>
		</g>
	</svg>
);

export const CheckSVG = ({ width, height, color, ...rest }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '15'}
		height={height || '15'}
		viewBox='0 0 29 29'
		fill='none'
		{...rest}
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M28.74 14.37C28.74 18.1812 27.226 21.8362 24.5311 24.5311C21.8362 27.226 18.1812 28.74 14.37 28.74C10.5588 28.74 6.90377 27.226 4.20888 24.5311C1.51398 21.8362 0 18.1812 0 14.37C0 10.5588 1.51398 6.90377 4.20888 4.20888C6.90377 1.51398 10.5588 0 14.37 0C18.1812 0 21.8362 1.51398 24.5311 4.20888C27.226 6.90377 28.74 10.5588 28.74 14.37ZM21.6089 8.92736C21.4806 8.7995 21.3278 8.69883 21.1597 8.63137C20.9916 8.5639 20.8116 8.53103 20.6305 8.53472C20.4494 8.53841 20.2709 8.57858 20.1057 8.65284C19.9405 8.72709 19.7919 8.8339 19.6689 8.96688L13.4306 16.9153L9.67101 13.1539C9.41563 12.916 9.07785 12.7864 8.72884 12.7926C8.37982 12.7987 8.04682 12.9401 7.8 13.187C7.55317 13.4338 7.41178 13.7668 7.40562 14.1158C7.39947 14.4648 7.52902 14.8026 7.76698 15.058L12.5199 19.8126C12.6479 19.9404 12.8004 20.0412 12.9682 20.1088C13.136 20.1764 13.3157 20.2095 13.4966 20.2061C13.6774 20.2028 13.8558 20.163 14.021 20.0892C14.1862 20.0155 14.3348 19.9092 14.458 19.7767L21.6286 10.8134C21.8731 10.5593 22.0082 10.2194 22.0048 9.86673C22.0014 9.51409 21.8599 9.17683 21.6107 8.92736H21.6089Z'
			fill={color || 'black'}
		/>
	</svg>
);

export const AngleRightSVG = ({ className }: { className?: string }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='8'
		height='13'
		viewBox='0 0 8 13'
		fill='none'
		className={className}
	>
		<path
			d='M0.657227 12.3135L6.31408 6.65662L0.657227 0.999768'
			stroke='#69696A'
		/>
	</svg>
);

export const AngleDownSVG = ({ className }: { className?: string }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='13'
		height='8'
		viewBox='0 0 13 8'
		fill='none'
		className={className}
	>
		<path
			d='M0.657227 0.686523L6.31408 6.34338L11.9709 0.686523'
			stroke='#69696A'
		/>
	</svg>
);

export const LockSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '7'}
		height={height || '12'}
		viewBox='0 0 7 12'
		fill='none'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M5.72727 5.74435H1.27273C1.10395 5.74435 0.942092 5.82504 0.82275 5.96868C0.703409 6.11231 0.636364 6.30713 0.636364 6.51026V10.3398C0.636364 10.543 0.703409 10.7378 0.82275 10.8814C0.942092 11.025 1.10395 11.1057 1.27273 11.1057H5.72727C5.89605 11.1057 6.05791 11.025 6.17725 10.8814C6.29659 10.7378 6.36364 10.543 6.36364 10.3398V6.51026C6.36364 6.30713 6.29659 6.11231 6.17725 5.96868C6.05791 5.82504 5.89605 5.74435 5.72727 5.74435ZM1.27273 4.97843C0.935179 4.97843 0.611456 5.13982 0.372773 5.4271C0.13409 5.71437 0 6.10399 0 6.51026V10.3398C0 10.7461 0.13409 11.1357 0.372773 11.423C0.611456 11.7103 0.935179 11.8717 1.27273 11.8717H5.72727C6.06482 11.8717 6.38854 11.7103 6.62723 11.423C6.86591 11.1357 7 10.7461 7 10.3398V6.51026C7 6.10399 6.86591 5.71437 6.62723 5.4271C6.38854 5.13982 6.06482 4.97843 5.72727 4.97843H1.27273ZM1.27273 2.6807C1.27273 1.96973 1.50739 1.28789 1.92508 0.785157C2.34278 0.28243 2.90929 0 3.5 0C4.09071 0 4.65722 0.28243 5.07492 0.785157C5.49261 1.28789 5.72727 1.96973 5.72727 2.6807V4.97843H5.09091V2.6807C5.09091 2.17286 4.9233 1.68583 4.62494 1.32674C4.32659 0.967648 3.92194 0.765913 3.5 0.765913C3.07806 0.765913 2.67341 0.967648 2.37506 1.32674C2.0767 1.68583 1.90909 2.17286 1.90909 2.6807V4.97843H1.27273V2.6807Z'
			fill={color || '#69696A'}
		/>
	</svg>
);

export const HamburgerSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '19'}
		height={height || '15'}
		viewBox='0 0 19 15'
		fill='none'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0 14.1667C0 13.9457 0.0877975 13.7337 0.244078 13.5774C0.400358 13.4211 0.61232 13.3333 0.833333 13.3333H17.5C17.721 13.3333 17.933 13.4211 18.0893 13.5774C18.2455 13.7337 18.3333 13.9457 18.3333 14.1667C18.3333 14.3877 18.2455 14.5996 18.0893 14.7559C17.933 14.9122 17.721 15 17.5 15H0.833333C0.61232 15 0.400358 14.9122 0.244078 14.7559C0.0877975 14.5996 0 14.3877 0 14.1667ZM0 7.5C0 7.27899 0.0877975 7.06702 0.244078 6.91074C0.400358 6.75446 0.61232 6.66667 0.833333 6.66667H17.5C17.721 6.66667 17.933 6.75446 18.0893 6.91074C18.2455 7.06702 18.3333 7.27899 18.3333 7.5C18.3333 7.72101 18.2455 7.93297 18.0893 8.08926C17.933 8.24554 17.721 8.33333 17.5 8.33333H0.833333C0.61232 8.33333 0.400358 8.24554 0.244078 8.08926C0.0877975 7.93297 0 7.72101 0 7.5ZM0 0.833333C0 0.61232 0.0877975 0.400358 0.244078 0.244078C0.400358 0.0877975 0.61232 0 0.833333 0H17.5C17.721 0 17.933 0.0877975 18.0893 0.244078C18.2455 0.400358 18.3333 0.61232 18.3333 0.833333C18.3333 1.05435 18.2455 1.26631 18.0893 1.42259C17.933 1.57887 17.721 1.66667 17.5 1.66667H0.833333C0.61232 1.66667 0.400358 1.57887 0.244078 1.42259C0.0877975 1.26631 0 1.05435 0 0.833333Z'
			fill={color || 'black'}
		/>
	</svg>
);

export const EllipsisSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '3'}
		height={height || '10'}
		viewBox='0 0 3 10'
		fill='none'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0.538391 8.38614C0.538391 8.67624 0.653634 8.95447 0.85877 9.1596C1.0639 9.36474 1.34213 9.47998 1.63223 9.47998C1.92234 9.47998 2.20056 9.36474 2.4057 9.1596C2.61083 8.95447 2.72607 8.67624 2.72607 8.38614C2.72607 8.09603 2.61083 7.81781 2.4057 7.61268C2.20056 7.40754 1.92234 7.2923 1.63223 7.2923C1.34213 7.2923 1.0639 7.40754 0.858769 7.61268C0.653634 7.81781 0.538391 8.09603 0.538391 8.38614ZM0.538391 4.74C0.538391 5.03011 0.653634 5.30833 0.858769 5.51346C1.0639 5.7186 1.34213 5.83384 1.63223 5.83384C1.92234 5.83384 2.20056 5.7186 2.4057 5.51346C2.61083 5.30833 2.72607 5.03011 2.72607 4.74C2.72607 4.4499 2.61083 4.17167 2.4057 3.96654C2.20056 3.7614 1.92234 3.64616 1.63223 3.64616C1.34213 3.64616 1.0639 3.7614 0.858769 3.96654C0.653634 4.17167 0.538391 4.4499 0.538391 4.74ZM0.538391 1.09386C0.538391 1.38397 0.653634 1.66219 0.858769 1.86732C1.0639 2.07246 1.34213 2.1877 1.63223 2.1877C1.92234 2.1877 2.20056 2.07246 2.4057 1.86732C2.61083 1.66219 2.72607 1.38397 2.72607 1.09386C2.72607 0.803757 2.61083 0.525534 2.4057 0.320399C2.20056 0.115264 1.92234 2.01219e-05 1.63223 2.01346e-05C1.34213 2.01473e-05 1.0639 0.115264 0.858769 0.320399C0.653634 0.525534 0.53839 0.803757 0.538391 1.09386Z'
			fill={color || '#274169'}
		/>
	</svg>
);

export const CloseSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '9'}
		height={height || '9'}
		viewBox='0 0 6 6'
		fill='none'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0.125881 0.125881C0.165683 0.0859786 0.212966 0.0543201 0.265022 0.0327193C0.317078 0.0111185 0.372884 0 0.429244 0C0.485604 0 0.54141 0.0111185 0.593466 0.0327193C0.645521 0.0543201 0.692805 0.0859786 0.732606 0.125881L3.00011 2.39424L5.26762 0.125881C5.30746 0.0860432 5.35475 0.0544418 5.4068 0.0328815C5.45885 0.0113213 5.51464 0.000224337 5.57098 0.000224337C5.62732 0.000224337 5.68311 0.0113213 5.73516 0.0328815C5.78721 0.0544418 5.83451 0.0860432 5.87434 0.125881C5.91418 0.165719 5.94578 0.213014 5.96734 0.265065C5.9889 0.317116 6 0.372904 6 0.429244C6 0.485583 5.9889 0.541372 5.96734 0.593423C5.94578 0.645474 5.91418 0.692768 5.87434 0.732606L3.60598 3.00011L5.87434 5.26762C5.91418 5.30746 5.94578 5.35475 5.96734 5.4068C5.9889 5.45885 6 5.51464 6 5.57098C6 5.62732 5.9889 5.68311 5.96734 5.73516C5.94578 5.78721 5.91418 5.83451 5.87434 5.87434C5.83451 5.91418 5.78721 5.94578 5.73516 5.96734C5.68311 5.9889 5.62732 6 5.57098 6C5.51464 6 5.45885 5.9889 5.4068 5.96734C5.35475 5.94578 5.30746 5.91418 5.26762 5.87434L3.00011 3.60598L0.732606 5.87434C0.692768 5.91418 0.645474 5.94578 0.593423 5.96734C0.541372 5.9889 0.485583 6 0.429244 6C0.372904 6 0.317116 5.9889 0.265065 5.96734C0.213014 5.94578 0.165719 5.91418 0.125881 5.87434C0.0860432 5.83451 0.0544418 5.78721 0.0328815 5.73516C0.0113213 5.68311 0.000224337 5.62732 0.000224337 5.57098C0.000224337 5.51464 0.0113213 5.45885 0.0328815 5.4068C0.0544418 5.35475 0.0860432 5.30746 0.125881 5.26762L2.39424 3.00011L0.125881 0.732606C0.0859786 0.692805 0.0543201 0.645521 0.0327193 0.593466C0.0111185 0.54141 0 0.485604 0 0.429244C0 0.372884 0.0111185 0.317078 0.0327193 0.265022C0.0543201 0.212966 0.0859786 0.165683 0.125881 0.125881Z'
			fill={color || '#F56E9D'}
		/>
	</svg>
);

export const ArrowRightSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '22'}
		height={height || '9'}
		viewBox='0 0 22 9'
		fill='none'
	>
		<path
			d='M21.3407 4.80566C21.5402 4.61478 21.5473 4.29828 21.3564 4.09872L18.2459 0.846835C18.055 0.647283 17.7385 0.64025 17.539 0.831125C17.3394 1.022 17.3324 1.33851 17.5232 1.53806L20.2881 4.42863L17.3976 7.19352C17.198 7.38439 17.191 7.7009 17.3819 7.90045C17.5727 8.1 17.8892 8.10703 18.0888 7.91616L21.3407 4.80566ZM0.988892 4.49988L20.984 4.94421L21.0062 3.94446L1.01111 3.50012L0.988892 4.49988Z'
			fill={color || 'black'}
		/>
	</svg>
);

export const ArrowLeftSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='26'
		height='8'
		viewBox='0 0 26 8'
		fill='none'
	>
		<path
			d='M0.646447 3.64645C0.451184 3.84171 0.451184 4.15829 0.646447 4.35356L3.82843 7.53554C4.02369 7.7308 4.34027 7.7308 4.53553 7.53554C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976313 4.7308 0.65973 4.53553 0.464468C4.34027 0.269206 4.02369 0.269206 3.82843 0.464468L0.646447 3.64645ZM26 3.5L1 3.5L1 4.5L26 4.5L26 3.5Z'
			fill='black'
		/>
	</svg>
);

export const NotificationSVG = ({ color }: { color?: string }) => (
	<svg
		width='14'
		height='15'
		viewBox='0 0 19 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M0.813127 15.0249V8.23085C0.813127 5.96733 1.73884 3.90972 3.23081 2.41769C4.72203 0.926466 6.77944 0 9.04397 0C11.3075 0 13.3651 0.925709 14.8571 2.41769C16.3484 3.90891 17.274 5.96713 17.274 8.23085V15.0249H17.6206C17.8794 15.0249 18.0895 15.2349 18.0895 15.4937C18.0895 15.7525 17.8794 15.9626 17.6206 15.9626H0.468856C0.210075 15.9626 0 15.7525 0 15.4937C0 15.2349 0.210055 15.0249 0.468856 15.0249H0.815499H0.813127ZM11.7821 17.7812C11.9474 17.5831 12.2429 17.5567 12.441 17.7228C12.6391 17.8882 12.6655 18.1837 12.4993 18.3818C12.08 18.8842 11.5513 19.2931 10.9482 19.5759C10.3667 19.8474 9.72059 20 9.04327 20C8.36516 20 7.71978 19.8482 7.13832 19.5759C6.53609 19.2939 6.00734 18.8842 5.58721 18.3818C5.42187 18.1837 5.44743 17.889 5.64552 17.7228C5.8436 17.5575 6.13834 17.5831 6.30447 17.7812C6.63913 18.1821 7.05846 18.5072 7.5329 18.7292C7.98898 18.9417 8.50016 19.0607 9.04248 19.0607C9.5856 19.0607 10.0968 18.9417 10.5521 18.7292C11.0265 18.5072 11.4458 18.1813 11.7805 17.7812H11.7821ZM16.3363 15.0249V8.23085C16.3363 6.22526 15.5152 4.4025 14.1934 3.08059C12.8716 1.75867 11.048 0.937712 9.04315 0.937712C7.03756 0.937712 5.21481 1.75879 3.89371 3.08059C2.57184 4.40246 1.75084 6.22599 1.75084 8.23085V15.0249H16.3363ZM9.04397 5.03289C8.78519 5.03289 8.57512 4.82284 8.57512 4.56404C8.57512 4.30526 8.78517 4.09518 9.04397 4.09518C10.1822 4.09518 11.2165 4.56003 11.9649 5.31004C12.7141 6.06004 13.1797 7.09359 13.1797 8.23093C13.1797 8.48971 12.9697 8.69978 12.7109 8.69978C12.4521 8.69978 12.242 8.48973 12.242 8.23093C12.242 7.35153 11.8818 6.55202 11.3019 5.97212C10.722 5.39225 9.92251 5.03201 9.04309 5.03201L9.04397 5.03289Z'
			fill={color || 'black'}
		/>
	</svg>
);

export const HomeSVG = ({ width, height, color }: ISVG) => (
	<svg
		width='13'
		height='13'
		viewBox='0 0 15 15'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M14.3055 4.47812L8.46709 0.310019C7.88758 -0.103339 7.10981 -0.103339 6.53111 0.310019L0.692684 4.47812C0.258449 4.78794 0 5.28959 0 5.82175V13.3473C0 14.2592 0.744854 15 1.66147 15H13.3391C14.2549 15 15.0006 14.2584 15.0006 13.3473V5.82175C15.0006 5.29041 14.7413 4.78796 14.3079 4.47892L14.3055 4.47812ZM5.47884 13.9726V10.2619C5.47884 9.15825 6.377 8.26009 7.48064 8.26009H7.51595C8.61959 8.26009 9.51775 9.15825 9.51775 10.2619V13.9726H5.47807H5.47884ZM13.9708 13.3473C13.9708 13.6925 13.6867 13.9726 13.3367 13.9726H10.5451V10.2619C10.5451 8.59158 9.18622 7.23274 7.51596 7.23274H7.48064C5.81034 7.23274 4.4515 8.59162 4.4515 10.2619V13.9726H1.65989C1.31074 13.9726 1.02581 13.6917 1.02581 13.3473V5.82173C1.02581 5.62187 1.12373 5.43166 1.28826 5.31445L7.12669 1.14635C7.23745 1.06689 7.36748 1.02756 7.49751 1.02756C7.62754 1.02756 7.75756 1.06689 7.86833 1.14635L13.7068 5.31445C13.8713 5.43164 13.9692 5.62106 13.9692 5.82173V13.3473H13.9708Z'
			fill='black'
		/>
	</svg>
);

export const RightArrowSVG = ({ width, height, color }: ISVG) => (
	<svg
		width='6'
		height='11'
		viewBox='0 0 6 11'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M1 9.65625L5.24264 5.41361L0.999999 1.17097'
			stroke='black'
		/>
	</svg>
);

export const ApplicationsSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '50'}
		height={height || '50'}
		viewBox='0 0 50 50'
		fill='none'
	>
		<circle
			cx='25'
			cy='25'
			r='25'
			fill='#EDF5FF'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M21.5 19C20.5717 19 19.6815 19.3687 19.0251 20.0251C18.3687 20.6815 18 21.5717 18 22.5V27.5C18 28.4283 18.3687 29.3185 19.0251 29.9749C19.6815 30.6313 20.5717 31 21.5 31H26.5C27.4283 31 28.3185 30.6313 28.9749 29.9749C29.6313 29.3185 30 28.4283 30 27.5V25C30 24.8674 30.0527 24.7402 30.1464 24.6464C30.2402 24.5527 30.3674 24.5 30.5 24.5C30.6326 24.5 30.7598 24.5527 30.8536 24.6464C30.9473 24.7402 31 24.8674 31 25V27.5C31 28.6935 30.5259 29.8381 29.682 30.682C28.8381 31.5259 27.6935 32 26.5 32H21.5C20.3065 32 19.1619 31.5259 18.318 30.682C17.4741 29.8381 17 28.6935 17 27.5V22.5C17 21.3065 17.4741 20.1619 18.318 19.318C19.1619 18.4741 20.3065 18 21.5 18H24C24.1326 18 24.2598 18.0527 24.3536 18.1464C24.4473 18.2402 24.5 18.3674 24.5 18.5C24.5 18.6326 24.4473 18.7598 24.3536 18.8536C24.2598 18.9473 24.1326 19 24 19H21.5Z'
			fill={color || '#274169'}
		/>
		<path
			d='M32 20C32 20.7956 31.6839 21.5587 31.1213 22.1213C30.5587 22.6839 29.7956 23 29 23C28.2044 23 27.4413 22.6839 26.8787 22.1213C26.3161 21.5587 26 20.7956 26 20C26 19.2044 26.3161 18.4413 26.8787 17.8787C27.4413 17.3161 28.2044 17 29 17C29.7956 17 30.5587 17.3161 31.1213 17.8787C31.6839 18.4413 32 19.2044 32 20Z'
			fill={color || '#274169'}
		/>
	</svg>
);

export const UserSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '30'}
		height={height || '30'}
		viewBox='0 0 30 30'
		fill='none'
	>
		<circle
			cx='15'
			cy='15'
			r='15'
			fill='#EDF5FF'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M16.2002 12.45C16.2002 12.8478 16.0422 13.2293 15.7609 13.5106C15.4796 13.7919 15.098 13.95 14.7002 13.95C14.3024 13.95 13.9208 13.7919 13.6395 13.5106C13.3582 13.2293 13.2002 12.8478 13.2002 12.45C13.2002 12.0521 13.3582 11.6706 13.6395 11.3893C13.9208 11.108 14.3024 10.95 14.7002 10.95C15.098 10.95 15.4796 11.108 15.7609 11.3893C16.0422 11.6706 16.2002 12.0521 16.2002 12.45ZM14.7002 14.7C15.2969 14.7 15.8692 14.4629 16.2912 14.0409C16.7131 13.619 16.9502 13.0467 16.9502 12.45C16.9502 11.8532 16.7131 11.2809 16.2912 10.859C15.8692 10.437 15.2969 10.2 14.7002 10.2C14.1035 10.2 13.5312 10.437 13.1092 10.859C12.6872 11.2809 12.4502 11.8532 12.4502 12.45C12.4502 13.0467 12.6872 13.619 13.1092 14.0409C13.5312 14.4629 14.1035 14.7 14.7002 14.7ZM19.2002 18.45C19.2002 19.2 18.4502 19.2 18.4502 19.2H10.9502C10.9502 19.2 10.2002 19.2 10.2002 18.45C10.2002 17.7 10.9502 15.45 14.7002 15.45C18.4502 15.45 19.2002 17.7 19.2002 18.45ZM18.4502 18.447C18.4494 18.2625 18.3347 17.7075 17.8262 17.199C17.3372 16.71 16.4169 16.2 14.7002 16.2C12.9827 16.2 12.0632 16.71 11.5742 17.199C11.0657 17.7075 10.9517 18.2625 10.9502 18.447H18.4502Z'
			fill={color || '#274169'}
		/>
	</svg>
);

export const UsersSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '50'}
		height={height || '50'}
		viewBox='0 0 50 50'
		fill='none'
	>
		<circle
			cx='25'
			cy='25'
			r='25'
			fill='#EDF5FF'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M32.25 31C32.25 31 33.3333 31 33.3333 29.9167C33.3333 28.8333 32.25 25.5833 27.9167 25.5833C23.5833 25.5833 22.5 28.8333 22.5 29.9167C22.5 31 23.5833 31 23.5833 31H32.25ZM23.6072 29.9167H32.2262C32.2312 29.9161 32.2363 29.9154 32.2413 29.9145L32.25 29.9123C32.2478 29.6263 32.0691 28.7965 31.4267 28.049C30.8287 27.3481 29.7778 26.6667 27.9167 26.6667C26.0566 26.6667 25.0057 27.3492 24.4067 28.049C23.7642 28.7965 23.5844 29.6274 23.5833 29.9123C23.5913 29.9139 23.5992 29.9153 23.6072 29.9167ZM27.9167 23.4167C28.4913 23.4167 29.0424 23.1884 29.4487 22.7821C29.8551 22.3757 30.0833 21.8246 30.0833 21.25C30.0833 20.6754 29.8551 20.1243 29.4487 19.7179C29.0424 19.3116 28.4913 19.0833 27.9167 19.0833C27.342 19.0833 26.7909 19.3116 26.3846 19.7179C25.9783 20.1243 25.75 20.6754 25.75 21.25C25.75 21.8246 25.9783 22.3757 26.3846 22.7821C26.7909 23.1884 27.342 23.4167 27.9167 23.4167ZM31.1667 21.25C31.1667 21.6768 31.0826 22.0994 30.9193 22.4937C30.7559 22.888 30.5166 23.2463 30.2148 23.5481C29.913 23.8499 29.5547 24.0893 29.1604 24.2526C28.7661 24.4159 28.3435 24.5 27.9167 24.5C27.4899 24.5 27.0673 24.4159 26.6729 24.2526C26.2786 24.0893 25.9204 23.8499 25.6186 23.5481C25.3168 23.2463 25.0774 22.888 24.9141 22.4937C24.7507 22.0994 24.6667 21.6768 24.6667 21.25C24.6667 20.388 25.0091 19.5614 25.6186 18.9519C26.2281 18.3424 27.0547 18 27.9167 18C28.7786 18 29.6053 18.3424 30.2148 18.9519C30.8243 19.5614 31.1667 20.388 31.1667 21.25ZM23.514 25.8867C23.0806 25.7502 22.6339 25.6605 22.1815 25.6191C21.9273 25.5949 21.672 25.583 21.4167 25.5833C17.0833 25.5833 16 28.8333 16 29.9167C16 30.6393 16.3607 31 17.0833 31H21.6507C21.4901 30.6618 21.41 30.291 21.4167 29.9167C21.4167 28.8225 21.8251 27.7045 22.5975 26.7707C22.8607 26.4522 23.1673 26.1543 23.514 25.8867ZM21.33 26.6667C19.523 26.6883 18.4971 27.36 17.9067 28.049C17.2599 28.8008 17.0833 29.6339 17.0833 29.9167H20.3333C20.3333 28.7846 20.6832 27.6568 21.33 26.6667ZM17.625 21.7917C17.625 20.9297 17.9674 20.1031 18.5769 19.4936C19.1864 18.8841 20.013 18.5417 20.875 18.5417C21.737 18.5417 22.5636 18.8841 23.1731 19.4936C23.7826 20.1031 24.125 20.9297 24.125 21.7917C24.125 22.6536 23.7826 23.4803 23.1731 24.0898C22.5636 24.6993 21.737 25.0417 20.875 25.0417C20.013 25.0417 19.1864 24.6993 18.5769 24.0898C17.9674 23.4803 17.625 22.6536 17.625 21.7917ZM20.875 19.625C20.3004 19.625 19.7493 19.8533 19.3429 20.2596C18.9366 20.6659 18.7083 21.217 18.7083 21.7917C18.7083 22.3663 18.9366 22.9174 19.3429 23.3237C19.7493 23.7301 20.3004 23.9583 20.875 23.9583C21.4496 23.9583 22.0007 23.7301 22.4071 23.3237C22.8134 22.9174 23.0417 22.3663 23.0417 21.7917C23.0417 21.217 22.8134 20.6659 22.4071 20.2596C22.0007 19.8533 21.4496 19.625 20.875 19.625Z'
			fill={color || '#274169'}
		/>
	</svg>
);

export const OrganizationsSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '50'}
		height={height || '50'}
		viewBox='0 0 50 50'
		fill='none'
	>
		<circle
			cx='25'
			cy='25'
			r='25'
			fill='#EDF5FF'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M18 25.5C18 23.5109 18.7902 21.6032 20.1967 20.1967C21.6032 18.7902 23.5109 18 25.5 18C27.4891 18 29.3968 18.7902 30.8033 20.1967C32.2098 21.6032 33 23.5109 33 25.5C33 27.4891 32.2098 29.3968 30.8033 30.8033C29.3968 32.2098 27.4891 33 25.5 33C23.5109 33 21.6032 32.2098 20.1967 30.8033C18.7902 29.3968 18 27.4891 18 25.5ZM25.0312 19.0097C24.4031 19.2009 23.7797 19.7784 23.2622 20.7487C23.1281 21 23.0034 21.2737 22.8919 21.5662C23.5528 21.7134 24.2719 21.8072 25.0312 21.8353V19.0097ZM21.9834 21.3178C21.5978 21.1939 21.2223 21.0403 20.8603 20.8584C21.471 20.2479 22.1961 19.7636 22.9941 19.4334C22.7837 19.7088 22.5965 20.001 22.4344 20.3072C22.262 20.634 22.1117 20.9719 21.9844 21.3187L21.9834 21.3178ZM21.2897 25.0312H18.9534C19.0407 23.7842 19.4842 22.5883 20.2313 21.5859C20.6719 21.8278 21.1641 22.0378 21.6984 22.2113C21.4554 23.1327 21.3179 24.0788 21.2887 25.0312H21.2897ZM22.6022 22.4616C23.3597 22.6369 24.1781 22.7438 25.0312 22.7728V25.0312H22.2281C22.2609 24.1059 22.3931 23.2369 22.6022 22.4616ZM25.9688 22.7719V25.0312H28.7719C28.744 24.1634 28.6185 23.3014 28.3978 22.4616C27.6403 22.6369 26.8219 22.7428 25.9688 22.7719ZM22.2281 25.9688H25.0312V28.2272C24.1781 28.2553 23.3597 28.3631 22.6022 28.5384C22.3812 27.6987 22.2554 26.8367 22.2272 25.9688H22.2281ZM25.9688 25.9688V28.2272C26.8219 28.2553 27.6403 28.3631 28.3978 28.5384C28.6069 27.7631 28.7391 26.8941 28.7728 25.9688H25.9688ZM22.8919 29.4338C23.5954 29.2795 24.3115 29.1898 25.0312 29.1656V31.9912C24.4031 31.8 23.7797 31.2225 23.2622 30.2522C23.1221 29.9876 22.9984 29.7136 22.8919 29.4338ZM22.995 31.5675C22.7843 31.2919 22.5968 30.9994 22.4344 30.6928C22.2617 30.366 22.1111 30.0281 21.9834 29.6813C21.5978 29.8052 21.2223 29.9588 20.8603 30.1406C21.4709 30.7519 22.1969 31.2368 22.995 31.5675ZM21.6984 28.7888C21.1909 28.9508 20.6997 29.1602 20.2313 29.4141C19.4845 28.4116 19.0413 27.2158 18.9544 25.9688H21.2887C21.3176 26.9213 21.455 27.8674 21.6984 28.7888ZM28.0059 31.5675C28.8037 31.2369 29.5284 30.7524 30.1387 30.1416C29.7771 29.9597 29.4019 29.8062 29.0166 29.6822C28.8889 30.0287 28.7383 30.3663 28.5656 30.6928C28.4036 30.9993 28.2164 31.2919 28.0059 31.5675ZM25.9688 29.1647C26.7281 29.1928 27.4472 29.2866 28.1081 29.4338C27.9956 29.7263 27.8719 30 27.7378 30.2512C27.2203 31.2216 26.5959 31.7981 25.9688 31.9903V29.1647ZM29.3016 28.7888C29.8359 28.9622 30.3281 29.1722 30.7687 29.4141C31.5155 28.4116 31.9587 27.2158 32.0456 25.9688H29.7112C29.6824 26.9213 29.545 27.8674 29.3016 28.7888ZM32.0456 25.0312H29.7112C29.6824 24.0787 29.545 23.1326 29.3016 22.2113C29.809 22.049 30.3002 21.8396 30.7687 21.5859C31.5155 22.5884 31.9587 23.7842 32.0456 25.0312ZM28.5656 20.3072C28.7316 20.6203 28.8834 20.9578 29.0175 21.3178C29.4025 21.1938 29.7774 21.0402 30.1387 20.8584C29.5283 20.248 28.8036 19.7637 28.0059 19.4334C28.2103 19.6988 28.3978 19.9931 28.5656 20.3072ZM28.1081 21.5662C27.4472 21.7134 26.7272 21.8072 25.9688 21.8353V19.0097C26.5969 19.2009 27.2203 19.7784 27.7378 20.7487C27.8719 21 27.9966 21.2737 28.1081 21.5662Z'
			fill={color || '#274169'}
		/>
	</svg>
);

export const BillingSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '50'}
		height={height || '50'}
		viewBox='0 0 50 50'
		fill='none'
	>
		<circle
			cx='25'
			cy='25'
			r='25'
			fill='#EDF5FF'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M16 20.1429C16 19.5745 16.2258 19.0295 16.6276 18.6276C17.0295 18.2258 17.5745 18 18.1429 18H32.6071C32.7492 18 32.8855 18.0564 32.986 18.1569C33.0864 18.2574 33.1429 18.3936 33.1429 18.5357C33.1429 18.6778 33.0864 18.8141 32.986 18.9145C32.8855 19.015 32.7492 19.0714 32.6071 19.0714H32.0714V21.2143C32.3556 21.2143 32.6281 21.3272 32.829 21.5281C33.03 21.729 33.1429 22.0016 33.1429 22.2857V31.3929C33.1429 31.8191 32.9735 32.2279 32.6721 32.5293C32.3707 32.8307 31.962 33 31.5357 33H18.6786C17.9682 33 17.2869 32.7178 16.7845 32.2155C16.2822 31.7131 16 31.0318 16 30.3214V20.1429ZM17.0714 21.9986V30.3214C17.0714 30.7477 17.2408 31.1565 17.5421 31.4578C17.8435 31.7592 18.2523 31.9286 18.6786 31.9286H31.5357C31.6778 31.9286 31.8141 31.8721 31.9145 31.7717C32.015 31.6712 32.0714 31.5349 32.0714 31.3929V22.2857H18.1429C17.7666 22.2862 17.397 22.1871 17.0714 21.9986ZM17.0714 20.1429C17.0714 20.427 17.1843 20.6995 17.3852 20.9005C17.5862 21.1014 17.8587 21.2143 18.1429 21.2143H31V19.0714H18.1429C17.8587 19.0714 17.5862 19.1843 17.3852 19.3852C17.1843 19.5862 17.0714 19.8587 17.0714 20.1429Z'
			fill={color || '#274169'}
		/>
	</svg>
);

export const SecuritySVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '50'}
		height={height || '50'}
		viewBox='0 0 50 50'
		fill='none'
	>
		<circle
			cx='25'
			cy='25'
			r='25'
			fill='#EDF5FF'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M28.7097 25.2581H21.9355C21.6788 25.2581 21.4327 25.36 21.2512 25.5415C21.0697 25.723 20.9677 25.9691 20.9677 26.2258V31.0645C20.9677 31.3212 21.0697 31.5673 21.2512 31.7488C21.4327 31.9303 21.6788 32.0323 21.9355 32.0323H28.7097C28.9663 32.0323 29.2125 31.9303 29.394 31.7488C29.5755 31.5673 29.6774 31.3212 29.6774 31.0645V26.2258C29.6774 25.9691 29.5755 25.723 29.394 25.5415C29.2125 25.36 28.9663 25.2581 28.7097 25.2581ZM21.9355 24.2903C21.4222 24.2903 20.9299 24.4942 20.5669 24.8572C20.2039 25.2202 20 25.7125 20 26.2258V31.0645C20 31.5778 20.2039 32.0701 20.5669 32.4331C20.9299 32.7961 21.4222 33 21.9355 33H28.7097C29.223 33 29.7153 32.7961 30.0783 32.4331C30.4412 32.0701 30.6452 31.5778 30.6452 31.0645V26.2258C30.6452 25.7125 30.4412 25.2202 30.0783 24.8572C29.7153 24.4942 29.223 24.2903 28.7097 24.2903H21.9355ZM21.9355 21.3871C21.9355 20.4888 22.2923 19.6273 22.9275 18.9921C23.5627 18.3569 24.4243 18 25.3226 18C26.2209 18 27.0824 18.3569 27.7176 18.9921C28.3528 19.6273 28.7097 20.4888 28.7097 21.3871V24.2903H27.7419V21.3871C27.7419 20.7454 27.487 20.1301 27.0333 19.6764C26.5796 19.2226 25.9642 18.9677 25.3226 18.9677C24.6809 18.9677 24.0656 19.2226 23.6118 19.6764C23.1581 20.1301 22.9032 20.7454 22.9032 21.3871V24.2903H21.9355V21.3871Z'
			fill={color || '#274169'}
		/>
	</svg>
);

export const ProfileSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '50'}
		height={height || '50'}
		viewBox='0 0 50 50'
		fill='none'
	>
		<circle
			cx='25'
			cy='25'
			r='25'
			fill='#EDF5FF'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M27 20.75C27 21.413 26.7366 22.0489 26.2678 22.5178C25.7989 22.9866 25.163 23.25 24.5 23.25C23.837 23.25 23.2011 22.9866 22.7322 22.5178C22.2634 22.0489 22 21.413 22 20.75C22 20.087 22.2634 19.4511 22.7322 18.9822C23.2011 18.5134 23.837 18.25 24.5 18.25C25.163 18.25 25.7989 18.5134 26.2678 18.9822C26.7366 19.4511 27 20.087 27 20.75ZM24.5 24.5C25.4946 24.5 26.4484 24.1049 27.1517 23.4017C27.8549 22.6984 28.25 21.7446 28.25 20.75C28.25 19.7554 27.8549 18.8016 27.1517 18.0983C26.4484 17.3951 25.4946 17 24.5 17C23.5054 17 22.5516 17.3951 21.8483 18.0983C21.1451 18.8016 20.75 19.7554 20.75 20.75C20.75 21.7446 21.1451 22.6984 21.8483 23.4017C22.5516 24.1049 23.5054 24.5 24.5 24.5ZM32 30.75C32 32 30.75 32 30.75 32H18.25C18.25 32 17 32 17 30.75C17 29.5 18.25 25.75 24.5 25.75C30.75 25.75 32 29.5 32 30.75ZM30.75 30.745C30.7487 30.4375 30.5575 29.5125 29.71 28.665C28.895 27.85 27.3613 27 24.5 27C21.6375 27 20.105 27.85 19.29 28.665C18.4425 29.5125 18.2525 30.4375 18.25 30.745H30.75Z'
			fill={color || '#274169'}
		/>
	</svg>
);

export const LogoutSVG = ({ width, height }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '50'}
		height={height || '50'}
		viewBox='0 0 50 50'
		fill='none'
	>
		<circle
			cx='25'
			cy='25'
			r='25'
			fill='#FAF5F7'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M21.8871 20.7331C20.8376 21.3142 20.0101 22.2265 19.5337 23.3274C19.0573 24.4284 18.9589 25.6562 19.2538 26.819C19.5487 27.9818 20.2203 29.0142 21.1638 29.7551C22.1073 30.496 23.2696 30.9036 24.4692 30.9143C25.6688 30.925 26.8381 30.5383 27.7947 29.8144C28.7513 29.0905 29.4413 28.0702 29.757 26.9129C30.0726 25.7555 29.9962 24.5262 29.5395 23.4169C29.0829 22.3076 28.2718 21.3806 27.2329 20.7809L27.776 19.8403C29.0225 20.5602 29.9955 21.6726 30.5432 23.0038C31.091 24.335 31.1825 25.8101 30.8036 27.1988C30.4247 28.5875 29.5966 29.8116 28.4487 30.6802C27.3008 31.5487 25.8977 32.0127 24.4582 31.9998C23.0188 31.9869 21.6242 31.4978 20.4921 30.6088C19.3599 29.7198 18.554 28.481 18.2001 27.0857C17.8461 25.6904 17.9641 24.2172 18.5356 22.8961C19.1071 21.5749 20.1 20.4802 21.3592 19.7827L21.8871 20.7331Z'
			fill='#F56E9D'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M23.9746 24.6028V17H25.0607V24.6028H23.9746Z'
			fill='#F56E9D'
		/>
	</svg>
);

export const CalendarSVG = ({ width, height }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '50'}
		height={height || '50'}
		viewBox='0 0 50 50'
		fill='none'
	>
		<circle
			cx='25'
			cy='25'
			r='25'
			fill='#EDF5FF'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M20.2812 17C20.4056 17 20.5248 17.0494 20.6127 17.1373C20.7006 17.2252 20.75 17.3444 20.75 17.4688V17.9375H28.25V17.4688C28.25 17.3444 28.2994 17.2252 28.3873 17.1373C28.4752 17.0494 28.5944 17 28.7188 17C28.8431 17 28.9623 17.0494 29.0502 17.1373C29.1381 17.2252 29.1875 17.3444 29.1875 17.4688V17.9375H30.125C30.6223 17.9375 31.0992 18.135 31.4508 18.4867C31.8025 18.8383 32 19.3152 32 19.8125V30.125C32 30.6223 31.8025 31.0992 31.4508 31.4508C31.0992 31.8025 30.6223 32 30.125 32H18.875C18.3777 32 17.9008 31.8025 17.5492 31.4508C17.1975 31.0992 17 30.6223 17 30.125V19.8125C17 19.3152 17.1975 18.8383 17.5492 18.4867C17.9008 18.135 18.3777 17.9375 18.875 17.9375H19.8125V17.4688C19.8125 17.3444 19.8619 17.2252 19.9498 17.1373C20.0377 17.0494 20.1569 17 20.2812 17ZM17.9375 20.75V30.125C17.9375 30.3736 18.0363 30.6121 18.2121 30.7879C18.3879 30.9637 18.6264 31.0625 18.875 31.0625H30.125C30.3736 31.0625 30.6121 30.9637 30.7879 30.7879C30.9637 30.6121 31.0625 30.3736 31.0625 30.125V20.75H17.9375Z'
			fill='#274169'
		/>
		<path
			d='M27.3125 23.0938C27.3125 22.9694 27.3619 22.8502 27.4498 22.7623C27.5377 22.6744 27.6569 22.625 27.7812 22.625H28.7188C28.8431 22.625 28.9623 22.6744 29.0502 22.7623C29.1381 22.8502 29.1875 22.9694 29.1875 23.0938V24.0312C29.1875 24.1556 29.1381 24.2748 29.0502 24.3627C28.9623 24.4506 28.8431 24.5 28.7188 24.5H27.7812C27.6569 24.5 27.5377 24.4506 27.4498 24.3627C27.3619 24.2748 27.3125 24.1556 27.3125 24.0312V23.0938Z'
			fill='#274169'
		/>
	</svg>
);

export const IntegrationSVG = ({ width, height }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '50'}
		height={height || '50'}
		viewBox='0 0 50 50'
		fill='none'
	>
		<circle
			cx='25'
			cy='25'
			r='25'
			fill='#EDF5FF'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M24 15C24.1658 15 24.3247 15.0658 24.4419 15.1831C24.5592 15.3003 24.625 15.4592 24.625 15.625V18.75H28.375V15.625C28.375 15.4592 28.4408 15.3003 28.5581 15.1831C28.6753 15.0658 28.8342 15 29 15C29.1658 15 29.3247 15.0658 29.4419 15.1831C29.5592 15.3003 29.625 15.4592 29.625 15.625V18.75H30.875C31.0408 18.75 31.1997 18.8158 31.3169 18.9331C31.4342 19.0503 31.5 19.2092 31.5 19.375V23.125C31.5 24.2853 31.0391 25.3981 30.2186 26.2186C29.3981 27.0391 28.2853 27.5 27.125 27.5C27.1225 28.0425 27.1125 28.5563 27.075 29.025C27.0238 29.6675 26.9175 30.2788 26.6787 30.805C26.4367 31.3616 26.0078 31.8161 25.4662 32.09C24.9062 32.375 24.2112 32.5 23.375 32.5C22.1275 32.5 21.3625 32.9125 20.9075 33.3975C20.4967 33.8313 20.2623 34.4027 20.25 35H19C19 34.23 19.29 33.2913 19.9962 32.54C20.7175 31.775 21.8263 31.25 23.375 31.25C24.1013 31.25 24.5775 31.14 24.8975 30.9762C25.1988 30.8225 25.3975 30.6012 25.54 30.2887C25.6912 29.9563 25.7812 29.5125 25.8275 28.9262C25.8612 28.5012 25.8713 28.0288 25.8738 27.5C24.7136 27.4997 23.6012 27.0386 22.781 26.2182C21.9608 25.3977 21.5 24.2851 21.5 23.125V19.375C21.5 19.2092 21.5658 19.0503 21.6831 18.9331C21.8003 18.8158 21.9592 18.75 22.125 18.75H23.375V15.625C23.375 15.4592 23.4408 15.3003 23.5581 15.1831C23.6753 15.0658 23.8342 15 24 15ZM22.75 20V23.125C22.75 23.9538 23.0792 24.7487 23.6653 25.3347C24.2513 25.9208 25.0462 26.25 25.875 26.25H27.125C27.9538 26.25 28.7487 25.9208 29.3347 25.3347C29.9208 24.7487 30.25 23.9538 30.25 23.125V20H22.75Z'
			fill='#274169'
		/>
	</svg>
);

export const ArrowProfitSVG = ({ width, height }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='8'
		height='14'
		viewBox='0 0 8 14'
		fill='none'
	>
		<path
			d='M4.35355 0.646446C4.15829 0.451184 3.84171 0.451184 3.64645 0.646446L0.464466 3.82843C0.269203 4.02369 0.269203 4.34027 0.464466 4.53553C0.659728 4.7308 0.97631 4.7308 1.17157 4.53553L4 1.70711L6.82843 4.53553C7.02369 4.7308 7.34027 4.7308 7.53553 4.53553C7.7308 4.34027 7.7308 4.02369 7.53553 3.82843L4.35355 0.646446ZM4.5 14L4.5 1L3.5 1L3.5 14L4.5 14Z'
			fill='#02835B'
		/>
	</svg>
);

export const ArrowLossSVG = ({ width, height }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='8'
		height='14'
		viewBox='0 0 8 14'
		fill='none'
	>
		<path
			d='M3.64645 13.3536C3.84171 13.5488 4.15829 13.5488 4.35355 13.3536L7.53553 10.1716C7.7308 9.97631 7.7308 9.65973 7.53553 9.46447C7.34027 9.2692 7.02369 9.2692 6.82843 9.46447L4 12.2929L1.17157 9.46447C0.976311 9.2692 0.659728 9.2692 0.464466 9.46447C0.269204 9.65973 0.269204 9.97631 0.464466 10.1716L3.64645 13.3536ZM3.5 5.96244e-09L3.5 13L4.5 13L4.5 -5.96244e-09L3.5 5.96244e-09Z'
			fill='#83022B'
		/>
	</svg>
);

export const LeftNavSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
	>
		<circle
			cx='16'
			cy='16'
			r='16'
			transform='rotate(180 16 16)'
			fill='#f5f5f5'
		/>
		<path
			d='M17.3431 21.6569L11.6863 16L17.3431 10.3431'
			stroke='#5F8080'
		/>
	</svg>
);
export const RightNavSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
	>
		<circle
			cx='16'
			cy='16'
			r='16'
			fill='#f5f5f5'
		/>
		<path
			d='M14.6569 10.3431L20.3137 16L14.6569 21.6569'
			stroke='#5F8080'
		/>
	</svg>
);
export const ShareSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='20'
		height='20'
		viewBox='0 0 90 90'
		fill='none'
	>
		<path
			d='M64.6512 10C58.8169 10 54.0698 14.7471 54.0698 20.5814C54.0698 22.04 54.373 23.4365 54.9091 24.702L33.0087 37.4709C31.0968 35.5843 28.473 34.4186 25.5814 34.4186C19.7471 34.4186 15 39.1657 15 45C15 50.8343 19.7471 55.5814 25.5814 55.5814C28.473 55.5814 31.0968 54.4156 33.0087 52.5291L54.9091 65.298C54.373 66.5634 54.0698 67.96 54.0698 69.4186C54.0698 75.2529 58.8169 80 64.6512 80C70.4854 80 75.2326 75.2529 75.2326 69.4186C75.2326 63.5843 70.4854 58.8372 64.6512 58.8372C60.8655 58.8372 57.5426 60.8506 55.6723 63.8481L34.077 51.2827C35.3857 49.5217 36.1628 47.3574 36.1628 45C36.1628 42.6425 35.3857 40.4783 34.077 38.7173L55.6723 26.1519C57.5426 29.1494 60.8655 31.1628 64.6512 31.1628C70.4854 31.1628 75.2326 26.4157 75.2326 20.5814C75.2326 14.7471 70.4854 10 64.6512 10ZM64.6512 11.6279C69.6057 11.6279 73.6046 15.6269 73.6046 20.5814C73.6046 25.5359 69.6057 29.5349 64.6512 29.5349C59.6966 29.5349 55.6977 25.5359 55.6977 20.5814C55.6977 15.6269 59.6966 11.6279 64.6512 11.6279ZM25.5814 36.0465C30.5359 36.0465 34.5349 40.0455 34.5349 45C34.5349 49.9545 30.5359 53.9535 25.5814 53.9535C20.6269 53.9535 16.6279 49.9545 16.6279 45C16.6279 40.0455 20.6269 36.0465 25.5814 36.0465ZM64.6512 60.4651C69.6057 60.4651 73.6046 64.4641 73.6046 69.4186C73.6046 74.3731 69.6057 78.3721 64.6512 78.3721C59.6966 78.3721 55.6977 74.3731 55.6977 69.4186C55.6977 64.4641 59.6966 60.4651 64.6512 60.4651Z'
			fill='black'
		/>
	</svg>
);
export const CopySVG = ({ width, height, color, ...rest }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '20'}
		height={height || '20'}
		viewBox='0 0 90 90'
		fill='none'
		{...rest}
	>
		<path
			d='M27 22H17V78H63V68H73V12H27V22ZM61 76H19V24H61V76ZM71 14V66H63V22H29V14H71Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);
export const PadlockSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='20'
		height='20'
		viewBox='0 0 90 90'
		fill='none'
	>
		<path
			d='M45.1333 12C34.5831 12 26.0667 20.5164 26.0667 31.0667V41.3333H21.6667C19.648 41.3333 18 42.9814 18 45V74.3333C18 76.352 19.648 78 21.6667 78H68.6C70.6186 78 72.2667 76.352 72.2667 74.3333V45C72.2667 42.9814 70.6186 41.3333 68.6 41.3333H64.2V31.0667C64.2 20.5164 55.6836 12 45.1333 12ZM45.1333 13.4667C54.8964 13.4667 62.7333 21.3036 62.7333 31.0667V41.3333H27.5333V31.0667C27.5333 21.3036 35.3702 13.4667 45.1333 13.4667ZM21.6667 42.8H68.6C69.8315 42.8 70.8 43.7685 70.8 45V74.3333C70.8 75.5648 69.8315 76.5333 68.6 76.5333H21.6667C20.4352 76.5333 19.4667 75.5648 19.4667 74.3333V45C19.4667 43.7685 20.4352 42.8 21.6667 42.8Z'
			fill='black'
		/>
	</svg>
);

export const TrophySVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='20'
		height='20'
		viewBox='0 0 90 90'
		fill='none'
	>
		<path
			d='M66.8431 18.5784C66.951 16.7451 67.0588 14.9118 67.0588 13.0784V12H22.1961V13.0784C22.1961 14.9118 22.3039 16.7451 22.4118 18.5784H14V19.6569C14 31.6275 20.902 42.0882 31.0392 47.1569C32.549 49.4216 34.2745 51.2549 36.1078 52.6569V57.402H40.6373V63.9804H36V68.1863H32.7647V78H56.4902V68.1863H53.2549V63.9804H48.7255V57.402H53.2549V52.6569C55.0882 51.2549 56.8137 49.3137 58.3235 47.049C68.3529 41.9804 75.3628 31.6275 75.3628 19.6569V18.5784H66.8431ZM16.1569 20.7353H22.6275C23.3824 29.3627 25.5392 37.2353 28.7745 43.2745C21.3333 38.4216 16.4804 30.1176 16.1569 20.7353ZM51.5294 51.2549L51.098 51.5784V55.2451H46.5686V66.1373H51.098V70.3431H54.3333V75.8431H34.9216V70.3431H38.1569V66.1373H42.6863V55.2451H38.1569V51.5784L37.7255 51.2549C29.8529 45.5392 24.4608 30.6569 24.2451 14.1569H64.7941C64.6863 30.7647 59.402 45.5392 51.5294 51.2549ZM60.5882 43.2745C63.7157 37.2353 65.8726 29.3627 66.7353 20.7353H73.2059C72.7745 30.1176 67.9216 38.3137 60.5882 43.2745Z'
			fill='black'
		/>
	</svg>
);

export const PulseSVG = ({ noText }: { noText?: boolean }) => (
	<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
		<svg
			width='24'
			height='24'
			viewBox='0 0 24 24'
			xmlns='http://www.w3.org/2000/svg'
			fill={PRIMARY_COLOR}
		>
			<style>
				{
					'.spinner_ZCsl{animation:spinner_qV4G 1.2s cubic-bezier(0.52,.6,.25,.99) infinite}.spinner_gaIW{animation-delay:.6s}@keyframes spinner_qV4G{0%{r:0;opacity:1}100%{r:11px;opacity:0}}'
				}
			</style>
			<circle
				className='spinner_ZCsl'
				cx='12'
				cy='12'
				r='0'
			/>
			<circle
				className='spinner_ZCsl spinner_gaIW'
				cx='12'
				cy='12'
				r='0'
			/>
		</svg>
		{!noText ? (
			<span style={{ fontSize: '14px', color: PRIMARY_COLOR, fontFamily: 'sans-serif' }}>Loading... please wait</span>
		) : null}
	</div>
);

export const VerifiedSVG = ({ color, width, height }: { color?: string; width?: string; height?: string }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '20'}
		height={height || '20'}
		viewBox='0 0 90 90'
		fill='none'
	>
		<path
			d='M74.2736 25.6526C58.9296 25.6526 52.167 19.4351 46.0463 12.5095C46.0249 12.486 45.9994 12.4677 45.978 12.4453C45.9556 12.4229 45.9373 12.3974 45.9138 12.376C45.8985 12.3627 45.8812 12.3546 45.8649 12.3413C45.8231 12.3067 45.7793 12.2771 45.7345 12.2476C45.6937 12.2211 45.654 12.1956 45.6122 12.1732C45.5654 12.1488 45.5185 12.1294 45.4706 12.11C45.4258 12.0917 45.3819 12.0744 45.3361 12.0611C45.2872 12.0459 45.2373 12.0367 45.1873 12.0265C45.1415 12.0183 45.0966 12.0092 45.0508 12.0051C44.9988 12 44.9458 12 44.8939 12C44.849 12 44.8052 12 44.7604 12.0041C44.7074 12.0092 44.6554 12.0183 44.6025 12.0295C44.5587 12.0377 44.5159 12.0469 44.472 12.0591C44.4221 12.0734 44.3732 12.0927 44.3243 12.1131C44.2805 12.1314 44.2367 12.1498 44.1939 12.1722C44.1501 12.1946 44.1093 12.2211 44.0665 12.2496C44.0227 12.2782 43.9789 12.3087 43.9381 12.3424C43.9228 12.3556 43.9045 12.3638 43.8902 12.377C43.8668 12.3984 43.8485 12.4239 43.826 12.4463C43.8036 12.4687 43.7782 12.487 43.7568 12.5105C37.635 19.4351 30.8694 25.6526 15.5284 25.6526C14.6837 25.6526 14 26.3363 14 27.181C14 55.0955 29.6548 71.6735 44.3049 77.8788C44.3396 77.894 44.3763 77.9001 44.4119 77.9114C44.4466 77.9236 44.4792 77.9338 44.5148 77.9429C44.6422 77.9766 44.7716 78 44.9 78C45.0284 78 45.1578 77.9776 45.2851 77.9429C45.3208 77.9338 45.3534 77.9226 45.3891 77.9114C45.4247 77.8991 45.4604 77.893 45.495 77.8788C60.1452 71.6735 75.8 55.0966 75.8 27.181C75.802 26.3363 75.1173 25.6526 74.2736 25.6526ZM56.4679 37.2786L44.3681 54.473C44.3182 54.5433 44.2581 54.6003 44.199 54.6604C44.1857 54.6737 44.1806 54.692 44.1674 54.7053C44.1613 54.7114 44.1521 54.7134 44.146 54.7185C44.0176 54.8367 43.8709 54.9254 43.716 54.9926C43.6803 55.0079 43.6467 55.0181 43.61 55.0303C43.4521 55.0853 43.2891 55.122 43.122 55.122C43.1209 55.122 43.1199 55.123 43.1189 55.123C43.1179 55.123 43.1179 55.123 43.1169 55.123C43.1158 55.123 43.1148 55.122 43.1128 55.122C42.9793 55.122 42.8458 55.0986 42.7164 55.0619C42.6838 55.0527 42.6522 55.0425 42.6206 55.0324C42.4892 54.9865 42.3608 54.9284 42.2436 54.8459C42.2426 54.8449 42.2406 54.8449 42.2396 54.8439C42.1519 54.7817 42.0735 54.7124 42.0032 54.638L33.4748 45.6001C32.895 44.9857 32.9235 44.0188 33.5379 43.44C34.1523 42.8613 35.1203 42.8888 35.6981 43.5032L42.9467 51.1849L53.9695 35.5209C54.4555 34.8301 55.4092 34.665 56.099 35.151C56.7878 35.635 56.9529 36.5877 56.4679 37.2786Z'
			fill={color || PRIMARY_COLOR}
		/>
	</svg>
);

export const BellBoldSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='20'
		height='20'
		viewBox='0 0 90 90'
		fill='none'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M72.2625 55.102H70.9059C74.6438 55.102 77.6531 58.1163 77.6531 61.8345V63.1862C77.6531 64.6832 76.4461 65.8775 74.9573 65.8775H15.6957C14.2054 65.8775 13 64.6726 13 63.1862V61.8345C13 58.1179 16.0208 55.102 19.7471 55.102H18.3906C19.8717 55.102 21.0816 53.8949 21.0816 52.4058V36.2439C21.0816 22.8486 31.9364 12 45.3265 12C58.7196 12 69.5714 22.8544 69.5714 36.2439V52.4058C69.5714 53.9043 70.7763 55.102 72.2625 55.102ZM35.898 68.5714H54.7551C54.7551 73.7787 50.5338 78 45.3265 78C40.1193 78 35.898 73.7787 35.898 68.5714Z'
			fill={PRIMARY_COLOR}
		/>
	</svg>
);

export const BellOutlineSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='20'
		height='20'
		viewBox='0 0 90 90'
		fill='none'
	>
		<path
			d='M34.5769 67.8462H37.1154C37.1154 72.052 40.5249 75.4615 44.7308 75.4615C48.9366 75.4615 52.3462 72.052 52.3462 67.8462H54.8846C54.8846 73.454 50.3386 78 44.7308 78C39.123 78 34.5769 73.454 34.5769 67.8462ZM76.4615 60.2287V61.5024C76.4615 63.6118 74.7582 65.3077 72.6521 65.3077H16.8095C14.705 65.3077 13 63.6049 13 61.5024V60.2287C13 56.0283 16.4096 52.6217 20.6154 52.6154V36.1144C20.6154 22.7928 31.4104 12 44.7308 12C58.0512 12 68.8462 22.7955 68.8462 36.1144V52.6154C73.0599 52.6217 76.4615 56.0238 76.4615 60.2287ZM68.8344 55.1538C67.4402 55.1538 66.3077 54.0128 66.3077 52.6245V36.1144C66.3077 24.1974 56.6492 14.5385 44.7308 14.5385C32.8122 14.5385 23.1538 24.1949 23.1538 36.1144V52.6245C23.1538 54.0191 22.0156 55.1538 20.6271 55.1538C17.8167 55.1538 15.5385 57.4275 15.5385 60.2287V61.5024C15.5385 62.2022 16.1062 62.7692 16.8095 62.7692H72.6521C73.3587 62.7692 73.9231 62.2074 73.9231 61.5024V60.2287C73.9231 57.4225 71.6522 55.1538 68.8344 55.1538Z'
			fill='black'
		/>
	</svg>
);

export const RefreshSVG = () => (
	<svg
		width='18.9'
		height='15'
		viewBox='0 0 56 43'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M41.2419 36.6719C37.5695 39.9007 32.8536 41.6797 27.9641 41.6797C16.8601 41.6797 7.82608 32.6272 7.82608 21.5003C7.82608 18.8585 8.35188 16.3111 9.33602 13.897L12.3184 21.1937C12.4227 21.449 12.6694 21.6036 12.9285 21.6036C13.0122 21.6036 13.0971 21.5879 13.1783 21.5548C13.5155 21.4171 13.676 21.0316 13.5386 20.6937L9.72443 11.3615L0.409433 15.1823C0.0722275 15.3199 -0.0882575 15.7054 0.0491226 16.0433C0.186503 16.3812 0.576787 16.542 0.908373 16.4043L8.09397 13.4558C7.06113 16.0114 6.50848 18.707 6.50848 21.5003C6.50848 33.3555 16.1332 43 27.9641 43C33.174 43 38.1971 41.1053 42.1118 37.665C42.3847 37.4241 42.4115 37.0073 42.1724 36.7333C41.9326 36.4592 41.5173 36.4316 41.2419 36.6719ZM55.8691 21.8169C55.6518 21.5228 55.2391 21.464 54.9481 21.683L48.8934 26.2084C49.2362 24.6684 49.4192 23.0909 49.4192 21.4997C49.4192 9.64448 39.7944 0 27.9635 0C23.9476 0 20.0317 1.11882 16.6371 3.23569C16.3287 3.42904 16.2344 3.83639 16.4261 4.14551C16.619 4.45337 17.0256 4.54911 17.334 4.35701C20.5175 2.37029 24.1943 1.3203 27.9635 1.3203C39.0676 1.3203 48.1016 10.3728 48.1016 21.4997C48.1016 23.1391 47.8942 24.7642 47.5058 26.3435L42.7069 19.8991C42.4883 19.605 42.0756 19.5455 41.7858 19.7651C41.4936 19.9829 41.4349 20.3965 41.6522 20.6881L47.6701 28.7714L55.7355 22.7399C56.0271 22.5221 56.0865 22.1085 55.8691 21.8169Z'
			fill='black'
		/>
	</svg>
);
export const RefreshLSVG = () => (
	<svg
		width='16'
		height='16'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M20.0093 9.99989C20.0093 10.5019 19.6019 10.9094 19.0998 10.9094C18.5978 10.9094 18.1903 10.5019 18.1903 9.99989C18.1903 7.81341 17.3385 5.75791 15.7928 4.21174C12.6009 1.02025 7.408 1.02025 4.21651 4.21174L3.83952 4.58873H6.14559C6.64764 4.58873 7.05511 4.99619 7.05511 5.49824C7.05511 6.0003 6.64764 6.40776 6.14559 6.40776H1.64395C1.1419 6.40776 0.734433 6.0003 0.734433 5.49824V0.996601C0.734433 0.494548 1.1419 0.0870858 1.64395 0.0870858C2.146 0.0870858 2.55346 0.494548 2.55346 0.996601V3.30267L2.93046 2.92568C6.83091 -0.975227 13.1784 -0.975227 17.0789 2.92568C18.9684 4.8152 20.0093 7.32773 20.0093 9.99989ZM18.3654 13.592H13.8637C13.3617 13.592 12.9542 13.9995 12.9542 14.5015C12.9542 15.0036 13.3617 15.411 13.8637 15.411H16.1698L15.7928 15.788C12.6009 18.9795 7.408 18.9795 4.21651 15.788C2.67079 14.2419 1.81903 12.1864 1.81903 9.99989C1.81903 9.49783 1.41157 9.09037 0.909515 9.09037C0.407463 9.09037 0 9.49783 0 9.99989C0 12.672 1.04094 15.1846 2.93046 17.0745C4.88046 19.0245 7.44256 20 10.0047 20C12.5668 20 15.1289 19.0245 17.0789 17.0741L17.4559 16.6971V19.0032C17.4559 19.5052 17.8633 19.9127 18.3654 19.9127C18.8674 19.9127 19.2749 19.5052 19.2749 19.0032V14.5015C19.2749 13.9995 18.8674 13.592 18.3654 13.592Z'
			fill='#000'
		/>
	</svg>
);

export const RefreshCWSVG = ({ width, height, color }: ISVG) => (
	<svg
		width={width || '18'}
		height={height || '18'}
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8M21 3v5h-5M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16M8 16H3v5'
			stroke={color || 'currentColor'}
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const StatsSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='20'
		height='18'
		viewBox='0 0 100 90'
		fill='none'
	>
		<path
			d='M17.4776 61.8806C16.6976 61.8806 16.0291 62.512 16.0291 63.3291V76.5514C16.0291 77.3314 16.6605 77.9999 17.4776 77.9999C18.2575 77.9999 18.9261 77.3685 18.9261 76.5514V63.3291C18.9261 62.512 18.2947 61.8806 17.4776 61.8806Z'
			fill='black'
		/>
		<path
			d='M28.7686 51.8525C27.9886 51.8525 27.3201 52.4839 27.3201 53.301V76.5515C27.3201 77.3314 27.9515 78 28.7686 78C29.5857 78 30.2171 77.3686 30.2171 76.5515V53.301C30.1799 52.4839 29.5485 51.8525 28.7686 51.8525Z'
			fill='black'
		/>
		<path
			d='M40.0222 42.3816C39.2423 42.3816 38.5737 43.013 38.5737 43.8301V76.5144C38.5737 77.2944 39.2051 77.9629 40.0222 77.9629C40.8022 77.9629 41.4707 77.3315 41.4707 76.5144V43.8301C41.4336 43.0501 40.8022 42.3816 40.0222 42.3816Z'
			fill='black'
		/>
		<path
			d='M51.239 51.8525C50.4591 51.8525 49.7905 52.4839 49.7905 53.301V76.5515C49.7905 77.3314 50.4219 78 51.239 78C52.019 78 52.6875 77.3686 52.6875 76.5515V53.301C52.6875 52.4839 52.0561 51.8525 51.239 51.8525Z'
			fill='black'
		/>
		<path
			d='M62.5298 55.9009C61.7498 55.9009 61.0813 56.5323 61.0813 57.3494V76.5514C61.0813 77.3314 61.7127 77.9999 62.5298 77.9999C63.3098 77.9999 63.9783 77.3685 63.9783 76.5514V57.3494C63.9412 56.5323 63.3098 55.9009 62.5298 55.9009Z'
			fill='black'
		/>
		<path
			d='M73.7837 43.7559C73.0037 43.7559 72.3352 44.3873 72.3352 45.2044V76.5516C72.3352 77.3315 72.9666 78.0001 73.7837 78.0001C74.5637 78.0001 75.2322 77.3687 75.2322 76.5516V45.2044C75.1951 44.3873 74.5637 43.7559 73.7837 43.7559Z'
			fill='black'
		/>
		<path
			d='M85.0376 34.8418C84.2577 34.8418 83.5891 35.4732 83.5891 36.2903V76.5514C83.5891 77.3314 84.2205 77.9999 85.0376 77.9999C85.8176 77.9999 86.4861 77.3685 86.4861 76.5514V36.2532C86.449 35.4732 85.8176 34.8418 85.0376 34.8418Z'
			fill='black'
		/>
		<path
			d='M92.6886 12H79.8748C79.0949 12 78.4263 12.6314 78.4263 13.4485C78.4263 14.2285 79.0577 14.897 79.8748 14.897H90.3115L57.553 40.933L40.8394 27.0051C40.3194 26.5594 39.5395 26.5594 38.9823 27.0051L5.51808 54.9353C4.92382 55.4553 4.81239 56.3466 5.33237 56.9409C5.6295 57.2752 6.03805 57.4609 6.44661 57.4609C6.78088 57.4609 7.11515 57.3495 7.37514 57.1266L39.9851 29.9392L56.6616 43.8672C57.1815 44.3129 57.9615 44.3129 58.4815 43.9043L91.2772 17.8312V26.2622C91.2772 27.0422 91.9086 27.7107 92.7257 27.7107C93.5057 27.7107 94.1742 27.0793 94.1742 26.2622V13.4485C94.1371 12.6314 93.5057 12 92.6886 12Z'
			fill='black'
		/>
	</svg>
);

export const TwitterSVG = () => (
	<svg
		width='20'
		height='20.45'
		viewBox='0 0 1200 1227'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<g clipPath='url(#clip0_4806_17)'>
			<path
				d='M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z'
				fill='black'
			/>
		</g>
		<defs>
			<clipPath id='clip0_4806_17'>
				<rect
					width='1200'
					height='1227'
					fill='white'
				/>
			</clipPath>
		</defs>
	</svg>
);

export const ThumbsUpOutline = () => (
	<svg
		width='19.18'
		height='17'
		viewBox='0 0 57 50'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M27.0576 48.5462C26.9309 48.5462 23.948 48.5236 21.639 46.5607C21.439 46.3895 21.2717 46.2767 21.1143 46.2052L19.4197 45.4353V25.6363L21.8378 23.5687L28.2989 11.5963C28.4776 11.3041 28.6099 10.9875 28.6901 10.6565C28.7697 10.3286 28.7973 9.98696 28.771 9.64278L28.1572 1.57735L28.5929 1.21436C29.5308 0.431327 30.722 0 31.9445 0C36.1687 0 39.4463 5.64172 39.4463 10.4954C39.4463 11.1236 39.3993 11.7574 39.3034 12.3774L38.5467 17.2838H50.3084C51.8074 17.2838 53.2807 17.9025 54.3528 18.9827C55.3847 20.0216 55.9483 21.3726 55.9389 22.7832C55.9295 24.0113 55.5182 25.1705 54.7772 26.109C55.8141 27.1247 56.4235 28.5277 56.4235 30.0117C56.4235 31.9576 55.4141 33.7011 53.8149 34.6735C54.0976 35.3399 54.2443 36.0552 54.2443 36.7938C54.2443 39.0237 52.9133 40.966 50.9435 41.8086C51.0445 42.2248 51.0952 42.6543 51.0952 43.0913C51.0952 45.9845 48.8314 48.3775 45.94 48.5374L45.8798 48.5399L27.0576 48.5462ZM21.6227 44.016L22.0259 44.1997C22.3757 44.3576 22.7067 44.5752 23.0678 44.883C24.7323 46.3005 27.0043 46.3431 27.0601 46.3444L45.846 46.3362C47.5569 46.2265 48.8928 44.8072 48.8928 43.0906C48.8928 42.5671 48.77 42.0631 48.5273 41.596L47.8302 40.2519L49.3235 40.003C50.8978 39.7391 52.0419 38.3899 52.0419 36.7931C52.0419 36.0847 51.8143 35.4083 51.383 34.8365L50.442 33.5883L51.936 33.1237C53.302 32.6968 54.2211 31.4454 54.2211 30.0117C54.2211 28.8418 53.586 27.7535 52.5641 27.1754L51.109 26.3498L52.4425 25.3398C53.2581 24.7223 53.7302 23.7844 53.7365 22.7681C53.7434 21.9487 53.4067 21.1557 52.7898 20.535C52.1278 19.8686 51.225 19.4868 50.3084 19.4868H35.9781L37.1273 12.0427C37.2044 11.5348 37.2452 11.0139 37.2452 10.4954C37.2452 6.76204 34.7989 2.20177 31.9445 2.20177C31.416 2.20177 30.8988 2.34158 30.443 2.6005L30.9652 9.47664C31.0097 10.0528 30.964 10.6245 30.8292 11.1769C30.6981 11.7198 30.4837 12.2395 30.1916 12.7197L23.58 24.9768L21.6227 26.6507V44.016ZM14.7911 50H2.26258C1.01374 50 0 48.9844 0 47.7374V24.1047C0 22.8578 1.01374 21.8422 2.26258 21.8422H14.7905C16.0374 21.8422 17.0531 22.8578 17.0531 24.1047V47.7368C17.0537 48.9844 16.0381 50 14.7911 50ZM2.26258 24.0452C2.23061 24.0452 2.20052 24.0753 2.20052 24.1054V47.7374C2.20052 47.7675 2.23061 47.7976 2.26258 47.7976H14.7905C14.8206 47.7976 14.8507 47.7675 14.8507 47.7374V24.1047C14.8507 24.0747 14.8206 24.0446 14.7905 24.0446L2.26258 24.0452ZM9.97693 45.8848C11.2834 45.8848 12.343 44.826 12.343 43.5188C12.343 42.2123 11.2834 41.1534 9.97693 41.1534C8.67041 41.1534 7.6109 42.2123 7.6109 43.5188C7.6109 44.8253 8.67041 45.8848 9.97693 45.8848Z'
			fill='black'
		/>
	</svg>
);

export const ThumbsDownOutline = () => (
	<svg
		width='19'
		height='17'
		viewBox='0 0 19 17'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M9.88866 0.494307C9.9313 0.494307 10.9358 0.501981 11.7133 1.16937C11.7806 1.22756 11.837 1.26593 11.89 1.29023L12.4606 1.55198V8.28365L11.6464 8.98663L9.47066 13.0573C9.41049 13.1566 9.36594 13.2642 9.33892 13.3768C9.31211 13.4883 9.30282 13.6044 9.31169 13.7215L9.51837 16.4637L9.37164 16.5871C9.05582 16.8533 8.65471 17 8.24304 17C6.82058 17 5.71689 15.0818 5.71689 13.4316C5.71689 13.218 5.73272 13.0025 5.76502 12.7917L6.01983 11.1235H2.05918C1.55441 11.1235 1.0583 10.9131 0.6973 10.5459C0.349811 10.1927 0.160023 9.73332 0.163189 9.25372C0.166356 8.83615 0.304844 8.44202 0.554377 8.12293C0.2052 7.77762 -2.08616e-07 7.30057 -2.08616e-07 6.79604C-2.08616e-07 6.1344 0.339889 5.54162 0.878434 5.21101C0.783223 4.98443 0.733822 4.74122 0.733822 4.49012C0.733822 3.73193 1.18201 3.07157 1.84532 2.78509C1.81133 2.64355 1.79423 2.49754 1.79423 2.34897C1.79423 1.36526 2.55656 0.551646 3.5302 0.497291L3.55047 0.496439L9.88866 0.494307ZM11.7188 2.03457L11.583 1.97211C11.4652 1.9184 11.3538 1.84443 11.2322 1.73978C10.6717 1.25783 9.9066 1.24334 9.88781 1.24291L3.56187 1.24568C2.98574 1.28298 2.53587 1.76557 2.53587 2.34919C2.53587 2.52717 2.57724 2.69855 2.65894 2.85735L2.8937 3.31435L2.39083 3.39898C1.86073 3.48871 1.47546 3.94743 1.47546 4.49033C1.47546 4.7312 1.55209 4.96119 1.69733 5.15559L2.01421 5.57998L1.51113 5.73793C1.05112 5.88309 0.741633 6.30855 0.741633 6.79604C0.741633 7.19378 0.955488 7.56382 1.2996 7.76035L1.78959 8.04108L1.34056 8.38447C1.0659 8.59443 0.906934 8.91331 0.904823 9.25883C0.9025 9.53743 1.01587 9.80707 1.2236 10.0181C1.44653 10.2447 1.75053 10.3745 2.05918 10.3745H6.88476L6.49779 12.9055C6.47182 13.0782 6.4581 13.2553 6.4581 13.4316C6.4581 14.7009 7.28186 16.2514 8.24304 16.2514C8.42101 16.2514 8.59518 16.2039 8.74866 16.1158L8.5728 13.7779C8.55781 13.5821 8.57322 13.3877 8.61861 13.1999C8.66273 13.0153 8.73493 12.8386 8.83331 12.6753L11.0597 8.50789L11.7188 7.93876V2.03457ZM14.0193 -3.54692e-07H18.2381C18.6586 -3.54692e-07 19 0.345312 19 0.769278V8.80439C19 9.22835 18.6586 9.57366 18.2381 9.57366H14.0195C13.5996 9.57366 13.2576 9.22835 13.2576 8.80439V0.769491C13.2574 0.345312 13.5994 -3.54692e-07 14.0193 -3.54692e-07ZM18.2381 8.82464C18.2489 8.82464 18.259 8.8144 18.259 8.80417V0.769278C18.259 0.759046 18.2489 0.748815 18.2381 0.748815H14.0195C14.0093 0.748815 13.9992 0.759046 13.9992 0.769278V8.80439C13.9992 8.81462 14.0093 8.82485 14.0195 8.82485L18.2381 8.82464ZM15.6404 1.39915C15.2004 1.39915 14.8436 1.75917 14.8436 2.2036C14.8436 2.64782 15.2004 3.00784 15.6404 3.00784C16.0803 3.00784 16.4371 2.64782 16.4371 2.2036C16.4371 1.75938 16.0803 1.39915 15.6404 1.39915Z'
			fill='black'
		/>
	</svg>
);

export const ThumbsUpSelected = () => (
	<svg
		width='25'
		height='25'
		viewBox='0 0 17 17'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<circle
			cx='8.5'
			cy='8.5'
			r='8.5'
			fill={PRIMARY_COLOR}
		/>
		<path
			d='M8.10061 12.7383C8.07674 12.7383 7.51443 12.7342 7.07916 12.3809C7.04146 12.3501 7.00991 12.3298 6.98025 12.3169L6.6608 12.1784V8.61454L7.11663 8.24237L8.33461 6.08733C8.36829 6.03474 8.39323 5.97776 8.40835 5.91817C8.42336 5.85915 8.42856 5.79765 8.4236 5.7357L8.3079 4.28392L8.39004 4.21858C8.56684 4.07764 8.79138 4 9.02184 4C9.81815 4 10.436 5.01551 10.436 5.88917C10.436 6.00224 10.4271 6.11633 10.4091 6.22794L10.2664 7.11108H12.4836C12.7662 7.11108 13.0439 7.22246 13.246 7.41689C13.4405 7.60388 13.5468 7.84707 13.545 8.10097C13.5432 8.32204 13.4657 8.53069 13.326 8.69963C13.5215 8.88244 13.6364 9.13499 13.6364 9.4021C13.6364 9.75238 13.4461 10.0662 13.1446 10.2412C13.1979 10.3612 13.2256 10.4899 13.2256 10.6229C13.2256 11.0243 12.9747 11.3739 12.6033 11.5255C12.6224 11.6005 12.6319 11.6778 12.6319 11.7564C12.6319 12.2772 12.2052 12.708 11.6601 12.7367L11.6488 12.7372L8.10061 12.7383ZM7.07609 11.9229L7.15208 11.9559C7.21803 11.9844 7.28043 12.0235 7.3485 12.0789C7.66227 12.3341 8.09056 12.3418 8.10108 12.342L11.6424 12.3405C11.9649 12.3208 12.2168 12.0653 12.2168 11.7563C12.2168 11.6621 12.1936 11.5714 12.1479 11.4873L12.0164 11.2453L12.298 11.2005C12.5947 11.153 12.8104 10.9102 12.8104 10.6228C12.8104 10.4952 12.7675 10.3735 12.6862 10.2706L12.5088 10.0459L12.7904 9.96227C13.0479 9.88542 13.2212 9.66018 13.2212 9.4021C13.2212 9.19153 13.1015 8.99562 12.9088 8.89158L12.6345 8.74296L12.8859 8.56116C13.0397 8.45001 13.1287 8.28119 13.1298 8.09826C13.1311 7.95077 13.0677 7.80802 12.9514 7.6963C12.8266 7.57635 12.6564 7.50762 12.4836 7.50762H9.78222L9.99885 6.16768C10.0134 6.07627 10.0211 5.9825 10.0211 5.88917C10.0211 5.21717 9.55992 4.39632 9.02184 4.39632C8.92221 4.39632 8.82471 4.42148 8.73879 4.46809L8.83724 5.7058C8.84563 5.8095 8.837 5.91242 8.81159 6.01184C8.78689 6.10956 8.74647 6.20311 8.6914 6.28955L7.44505 8.49582L7.07609 8.79713V11.9229ZM5.78826 13H3.42652C3.1911 13 3 12.8172 3 12.5927V8.33885C3 8.1144 3.1911 7.93159 3.42652 7.93159H5.78815C6.02321 7.93159 6.21466 8.1144 6.21466 8.33885V12.5926C6.21478 12.8172 6.02333 13 5.78826 13ZM3.42652 8.32813C3.42049 8.32813 3.41482 8.33355 3.41482 8.33897V12.5927C3.41482 12.5982 3.42049 12.6036 3.42652 12.6036H5.78815C5.79382 12.6036 5.79949 12.5982 5.79949 12.5927V8.33885C5.79949 8.33344 5.79382 8.32802 5.78815 8.32802L3.42652 8.32813ZM4.88075 12.2593C5.12704 12.2593 5.32676 12.0687 5.32676 11.8334C5.32676 11.5982 5.12704 11.4076 4.88075 11.4076C4.63445 11.4076 4.43473 11.5982 4.43473 11.8334C4.43473 12.0686 4.63445 12.2593 4.88075 12.2593Z'
			fill='white'
		/>
	</svg>
);

export const ThumbsDownSelected = () => (
	<svg
		width='23'
		height='22'
		viewBox='0 0 23 22'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<circle
			cx='11.75'
			cy='11'
			r='11'
			transform='rotate(180 11.75 11)'
			fill='#E92B2B'
		/>
		<path
			d='M12.2664 5.51509C12.2973 5.51509 13.025 5.52035 13.5883 5.97759C13.6371 6.01746 13.6779 6.04374 13.7163 6.06039L14.1297 6.23973V10.8517L13.5398 11.3334L11.9636 14.1222C11.92 14.1903 11.8877 14.264 11.8681 14.3411C11.8487 14.4175 11.842 14.4971 11.8484 14.5773L11.9981 16.4561L11.8918 16.5406C11.663 16.723 11.3725 16.8235 11.0742 16.8235C10.0437 16.8235 9.24413 15.5093 9.24413 14.3787C9.24413 14.2323 9.2556 14.0847 9.279 13.9403L9.4636 12.7974H6.59427C6.22859 12.7974 5.86917 12.6532 5.60764 12.4016C5.3559 12.1596 5.21841 11.8449 5.2207 11.5163C5.223 11.2303 5.32333 10.9602 5.5041 10.7416C5.25114 10.505 5.10248 10.1782 5.10248 9.83254C5.10248 9.37924 5.34872 8.97311 5.73887 8.7466C5.66989 8.59136 5.6341 8.42474 5.6341 8.2527C5.6341 7.73325 5.9588 7.28083 6.43934 7.08455C6.41471 6.98758 6.40233 6.88755 6.40233 6.78576C6.40233 6.1118 6.9546 5.55437 7.65996 5.51713L7.67464 5.51655L12.2664 5.51509ZM13.5922 6.57035L13.4939 6.52757C13.4086 6.49076 13.3278 6.44009 13.2397 6.36838C12.8337 6.03819 12.2794 6.02826 12.2658 6.02797L7.6829 6.02987C7.26553 6.05543 6.93961 6.38605 6.93961 6.7859C6.93961 6.90785 6.96959 7.02526 7.02877 7.13406L7.19884 7.44716L6.83454 7.50514C6.4505 7.56662 6.17139 7.88089 6.17139 8.25285C6.17139 8.41787 6.2269 8.57545 6.33213 8.70863L6.56169 8.99939L6.19723 9.10761C5.86397 9.20706 5.63976 9.49855 5.63976 9.83254C5.63976 10.105 5.79469 10.3586 6.04399 10.4932L6.39896 10.6855L6.07366 10.9208C5.87468 11.0647 5.75952 11.2831 5.75799 11.5199C5.7563 11.7107 5.83843 11.8955 5.98893 12.04C6.15043 12.1953 6.37067 12.2842 6.59427 12.2842H10.0902L9.80986 14.0183C9.79104 14.1365 9.7811 14.2579 9.7811 14.3787C9.7811 15.2483 10.3779 16.3106 11.0742 16.3106C11.2032 16.3106 11.3293 16.278 11.4405 16.2177L11.3131 14.616C11.3023 14.4818 11.3134 14.3486 11.3463 14.2199C11.3783 14.0935 11.4306 13.9724 11.5018 13.8605L13.1148 11.0054L13.5922 10.6154V6.57035ZM15.2588 5.17643H18.3152C18.6199 5.17643 18.8672 5.41301 18.8672 5.70348V11.2085C18.8672 11.499 18.6199 11.7355 18.3152 11.7355H15.259C14.9548 11.7355 14.707 11.499 14.707 11.2085V5.70362C14.7069 5.41301 14.9546 5.17643 15.2588 5.17643ZM18.3152 11.2224C18.323 11.2224 18.3304 11.2154 18.3304 11.2084V5.70348C18.3304 5.69647 18.323 5.68946 18.3152 5.68946H15.259C15.2517 5.68946 15.2443 5.69647 15.2443 5.70348V11.2085C15.2443 11.2155 15.2517 11.2225 15.259 11.2225L18.3152 11.2224ZM16.4333 6.13502C16.1146 6.13502 15.8561 6.38167 15.8561 6.68616C15.8561 6.9905 16.1146 7.23716 16.4333 7.23716C16.752 7.23716 17.0105 6.9905 17.0105 6.68616C17.0105 6.38182 16.752 6.13502 16.4333 6.13502Z'
			fill='white'
		/>
	</svg>
);

export const ViewSVG = () => (
	<svg
		width='26'
		height='13'
		viewBox='0 0 34 17'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M17.0004 0C9.87319 0 3.61282 3.29057 0.072845 8.27057C-0.0295028 8.41673 -0.0189164 8.58778 0.072845 8.71733C3.61282 13.6973 9.87319 17 17.0004 17C24.1276 17 30.388 13.6973 33.928 8.71733C34.0228 8.60436 34.0258 8.39865 33.928 8.27057C30.388 3.29057 24.1276 0 17.0004 0ZM17.0004 0.772727C23.7783 0.772727 29.7065 3.86656 33.119 8.5C29.7057 13.1298 23.7751 16.2273 17.0004 16.2273C10.2257 16.2273 4.29507 13.1298 0.881813 8.5C4.29429 3.86656 10.2225 0.772727 17.0004 0.772727ZM17.0004 3.09091C14.0176 3.09091 11.5913 5.51723 11.5913 8.5C11.5913 11.4828 14.0176 13.9091 17.0004 13.9091C19.9832 13.9091 22.4095 11.4828 22.4095 8.5C22.4095 5.51723 19.9832 3.09091 17.0004 3.09091ZM17.0004 3.86364C19.5655 3.86364 21.6368 5.93485 21.6368 8.5C21.6368 11.0651 19.5655 13.1364 17.0004 13.1364C14.4352 13.1364 12.364 11.0651 12.364 8.5C12.364 5.93485 14.4352 3.86364 17.0004 3.86364Z'
			fill='black'
		/>
	</svg>
);

export const ChannelMenuSVG = ({ fill }: { fill?: string }) => {
	const filler = fill || 'black';
	return (
		<svg
			width='12.17'
			height='15'
			viewBox='0 0 35 41'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M28.2736 9.87344H18.9704L28.8477 1.39628L27.65 0L17.3056 8.87983L6.86546 3.78034L6.05787 5.43235L15.1496 9.8733H6.43699C2.88826 9.8733 0 12.7616 0 16.3103V31.9417C0 35.3064 2.59575 38.0716 5.8888 38.3509L5.3553 40.5695L7.14347 41L7.77445 38.3785H26.9366L27.5676 41L29.3557 40.5695L28.8222 38.3509C32.1152 38.0713 34.711 35.3063 34.711 31.9417V16.3103C34.711 12.7616 31.8246 9.8733 28.2741 9.8733L28.2736 9.87344ZM32.8709 31.9418C32.8709 34.4769 30.8086 36.5392 28.2736 36.5392H6.4369C3.90185 36.5392 1.83959 34.4769 1.83959 31.9418V16.3104C1.83959 13.7754 3.90185 11.7131 6.4369 11.7131H28.2755C30.8105 11.7131 32.8728 13.7754 32.8728 16.3104V31.9418H32.8709Z'
				fill={filler}
			/>
			<path
				d='M23.6008 14.9194H7.14332C5.62191 14.9194 4.38382 16.1575 4.38382 17.6789V30.5732C4.38382 32.0946 5.62191 33.3327 7.14332 33.3327H23.5989C25.1203 33.3327 26.3584 32.0946 26.3584 30.5732L26.3602 17.6789C26.3602 16.1575 25.1222 14.9194 23.6008 14.9194ZM24.5206 30.573C24.5206 31.0807 24.1085 31.4928 23.6008 31.4928H7.14332C6.63559 31.4928 6.2235 31.0807 6.2235 30.573V17.6787C6.2235 17.171 6.63559 16.7589 7.14332 16.7589H23.5989C24.1066 16.7589 24.5187 17.171 24.5187 17.6787L24.5206 30.573Z'
				fill={filler}
			/>
			<path
				d='M29.5923 22.3203C28.597 22.3203 27.7857 23.1316 27.7857 24.1268C27.7857 25.1221 28.597 25.9334 29.5923 25.9334C30.5875 25.9334 31.3988 25.1221 31.3988 24.1268C31.3988 23.1297 30.5875 22.3203 29.5923 22.3203Z'
				fill={filler}
			/>
			<path
				d='M29.5923 17.9678C28.597 17.9678 27.7857 18.7791 27.7857 19.7743C27.7857 20.7695 28.597 21.5808 29.5923 21.5808C30.5875 21.5808 31.3988 20.7695 31.3988 19.7743C31.3988 18.7791 30.5875 17.9678 29.5923 17.9678Z'
				fill={filler}
			/>
			<path
				d='M29.5923 26.6714C28.597 26.6714 27.7857 27.4827 27.7857 28.4779C27.7857 29.4731 28.597 30.2844 29.5923 30.2844C30.5875 30.2844 31.3988 29.475 31.3988 28.4779C31.3988 27.4826 30.5875 26.6714 29.5923 26.6714Z'
				fill={filler}
			/>
		</svg>
	);
};

export const HomeMenuSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='18.75'
		height='15'
		viewBox='0 0 44 35'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M21.9043 0.000239758C22.1338 0.0051616 22.3479 0.0811931 22.5537 0.222406L43.3348 16.6285C43.813 17.0125 43.8808 17.7211 43.5228 18.1837C43.17 18.6397 42.4195 18.7127 41.9676 18.3546L21.8701 2.49534L1.77261 18.3546C1.32074 18.7127 0.5909 18.6369 0.234532 18.1837C-0.119163 17.7339 -0.0811335 16.9867 0.405429 16.6285L8.19834 10.4762V1.09398C8.19837 0.803913 8.31362 0.525716 8.51873 0.320605C8.72384 0.115495 9.00202 0.00026876 9.29209 0.000239758H13.6671C13.9571 0.00026876 14.2353 0.115495 14.4404 0.320605C14.6455 0.525716 14.7608 0.803913 14.7608 1.09398V5.29806L21.1865 0.222406C21.43 0.0620472 21.6748 -0.00454537 21.9043 0.000239758ZM12.5733 2.18772H10.3858V8.75018L12.5733 7.02412V2.18772ZM35.5419 14.7145L37.7294 16.4406V33.9063C37.7294 34.1963 37.6141 34.4745 37.409 34.6796C37.2039 34.8847 36.9257 35 36.6357 35H27.3388C27.0488 35 26.7706 34.8847 26.5655 34.6796C26.3604 34.4745 26.2451 34.1963 26.2451 33.9063V24.0626H17.4952V33.9063C17.4951 34.1963 17.3799 34.4745 17.1748 34.6796C16.9697 34.8847 16.6915 35 16.4014 35H7.1046C6.81453 35 6.53635 34.8847 6.33124 34.6796C6.12613 34.4745 6.01089 34.1963 6.01086 33.9063V16.4406L8.19834 14.7145V32.8125H15.3077V22.9689C15.3077 22.6788 15.4229 22.4006 15.6281 22.1955C15.8332 21.9904 16.1113 21.8752 16.4014 21.8751H27.3388C27.6289 21.8752 27.9071 21.9904 28.1122 22.1955C28.3173 22.4006 28.4326 22.6788 28.4326 22.9689V32.8125H35.5419V14.7145Z'
			fill={fill || 'black'}
		/>
	</svg>
);

export const FeedbackMenuSVG = ({ fill }: { fill?: string }) => {
	const filler = fill || 'black';
	return (
		<svg
			width='15'
			height='15'
			viewBox='0 0 35 35'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M31.4463 3.48833C31.1267 1.51006 29.4113 0 27.3428 0H4.158C1.86122 0 0 1.86122 0 4.15722V30.6977C0 31.1807 0.391222 31.5727 0.875 31.5727C1.04144 31.5727 1.19622 31.5264 1.32844 31.4459L5.19594 28.8532C5.88622 29.3642 6.73244 29.6765 7.65839 29.6765H25.9222L33.6719 34.8732C33.8038 34.9537 33.9589 35 34.125 35C34.608 35 34.9992 34.608 34.9992 34.125V7.58372C34.9992 5.49578 33.4546 3.78311 31.4463 3.48833ZM1.75 29.0562V4.15722C1.75 2.82994 2.82994 1.75 4.158 1.75H27.3428C28.6701 1.75 29.75 2.82994 29.75 4.15722V22.092C29.75 23.4193 28.6701 24.5 27.3428 24.5H8.54622L8.10328 24.7967L1.75 29.0562ZM33.25 32.4835L26.8967 28.2232L26.4542 27.9265H7.658C7.3605 27.9265 7.07894 27.8651 6.81644 27.7663L9.07822 26.25H27.3432C29.6392 26.25 31.5004 24.388 31.5004 22.092V5.27956C32.5068 5.56733 33.2504 6.48628 33.2504 7.58333L33.25 32.4835Z'
				fill={filler}
			/>
			<path
				d='M10.5 13.2222C10.5 14.1889 9.71678 14.9722 8.75 14.9722C7.784 14.9722 7 14.1889 7 13.2222C7 12.2562 7.784 11.4722 8.75 11.4722C9.71678 11.4722 10.5 12.2562 10.5 13.2222Z'
				fill={filler}
			/>
			<path
				d='M24.5 13.2222C24.5 14.1889 23.7168 14.9722 22.75 14.9722C21.784 14.9722 21 14.1889 21 13.2222C21 12.2562 21.784 11.4722 22.75 11.4722C23.7168 11.4722 24.5 12.2562 24.5 13.2222Z'
				fill={filler}
			/>
			<path
				d='M17.5 13.2222C17.5 14.1889 16.716 14.9722 15.75 14.9722C14.784 14.9722 14 14.1889 14 13.2222C14 12.2562 14.784 11.4722 15.75 11.4722C16.716 11.4722 17.5 12.2562 17.5 13.2222Z'
				fill={filler}
			/>
		</svg>
	);
};

export const HelpMenuSVG = ({ fill }: { fill?: string }) => {
	const filler = fill || 'black';
	return (
		<svg
			width='15'
			height='15'
			viewBox='0 0 35 35'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M17.5 0C14.0388 0 10.6554 1.02636 7.77753 2.94928C4.89967 4.87221 2.65665 7.60533 1.33212 10.803C0.00758244 14.0007 -0.338976 17.5194 0.336265 20.9141C1.01151 24.3087 2.67822 27.4269 5.12564 29.8744C7.57306 32.3218 10.6913 33.9885 14.0859 34.6637C17.4806 35.339 20.9993 34.9924 24.197 33.6679C27.3947 32.3434 30.1278 30.1003 32.0507 27.2225C33.9736 24.3446 35 20.9612 35 17.5C34.9946 12.8604 33.1491 8.41235 29.8684 5.13165C26.5876 1.85094 22.1396 0.00544876 17.5 0ZM17.5 32.9412C14.446 32.9412 11.4606 32.0356 8.92135 30.3389C6.38206 28.6422 4.40293 26.2306 3.23422 23.4091C2.06551 20.5876 1.75973 17.4829 2.35553 14.4876C2.95133 11.4923 4.42196 8.74092 6.58145 6.58144C8.74093 4.42195 11.4923 2.95132 14.4876 2.35552C17.4829 1.75972 20.5876 2.06551 23.4091 3.23421C26.2306 4.40292 28.6422 6.38205 30.3389 8.92134C32.0356 11.4606 32.9412 14.446 32.9412 17.5C32.9368 21.5939 31.3086 25.5189 28.4137 28.4137C25.5189 31.3086 21.5939 32.9368 17.5 32.9412Z'
				fill={filler}
			/>
			<path
				d='M17.5 5.34912C15.5437 5.3513 13.6681 6.12941 12.2848 7.51274C10.9015 8.89606 10.1234 10.7716 10.1212 12.7279C10.1212 13.001 10.2296 13.2628 10.4227 13.4558C10.6157 13.6489 10.8776 13.7574 11.1506 13.7574C11.4236 13.7574 11.6854 13.6489 11.8785 13.4558C12.0716 13.2628 12.18 13.001 12.18 12.7279C12.18 12.0293 12.3176 11.3375 12.585 10.6921C12.8523 10.0466 13.2442 9.46014 13.7382 8.96614C14.2322 8.47213 14.8187 8.08026 15.4641 7.81291C16.1096 7.54555 16.8014 7.40794 17.5 7.40794C18.1986 7.40794 18.8904 7.54555 19.5359 7.81291C20.1813 8.08026 20.7678 8.47213 21.2618 8.96614C21.7558 9.46014 22.1477 10.0466 22.415 10.6921C22.6824 11.3375 22.82 12.0293 22.82 12.7279C22.82 14.8609 21.3294 16.4091 19.7524 18.0521C18.1753 19.695 16.4582 21.4656 16.4582 23.9074C16.4582 24.1804 16.5667 24.4422 16.7597 24.6353C16.9528 24.8283 17.2146 24.9368 17.4877 24.9368C17.7607 24.9368 18.0225 24.8283 18.2156 24.6353C18.4086 24.4422 18.5171 24.1804 18.5171 23.9074C18.5171 22.2932 19.7524 20.9921 21.2224 19.4809C22.9312 17.7062 24.8665 15.6926 24.8665 12.7321C24.8654 10.7772 24.0895 8.90241 22.7087 7.51855C21.3279 6.13469 19.4549 5.35457 17.5 5.34912Z'
				fill={filler}
			/>
			<path
				d='M17.5 28.6176C18.2323 28.6176 18.8259 28.024 18.8259 27.2917C18.8259 26.5594 18.2323 25.9658 17.5 25.9658C16.7678 25.9658 16.1741 26.5594 16.1741 27.2917C16.1741 28.024 16.7678 28.6176 17.5 28.6176Z'
				fill={filler}
			/>
		</svg>
	);
};

export const LogoutMenuSVG = () => (
	<svg
		width='36'
		height='35'
		viewBox='0 0 36 35'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M17.5342 34.9999C13.7418 35.0074 10.0496 33.7827 7.01349 31.5102C3.97736 29.2376 1.76162 26.0403 0.699849 22.3996C-0.361919 18.7588 -0.212247 14.8717 1.12633 11.3234C2.46491 7.77505 4.91995 4.75759 8.12184 2.72527C8.39985 2.56668 8.72811 2.52078 9.03896 2.59702C9.34981 2.67327 9.61957 2.86585 9.79265 3.13509C9.96573 3.40432 10.0289 3.72969 9.96925 4.04414C9.90956 4.35859 9.73152 4.63816 9.47182 4.82525C6.73766 6.57182 4.64349 9.1578 3.50344 12.1953C2.3634 15.2328 2.23893 18.5581 3.14872 21.6723C4.05851 24.7865 5.9535 27.5218 8.54944 29.4679C11.1454 31.414 14.3023 32.4659 17.5467 32.4659C20.7911 32.4659 23.9481 31.414 26.544 29.4679C29.14 27.5218 31.035 24.7865 31.9448 21.6723C32.8545 18.5581 32.7301 15.2328 31.59 12.1953C30.45 9.1578 28.3558 6.57182 25.6217 4.82525C25.362 4.63816 25.1839 4.35859 25.1242 4.04414C25.0645 3.72969 25.1277 3.40432 25.3008 3.13509C25.4739 2.86585 25.7437 2.67327 26.0545 2.59702C26.3654 2.52078 26.6936 2.56668 26.9716 2.72527C30.1754 4.75872 32.6313 7.77841 33.9694 11.3292C35.3075 14.88 35.4552 18.7696 34.3902 22.4117C33.3253 26.0537 31.1053 29.2509 28.065 31.5215C25.0247 33.792 21.3288 35.0128 17.5342 34.9999Z'
			fill='black'
		/>
		<path
			d='M17.5342 19.9998C17.2027 19.9998 16.8848 19.8681 16.6504 19.6337C16.4159 19.3993 16.2842 19.0813 16.2842 18.7498V1.24999C16.2842 0.91847 16.4159 0.600531 16.6504 0.366113C16.8848 0.131695 17.2027 0 17.5342 0C17.8657 0 18.1837 0.131695 18.4181 0.366113C18.6525 0.600531 18.7842 0.91847 18.7842 1.24999V18.7498C18.7842 19.0813 18.6525 19.3993 18.4181 19.6337C18.1837 19.8681 17.8657 19.9998 17.5342 19.9998Z'
			fill='black'
		/>
	</svg>
);

export const TipMenuSVG = ({ fill }: { fill?: string }) => {
	const filler = fill || '#010202';
	return (
		<svg
			width='15'
			height='15'
			viewBox='0 0 35 35'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M5.5373 21.1047H1.14925C0.522387 21.1047 0 20.6867 0 19.9554C0 19.2241 0.417909 18.8062 1.14925 18.8062H5.5373C6.16417 18.8062 6.68656 19.2241 6.68656 19.9554C6.68656 20.6867 6.11193 21.1047 5.5373 21.1047Z'
				fill={filler}
			/>
			<path
				d='M9.03729 11.4404C8.77609 11.4404 8.41042 11.2836 8.14923 11.0224L5.11938 7.36574C4.70147 6.94783 4.85819 6.21648 5.2761 5.74634C5.69401 5.32843 6.42535 5.48514 6.8955 5.90305L9.92535 9.55976C10.3433 9.97767 10.1865 10.709 9.76863 11.1792C9.66415 11.2836 9.29848 11.4404 9.03729 11.4404Z'
				fill={filler}
			/>
			<path
				d='M17.4477 7.36566C16.8208 7.36566 16.2985 6.94775 16.2985 6.21641V1.14925C16.2985 0.522388 16.7164 0 17.4477 0C18.1791 0 18.597 0.41791 18.597 1.14925V6.21641C18.597 6.79104 18.0746 7.36566 17.4477 7.36566Z'
				fill={filler}
			/>
			<path
				d='M25.8581 11.4404C25.5969 11.4404 25.4402 11.2836 25.1268 11.1792C24.7089 10.7613 24.4999 10.1866 24.9701 9.55976L27.9999 5.90305C28.4178 5.48514 28.9925 5.27618 29.6193 5.74633C30.0372 6.16424 30.2462 6.73887 29.776 7.36573L26.7462 11.0224C26.485 11.2836 26.1716 11.4404 25.8581 11.4404Z'
				fill={filler}
			/>
			<path
				d='M33.694 21.1047H29.3059C28.6791 21.1047 28.1567 20.6867 28.1567 19.9554C28.1567 19.2241 28.5746 18.8062 29.3059 18.8062H33.694C34.3208 18.8062 34.8432 19.2241 34.8432 19.9554C34.8432 20.6867 34.3208 21.1047 33.694 21.1047Z'
				fill={filler}
			/>
			<path
				d='M17.4477 11.2834C21.2089 11.2834 24.2387 14.3132 24.2387 18.0744C24.2387 20.3729 23.0895 22.567 20.8955 23.8729C20.1641 24.2908 19.9029 25.0222 19.9029 25.7535V26.4849C19.9029 26.9028 19.5895 27.2162 19.1716 27.2162H15.8283C15.4104 27.2162 15.097 26.9028 15.097 26.4849V25.7535C15.097 25.0222 14.679 24.2908 14.1044 23.8729C12.0671 22.567 10.7611 20.5296 10.7611 18.0744C10.6567 14.3132 13.6865 11.2834 17.4477 11.2834ZM17.4477 9.1416C12.5373 9.1416 8.4104 13.164 8.4104 18.1789C8.4104 21.2087 10.0298 23.9774 12.485 25.649C12.694 25.8058 12.7985 26.0147 12.7985 26.2759V28.052C12.7985 28.8878 13.4776 29.5147 14.2611 29.5147H20.4253C21.2611 29.5147 21.888 28.8356 21.888 28.052V26.2759C21.888 26.0147 21.9925 25.8058 22.2014 25.649C24.6044 24.0296 26.276 21.3132 26.276 18.1789C26.485 13.0595 22.3581 9.1416 17.4477 9.1416Z'
				fill={filler}
			/>
			<path
				d='M20.791 32.4406H13.8955C13.2687 32.4406 12.7463 31.9182 12.7463 31.2913C12.7463 30.6645 13.2687 30.1421 13.8955 30.1421H20.7388C21.3657 30.1421 21.8881 30.6645 21.8881 31.2913C21.9403 31.9182 21.4179 32.4406 20.791 32.4406Z'
				fill={filler}
			/>
			<path
				d='M20.791 35.0002H13.8955C13.2687 35.0002 12.7463 34.4778 12.7463 33.8509C12.7463 33.224 13.2687 32.7017 13.8955 32.7017H20.7388C21.3657 32.7017 21.8881 33.224 21.8881 33.8509C21.9403 34.4778 21.4179 35.0002 20.791 35.0002Z'
				fill={filler}
			/>
		</svg>
	);
};

export const AccountMenuSVG = ({ fill }: { fill?: string }) => {
	const filler = fill || 'black';
	return (
		<svg
			width='15.68'
			height='15'
			viewBox='0 0 37 35'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M11.4027 22.7622C5.19321 22.7622 0.0983983 27.8071 0.0120569 33.997C0.0120236 34.0013 0.0120236 34.0056 0.0120569 34.0099C-0.0103455 34.14 -0.00144102 34.2736 0.0380333 34.3995C0.038 34.4038 0.038 34.4081 0.0380333 34.4124C0.0551279 34.462 0.0768717 34.5098 0.102974 34.5553C0.118814 34.5822 0.136159 34.6082 0.154927 34.6332C0.17115 34.6557 0.188489 34.6774 0.20688 34.6982C0.223104 34.7207 0.240443 34.7423 0.258833 34.7631C0.275376 34.7812 0.292711 34.7985 0.310785 34.8151C0.335765 34.8338 0.361783 34.8512 0.388715 34.867C0.409756 34.881 0.431426 34.894 0.453656 34.9061C0.457978 34.9061 0.462301 34.9061 0.466623 34.9061C0.536178 34.9423 0.610515 34.9686 0.687422 34.984C0.691745 34.984 0.696068 34.984 0.70039 34.984C0.807573 35.0053 0.917912 35.0053 1.02509 34.984H35.5997C35.734 35.0086 35.8723 34.9997 36.0023 34.9582C36.1229 34.9229 36.2339 34.8608 36.327 34.7764C36.3359 34.768 36.3445 34.7594 36.353 34.7506C36.353 34.7463 36.353 34.742 36.353 34.7377C36.3711 34.7212 36.3884 34.7039 36.4049 34.6858C36.4093 34.6815 36.4136 34.6772 36.4179 34.6729C36.4316 34.6561 36.4446 34.6388 36.4569 34.6209C36.4569 34.6166 36.4569 34.6123 36.4569 34.6081C36.4708 34.587 36.4838 34.5654 36.4958 34.5432C36.5227 34.4935 36.5444 34.4413 36.5607 34.3873C36.5907 34.2818 36.5996 34.1714 36.5867 34.0625C36.5868 34.0583 36.5868 34.054 36.5867 34.0497C36.529 27.8354 31.4235 22.7629 25.1962 22.7629H11.4027V22.7622ZM11.4027 24.4247H25.1962C30.2709 24.4247 34.4583 28.3541 34.8854 33.3216H1.71351C2.14061 28.3541 6.32799 24.4247 11.4027 24.4247Z'
				fill={filler}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M18.2995 0C13.0876 0 8.84479 4.24282 8.84479 9.45478C8.84479 14.663 13.0876 18.9052 18.2995 18.9052C23.5078 18.9052 27.7503 14.663 27.7503 9.45478C27.7503 4.24283 23.5078 0 18.2995 0ZM18.2995 1.66249C22.6087 1.66249 26.0878 5.14126 26.0878 9.45478C26.0878 13.7638 22.6087 17.2427 18.2995 17.2427C13.986 17.2427 10.5073 13.7638 10.5073 9.45478C10.5073 5.14126 13.986 1.66249 18.2995 1.66249Z'
				fill={filler}
			/>
		</svg>
	);
};

// export const FilterSVG = ({ fill }: { fill?: string }) => {
//   const filler = fill || 'black';
//   return (
//     <svg
//       width="13"
//       height="9"
//       viewBox="0 0 16 12"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M9 10C9.55229 10 10 10.4477 10 11C10 11.5523 9.55229 12 9 12H7C6.44771 12 6 11.5523 6 11C6 10.4477 6.44771 10 7 10H9ZM12 5C12.5523 5 13 5.44771 13 6C13 6.55229 12.5523 7 12 7H4C3.44771 7 3 6.55229 3 6C3 5.44771 3.44771 5 4 5H12ZM15 0C15.5523 0 16 0.447715 16 1C16 1.55229 15.5523 2 15 2H1C0.447715 2 0 1.55229 0 1C0 0.447715 0.447715 0 1 0H15Z"
//         fill={filler}
//       />
//     </svg>
//   );
// };

export const CommentSVG = () => (
	<svg
		width='12'
		height='11.07'
		viewBox='0 0 57 53'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M0 5.5V36C0 39 2.5 41.5 5.5 41.5H9.5C12.7 51.7 17.3 52.2 18.2 52.2C19.7 52.2 20.2 50.9 21.3 48.4C22.4 45.8 24.2 41.5 26.3 41.5H51.1C54.1 41.5 56.6 39 56.6 36V5.5C56.6 2.5 54.1 0 51.1 0H5.5C2.5 0 0 2.5 0 5.5ZM3 5.5C3 4.1 4.1 3 5.5 3H51.1C52.5 3 53.6 4.1 53.6 5.5V36C53.6 37.4 52.5 38.5 51.1 38.5H26.1C26 38.5 25.9 38.5 25.7 38.5C21.9 39 19.9 44 18.5 47.3C18.2 47.9 17.9 48.8 17.7 49.3C15.5 48.5 13 43.2 12 39.5V39.4C12 39.4 12 39.3 11.9 39.3C11.9 39.3 11.9 39.2 11.8 39.2C11.8 39.2 11.8 39.1 11.7 39.1L11.6 39L11.5 38.9L11.4 38.8L11.3 38.7C11.3 38.7 11.2 38.7 11.2 38.6C11.2 38.6 11.1 38.6 11.1 38.5H11H10.9C10.8 38.5 10.8 38.5 10.7 38.5H10.6H5.6C4.2 38.5 3.1 37.4 3.1 36V5.5H3Z'
			fill='black'
		/>
		<path
			d='M43.5 14.1H12.5C11.7 14.1 11.1 13.4 11.1 12.6C11.1 11.8 11.7 11.1 12.5 11.1H43.5C44.3 11.1 44.9 11.8 44.9 12.6C44.9 13.4 44.3 14.1 43.5 14.1Z'
			fill='black'
		/>
		<path
			d='M43.5 22.1H12.5C11.7 22.1 11.1 21.4 11.1 20.6C11.1 19.8 11.7 19.1 12.5 19.1H43.5C44.3 19.1 44.9 19.8 44.9 20.6C44.9 21.4 44.3 22.1 43.5 22.1Z'
			fill='black'
		/>
		<path
			d='M43.5 30.1H12.5C11.7 30.1 11.1 29.4 11.1 28.6C11.1 27.8 11.7 27.1 12.5 27.1H43.5C44.3 27.1 44.9 27.8 44.9 28.6C44.9 29.4 44.3 30.1 43.5 30.1Z'
			fill='black'
		/>
	</svg>
);

export const LikeSVG = () => (
	<svg
		width='12'
		height='10.67'
		viewBox='0 0 20 18'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M6.74504 8.65792L6.72714 14.8925L6.72535 14.8603C6.78442 15.7106 6.85065 16.2404 7.10484 16.4731C7.36798 16.7112 7.93543 16.7434 8.81436 16.747H8.81973L15.7472 16.8508L15.7526 16.8526C15.9441 16.8562 16.107 16.8598 16.2878 16.8598C16.943 16.8598 17.3654 16.7917 17.591 16.6056C17.8953 16.3568 18.0027 15.7857 18.1245 14.9104L18.1262 14.9086L18.9819 8.83671L18.9837 8.83313L18.9855 8.81702V8.81523C19.1108 8.00255 19.1072 7.66422 18.9819 7.55323C18.8996 7.47984 18.6543 7.41003 18.1442 7.41003C17.8864 7.41003 17.6071 7.42614 17.3082 7.44225L11.8843 7.73403C11.7107 7.74298 11.5478 7.65527 11.46 7.5049C11.3741 7.35633 11.3777 7.17016 11.4726 7.02337L11.4779 7.01442L11.4815 7.01084L11.4744 7.01979C12.1886 5.9153 12.8849 4.8395 13.3414 3.96056C13.8104 3.05834 13.9643 2.47837 13.8802 2.0631C13.7943 1.64064 13.4506 1.27728 12.9566 0.7886L13.5956 0.79755L8.32197 5.72381L8.30944 5.73455C7.74913 6.22323 7.28194 6.63676 7.04388 7.08961C6.81117 7.52997 6.77716 8.0437 6.74315 8.67921L6.74504 8.65792ZM5.82306 8.65415V8.63088C5.85528 8.03299 5.88571 7.30982 6.22941 6.66001C6.56415 6.02455 7.18171 5.49466 7.70444 5.03998L7.6937 5.05072L12.9655 0.124466C13.1463 -0.0455888 13.4291 -0.0402225 13.6045 0.133416C14.0431 0.568402 14.632 1.13049 14.7824 1.88052C14.9363 2.6377 14.6302 3.47727 14.1594 4.3848C13.6779 5.31204 12.9547 6.42904 12.2476 7.52101L12.2423 7.52997L12.2387 7.53355L11.8341 6.81394L17.258 6.52216H17.2831H17.2563C17.548 6.50605 17.8541 6.48815 18.1441 6.48815C18.6149 6.48815 19.2164 6.52753 19.5959 6.86586C20.1848 7.39033 19.9807 8.40532 19.8966 8.95487V8.95307L19.8948 8.97098V8.96561L19.0374 15.0375C18.9371 15.7607 18.8208 16.7882 18.1764 17.3181C17.6644 17.7405 16.9072 17.7817 16.2878 17.7817C16.0999 17.7817 15.9155 17.7763 15.7293 17.7727H15.7347L8.80539 17.6689H8.80897C8.09652 17.6653 7.07259 17.6886 6.48548 17.1552C5.89295 16.6146 5.85359 15.6085 5.80703 14.9229L5.80524 14.8907L5.82306 8.65415Z'
			fill='black'
		/>
		<path
			d='M0.460048 6.42762H4.91554C5.16973 6.42762 5.37558 6.63348 5.37558 6.88767V17.2305C5.37558 17.4847 5.16973 17.6906 4.91554 17.6906L0.460048 17.6923C0.338326 17.6923 0.220179 17.6422 0.134256 17.5563C0.0483326 17.4704 0 17.3522 0 17.2305V6.88766C0 6.76594 0.0483326 6.64779 0.134256 6.56187C0.220179 6.47594 0.338322 6.42762 0.460048 6.42762ZM0.460048 7.3477L0.920092 6.88766V17.2305L0.460048 16.7705H4.91554L4.45371 17.2305V6.88766L4.91554 7.34949L0.460048 7.3477Z'
			fill='black'
		/>
	</svg>
);

export const DislikeSVG = () => (
	<svg
		width='12'
		height='10.84'
		viewBox='0 0 20 19'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M13.2181 9.23715L13.0625 3.01122L13.0697 3.0738L13.0661 3.04341C12.9838 2.19411 12.9034 1.66846 12.6423 1.44317C12.4474 1.2751 12.0577 1.20894 11.4211 1.20894C11.262 1.20894 11.0957 1.21252 10.9277 1.21609H10.9223L4.00292 1.30371H3.99577H3.99756C3.08747 1.30728 2.47065 1.33589 2.16846 1.59872C1.87166 1.85619 1.78047 2.43013 1.68213 3.30804L0.993764 9.39436L0.995552 9.3425L0.991976 9.39972C0.89006 10.224 0.898999 10.5673 1.02773 10.6763C1.09925 10.7354 1.29772 10.7979 1.72324 10.7979C2.01468 10.7979 2.34725 10.7711 2.70304 10.7407H2.70483L8.11143 10.2991C8.28308 10.2866 8.44936 10.3706 8.54054 10.5172C8.63173 10.6638 8.63173 10.8498 8.54233 10.9982L8.49406 11.0769C7.82716 12.1729 7.18168 13.2385 6.75971 14.1093C6.31629 15.0211 6.17863 15.6058 6.27338 16.017C6.37171 16.4372 6.72573 16.7895 7.23175 17.2651L6.59346 17.274L11.7231 12.2089L11.7589 12.1767L11.7357 12.1964C12.281 11.6939 12.7351 11.2684 12.9622 10.8089C13.1803 10.3637 13.2018 9.85236 13.2179 9.21402L13.2181 9.23715ZM14.1369 9.21402V9.23727C14.1226 9.83624 14.1101 10.5586 13.7865 11.2165C13.47 11.8602 12.8674 12.4056 12.3579 12.874L12.3346 12.8955H12.3328L12.3686 12.8633L7.24074 17.9284C7.06373 18.1019 6.78302 18.1054 6.60245 17.9356C6.15188 17.5136 5.54933 16.9683 5.37768 16.2245C5.20425 15.4717 5.48496 14.626 5.93193 13.707C6.37714 12.788 7.04763 11.683 7.70739 10.5977L7.75567 10.519L8.18657 11.2163L2.77814 11.6579H2.77992C2.43306 11.6866 2.06295 11.7187 1.72323 11.7187C1.30484 11.7187 0.786319 11.6758 0.435888 11.3808C-0.170227 10.8694 0.0103489 9.83957 0.0800827 9.28532L0.0765076 9.34254L0.0782947 9.29068L0.766662 3.20436C0.84891 2.48025 0.936518 1.45216 1.5641 0.905048C2.18633 0.36329 3.23584 0.386543 3.99396 0.382972H3.99575H3.99039L10.9116 0.29536H10.908C11.0814 0.291784 11.2424 0.288208 11.4212 0.288208C12.0112 0.288208 12.7532 0.323967 13.2413 0.745929C13.8492 1.26801 13.9154 2.27106 13.9816 2.95407L13.9762 2.92367L13.9834 2.98804L14.1369 9.21402Z'
			fill='black'
		/>
		<path
			d='M19.5579 11.2914L15.2239 11.4577C14.97 11.4666 14.7554 11.2681 14.7465 11.0143L14.3478 0.644117C14.3388 0.390224 14.5355 0.177471 14.7894 0.166715L19.1235 0.000432987C19.2468 -0.00493105 19.3648 0.0397687 19.4542 0.122013C19.5436 0.204258 19.5973 0.320476 19.6026 0.442061L19.9996 10.814C20.0049 10.9356 19.9602 11.0536 19.878 11.143C19.7957 11.2324 19.6795 11.286 19.5579 11.2914ZM19.5222 10.3706L19.0806 10.848L18.6818 0.477887L19.1592 0.919514L14.8252 1.0858L15.2668 0.608393L15.6655 10.9804L15.1881 10.5369L19.5222 10.3706Z'
			fill='black'
		/>
	</svg>
);

export const BackArrowSVG = () => (
	<svg
		width='19'
		height='8'
		viewBox='0 0 19 8'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M0.646447 3.64645C0.451184 3.84171 0.451184 4.15829 0.646447 4.35355L3.82843 7.53554C4.02369 7.7308 4.34027 7.7308 4.53553 7.53554C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976312 4.7308 0.659729 4.53553 0.464467C4.34027 0.269205 4.02369 0.269205 3.82843 0.464467L0.646447 3.64645ZM19 3.5L1 3.5L1 4.5L19 4.5L19 3.5Z'
			fill='#7D7D7D'
		/>
	</svg>
);

export const ViolationsSVG = () => (
	<svg
		width='22.11'
		height='22'
		viewBox='0 0 26 25'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M24.4292 17.9212L20.2313 13.9832C20.3916 13.524 20.2963 12.9955 19.9281 12.6316C19.5425 12.246 18.9707 12.155 18.4941 12.3587L17.7923 11.7002C18.1172 11.3623 18.1172 10.8207 17.7837 10.4872L16.8652 9.56873L18.3988 8.03513C18.6458 8.28207 18.9707 8.41637 19.3172 8.41637C19.6638 8.41637 19.9887 8.28207 20.2357 8.03513L20.8465 7.4243C21.3534 6.91743 21.3534 6.09431 20.8465 5.58745L15.6392 0.38015C15.1323 -0.126717 14.3092 -0.126717 13.8024 0.38015L13.1915 0.990989C12.793 1.38955 12.7107 1.98306 12.9403 2.46827L6.0824 9.32613C5.60153 9.10952 4.99502 9.1875 4.60945 9.57306L3.99861 10.1839C3.75168 10.4308 3.61738 10.7558 3.61738 11.1023C3.61738 11.4489 3.75168 11.7738 3.99861 12.0208L9.20591 17.228C9.45718 17.4793 9.79076 17.6093 10.1243 17.6093C10.4579 17.6093 10.7915 17.4836 11.0428 17.228L11.6536 16.6172C12.1605 16.1103 12.1605 15.2872 11.6536 14.7804L13.1872 13.2468L14.1056 14.1652C14.2746 14.3341 14.4955 14.4165 14.7165 14.4165C14.9374 14.4165 15.1497 14.3341 15.3186 14.1739L15.9771 14.8757C15.9078 15.036 15.8688 15.2092 15.8688 15.3912C15.8688 15.7378 16.0031 16.0627 16.2501 16.3096C16.497 16.5566 16.8219 16.6909 17.1685 16.6909C17.3201 16.6909 17.4631 16.6605 17.6017 16.6129L21.5267 20.7978C21.8992 21.2267 22.4364 21.4823 23.0039 21.4996C23.0256 21.4996 23.0516 21.4996 23.0733 21.4996C23.6148 21.4996 24.139 21.283 24.5202 20.9017C24.9231 20.5032 25.1397 19.9487 25.1181 19.3855C25.0964 18.818 24.8408 18.2808 24.4249 17.9255L24.4292 17.9212ZM16.5316 14.1912L15.9381 13.5587L16.2414 13.2554L17.1858 12.311L17.8183 12.9045L16.536 14.1868L16.5316 14.1912ZM13.8024 1.60183L14.4132 0.990989C14.4998 0.908678 14.6082 0.865356 14.7208 0.865356C14.8334 0.865356 14.9417 0.908678 15.0284 0.990989L20.2357 6.19828C20.4046 6.36724 20.4046 6.64017 20.2357 6.80912L19.6248 7.41996C19.4602 7.58459 19.1743 7.58459 19.014 7.41996L13.8067 2.21267C13.6377 2.04371 13.6377 1.77078 13.8067 1.60183H13.8024ZM11.0471 15.9977L10.4363 16.6085C10.2673 16.7775 9.99437 16.7775 9.82108 16.6085L4.61379 11.4012C4.53147 11.3189 4.48815 11.2106 4.48815 11.0937C4.48815 10.9767 4.53147 10.8684 4.61379 10.7861L5.22462 10.1752C5.30694 10.0929 5.41524 10.0496 5.53221 10.0496C5.64918 10.0496 5.75748 10.0929 5.8398 10.1752L11.0471 15.3825C11.216 15.5515 11.216 15.8287 11.0471 15.9977ZM6.75822 9.87198L13.4991 3.13109L17.788 7.41996L11.0471 14.1609L6.75822 9.87198ZM13.8024 12.6273L16.2544 10.1752L17.1728 11.0937L14.7208 13.5457L13.8024 12.6273ZM16.8652 15.6901C16.7829 15.6078 16.7396 15.4995 16.7396 15.3825C16.7396 15.2656 16.7829 15.1573 16.8652 15.0749L18.7021 13.2381C18.7887 13.1558 18.897 13.1125 19.0097 13.1125C19.1223 13.1125 19.2306 13.1558 19.3172 13.2381C19.4862 13.4071 19.4862 13.68 19.3172 13.8489L17.4804 15.6858C17.3158 15.8504 17.0342 15.8504 16.8696 15.6858L16.8652 15.6901ZM23.9094 20.2822C23.6754 20.5162 23.3592 20.6375 23.0343 20.6288C22.7007 20.6158 22.4018 20.4729 22.1722 20.2129L18.3078 16.0887L19.7158 14.6807L23.8531 18.5624C24.1043 18.779 24.2473 19.0779 24.2603 19.4115C24.2733 19.7407 24.152 20.0526 23.9137 20.2866L23.9094 20.2822ZM11.1987 22.4007H10.8261V21.5862C10.8261 21.0794 10.4146 20.6678 9.90773 20.6678H2.21808C1.71122 20.6678 1.29966 21.0794 1.29966 21.5862V22.4007H0.927089C0.41589 22.4007 0 22.8166 0 23.3278V24.0729C0 24.5841 0.41589 25 0.927089 25H11.2031C11.7142 25 12.1301 24.5841 12.1301 24.0729V23.3278C12.1301 22.8166 11.7142 22.4007 11.2031 22.4007H11.1987ZM2.16176 21.5862C2.16176 21.5602 2.18343 21.5342 2.21375 21.5342H9.90773C9.93805 21.5342 9.95971 21.5559 9.95971 21.5862V22.4007H2.1661V21.5862H2.16176ZM11.2594 24.0729C11.2594 24.1076 11.2334 24.1336 11.1987 24.1336H0.927089C0.892432 24.1336 0.866439 24.1076 0.866439 24.0729V23.3278C0.866439 23.2931 0.892432 23.2671 0.927089 23.2671H11.2031C11.2377 23.2671 11.2637 23.2931 11.2637 23.3278V24.0729H11.2594ZM6.06074 19.3681C5.82247 19.3681 5.62752 19.1732 5.62752 18.9349V17.4057C5.62752 17.1674 5.82247 16.9724 6.06074 16.9724C6.29901 16.9724 6.49396 17.1674 6.49396 17.4057V18.9349C6.49396 19.1732 6.29901 19.3681 6.06074 19.3681ZM7.81094 19.888C7.603 19.7667 7.53802 19.5024 7.65932 19.2945L8.43911 17.9775C8.56041 17.7696 8.82468 17.7046 9.03262 17.8259C9.24057 17.9472 9.30555 18.2115 9.18425 18.4194L8.40445 19.7364C8.32214 19.875 8.17918 19.9487 8.03189 19.9487C7.95824 19.9487 7.88026 19.9313 7.81094 19.888ZM2.7856 18.4194C2.6643 18.2115 2.73361 17.9472 2.93723 17.8259C3.14517 17.7046 3.40944 17.7739 3.53074 17.9775L4.31053 19.2945C4.43183 19.5024 4.36252 19.7667 4.15891 19.888C4.08959 19.927 4.01594 19.9487 3.93796 19.9487C3.79067 19.9487 3.64337 19.8707 3.56539 19.7364L2.7856 18.4194Z'
			fill='black'
		/>
	</svg>
);

export const SunSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='23'
		height='23'
		viewBox='0 0 60 60'
		fill='none'
	>
		<g clipPath='url(#clip0_584_86)'>
			<path
				d='M44.19 16.44C40.48 12.74 35.56 10.7 30.32 10.7C25.08 10.7 20.15 12.74 16.45 16.44C12.74 20.14 10.7 25.07 10.7 30.31C10.7 35.55 12.74 40.48 16.45 44.18C20.15 47.88 25.08 49.92 30.32 49.92C35.56 49.92 40.48 47.88 44.19 44.18C47.89 40.47 49.93 35.55 49.93 30.31C49.93 25.07 47.89 20.15 44.19 16.44ZM31.32 54.16V59.62C31.32 60.17 30.87 60.62 30.32 60.62C29.77 60.62 29.32 60.17 29.32 59.62V54.16C29.32 53.61 29.77 53.16 30.32 53.16C30.87 53.16 31.32 53.61 31.32 54.16ZM29.32 6.47V1C29.32 0.45 29.77 0 30.32 0C30.87 0 31.32 0.45 31.32 1V6.47C31.32 7.02 30.87 7.47 30.32 7.47C29.77 7.47 29.32 7.02 29.32 6.47ZM7.47 30.32C7.47 30.87 7.02 31.32 6.47 31.32H1C0.45 31.32 0 30.87 0 30.32C0 29.77 0.45 29.32 1 29.32H6.47C7.02 29.32 7.47 29.77 7.47 30.32ZM60.63 30.32C60.63 30.87 60.18 31.32 59.63 31.32H54.17C53.62 31.32 53.17 30.87 53.17 30.32C53.17 29.77 53.62 29.32 54.17 29.32H59.63C60.18 29.32 60.63 29.77 60.63 30.32ZM8.89 10.3C8.5 9.91 8.5 9.28 8.89 8.89C9.28 8.5 9.91 8.5 10.3 8.89L14.17 12.76C14.56 13.15 14.56 13.78 14.17 14.17C13.97 14.37 13.72 14.46 13.46 14.46C13.2 14.46 12.95 14.36 12.75 14.17L8.88 10.3H8.89ZM51.75 50.34C52.14 50.73 52.14 51.36 51.75 51.75C51.55 51.95 51.3 52.04 51.04 52.04C50.78 52.04 50.53 51.94 50.33 51.75L46.47 47.88C46.08 47.49 46.08 46.86 46.47 46.47C46.86 46.08 47.49 46.08 47.88 46.47L51.74 50.34H51.75ZM51.75 8.88C52.14 9.27 52.14 9.9 51.75 10.3L47.89 14.17C47.69 14.37 47.44 14.46 47.18 14.46C46.92 14.46 46.67 14.36 46.47 14.17C46.08 13.78 46.08 13.15 46.47 12.75L50.33 8.88C50.72 8.49 51.35 8.49 51.75 8.88ZM14.17 46.47C14.56 46.86 14.56 47.49 14.17 47.88L10.3 51.75C10.1 51.95 9.85 52.04 9.59 52.04C9.33 52.04 9.08 51.94 8.88 51.75C8.49 51.36 8.49 50.73 8.88 50.34L12.75 46.47C13.14 46.08 13.77 46.08 14.16 46.47H14.17Z'
				fill='#ffb000'
			/>
		</g>
		<defs>
			<clipPath id='clip0_584_86'>
				<rect
					width='60'
					height='60'
					fill='white'
				/>
			</clipPath>
		</defs>
	</svg>
);

export const MoonSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='25'
		height='25'
		viewBox='0 0 60 60'
		fill='none'
	>
		<path
			d='M23.8894 10.5098C23.534 10.2159 23.096 10.0398 22.6361 10.006C22.1762 9.97215 21.7172 10.0822 21.3226 10.3209C18.1643 12.2381 15.5546 14.9382 13.7462 18.16C11.9377 21.3817 10.9918 25.0158 11.0001 28.7104C11.0001 40.4552 20.2892 50 31.7007 50C34.9661 49.9814 38.1802 49.1869 41.0781 47.6819C43.976 46.1769 46.4746 44.0046 48.3679 41.3442C48.6537 40.9747 48.8159 40.5246 48.8313 40.0578C48.8467 39.5909 48.7146 39.1311 48.4538 38.7436C48.193 38.3561 47.8168 38.0606 47.3785 37.8991C46.9402 37.7377 46.4622 37.7184 46.0123 37.844C44.7251 38.1356 43.4097 38.2847 42.09 38.2885C31.9007 38.2885 23.6005 29.7327 23.6005 19.2212C23.5992 17.1015 23.9445 14.9959 24.6227 12.9877C24.774 12.5498 24.7847 12.0755 24.6532 11.6312C24.5217 11.1869 24.2547 10.7949 23.8894 10.5098ZM42.1122 40.5108C43.6045 40.4943 45.0921 40.3418 46.5568 40.0552C44.8913 42.451 42.6719 44.4091 40.0874 45.7633C37.5029 47.1175 34.6296 47.8276 31.7118 47.8333C21.5115 47.7777 13.2223 39.2219 13.2223 28.7104C13.2078 25.3999 14.057 22.1428 15.6861 19.2608C17.3151 16.3787 19.6677 13.9714 22.5115 12.2766C21.7654 14.5155 21.3901 16.8613 21.4004 19.2212C21.3671 30.9549 30.6562 40.5108 42.1122 40.5108Z'
			fill='white'
		/>
	</svg>
);

export const InfoSmallSVG = () => (
	<svg
		width='10'
		height='10'
		viewBox='0 0 10 10'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M4.98645 0C7.75068 0 10 2.24932 10 4.98645C10 7.75068 7.75068 10 4.98645 10C2.24932 10 0 7.75068 0 4.98645C0 2.24932 2.24932 0 4.98645 0ZM5.20325 1.92412C5.66396 1.92412 6.01626 2.30352 6.01626 2.73713C5.98916 3.19783 5.63686 3.55014 5.20325 3.55014C4.74255 3.55014 4.39024 3.17073 4.39024 2.73713C4.39024 2.27642 4.76965 1.92412 5.20325 1.92412ZM6.36856 7.39837C6.12466 8.29268 3.73984 8.37398 3.90244 7.15447C4.01084 6.34146 4.17344 5.55556 4.30894 4.76965C4.39024 4.25474 4.06504 4.41734 3.76694 4.30894C3.57724 4.22764 3.57724 3.98374 3.82114 3.92954C4.11924 3.84824 5.17615 3.90244 5.52846 3.90244C5.71816 3.90244 5.82656 4.01084 5.85366 4.20054C5.85366 4.36314 5.82656 4.49864 5.79946 4.66125C5.66396 5.42005 5.47425 6.23306 5.36585 6.99187C5.36585 7.15447 5.39295 7.45257 5.63686 7.42547C5.88076 7.42547 5.98916 7.31707 6.17886 7.23577C6.28726 7.18157 6.39566 7.26287 6.36856 7.39837Z'
			fill='black'
		/>
	</svg>
);

export const CartSVG = ({ color }: { color?: string }) => (
	<svg
		width='18'
		height='15'
		viewBox='0 0 18 15'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M17.6188 4.31656C17.5574 4.22523 17.4591 4.1646 17.3494 4.15155L3.72344 2.51299L2.63131 0.656451C2.47858 0.397045 2.2092 0.22283 1.91064 0.189823L0.21374 0.00102146C0.108594 -0.00972338 0.0134329 0.065489 0.00115322 0.170635C-0.0103589 0.27578 0.0656226 0.370941 0.170766 0.383221L1.86766 0.572788C2.04649 0.592742 2.20767 0.69712 2.29899 0.852156L3.42412 2.76396L5.24688 11.0259C5.28526 11.1979 5.44029 11.323 5.61681 11.323H15.5365C15.7061 11.323 15.8565 11.2086 15.901 11.0451L17.6678 4.62902C17.6985 4.52157 17.6802 4.40788 17.6188 4.31656ZM15.5336 10.9376L5.62377 10.9422L3.85242 2.91519L17.2988 4.52536L15.5336 10.9376Z'
			fill={color || 'black'}
		/>
		<path
			d='M6.84963 11.9102C5.99773 11.9102 5.30469 12.6032 5.30469 13.4551C5.30469 14.307 5.99771 15.0008 6.84963 15.0008C7.70153 15.0008 8.39458 14.3078 8.39458 13.4551C8.39458 12.6032 7.70155 11.9102 6.84963 11.9102ZM6.84963 14.6162C6.20955 14.6162 5.68842 14.0951 5.68842 13.455C5.68842 12.8149 6.20953 12.2946 6.84963 12.2946C7.48971 12.2946 8.01084 12.8149 8.01084 13.455C8.01007 14.0951 7.48973 14.6162 6.84963 14.6162Z'
			fill={color || 'black'}
		/>
		<path
			d='M14.2969 11.9102C13.445 11.9102 12.752 12.6032 12.752 13.4551C12.752 14.307 13.445 15.0008 14.2969 15.0008C15.1488 15.0008 15.8426 14.3078 15.8426 13.4551C15.8418 12.6032 15.1488 11.9102 14.2969 11.9102ZM14.2969 14.6162C13.6568 14.6162 13.1357 14.0951 13.1357 13.455C13.1357 12.8149 13.6568 12.2946 14.2969 12.2946C14.937 12.2946 15.4581 12.8149 15.4581 13.455C15.4573 14.0951 14.937 14.6162 14.2969 14.6162Z'
			fill={color || 'black'}
		/>
	</svg>
);

export const CartBlockSVG = ({ color }: { color?: string }) => (
	<svg
		width='18'
		height='15'
		viewBox='0 0 18 15'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M17.6345 4.35716C17.5808 4.2773 17.4948 4.22432 17.3988 4.2128L3.76528 2.5734L2.63881 0.659086C2.486 0.399547 2.21572 0.224477 1.91623 0.190686L0.213848 0.00102175C0.107882 -0.00972838 0.0126729 0.0655222 0.0011536 0.17149C-0.0103644 0.277456 0.065654 0.372666 0.171622 0.384185L1.87401 0.573849C2.05369 0.593813 2.21571 0.698244 2.30708 0.854126L3.45121 2.79838C3.46503 2.82141 3.48269 2.83907 3.50343 2.85366L5.31177 11.0499C5.34478 11.2004 5.48147 11.3094 5.6358 11.3094H15.5882C15.7372 11.3094 15.8685 11.2096 15.9077 11.066L17.6799 4.62894C17.7045 4.53679 17.6883 4.43778 17.6345 4.35716Z'
			fill={color || 'black'}
		/>
		<path
			d='M6.8711 11.9961C6.04257 11.9961 5.36914 12.6695 5.36914 13.498C5.36914 14.3266 6.04257 15 6.8711 15C7.69962 15 8.37305 14.3266 8.37305 13.498C8.37305 12.6703 7.69886 11.9961 6.8711 11.9961Z'
			fill={color || 'black'}
		/>
		<path
			d='M14.3418 11.9961C13.5133 11.9961 12.8398 12.6695 12.8398 13.498C12.8398 14.3266 13.514 15 14.3418 15C15.1703 15 15.8438 14.3266 15.8438 13.498C15.8438 12.6703 15.1703 11.9961 14.3418 11.9961Z'
			fill={color || 'black'}
		/>
	</svg>
);

export const SwitchDarkSVG = () => (
	<svg
		width='10'
		height='12.22'
		viewBox='0 0 290 333'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M86.2609 82.8384C62.9711 95.7345 44.6069 115.979 34.0352 140.412C23.4636 164.845 21.2795 192.091 27.8241 217.896C34.3687 243.701 49.2735 266.612 70.2115 283.054C91.1496 299.495 116.942 308.541 143.563 308.779C170.184 309.017 196.135 300.434 217.363 284.369C238.592 268.305 253.904 245.663 260.909 219.979C267.914 194.296 266.217 167.015 256.084 142.397C245.951 117.779 227.951 97.2094 204.896 83.8989L216.947 63.0257C244.609 79.0025 266.203 103.688 278.358 133.23C290.513 162.772 292.544 195.506 284.136 226.324C275.727 257.142 257.351 284.308 231.877 303.583C206.403 322.858 175.264 333.155 143.321 332.869C111.378 332.582 80.4282 321.727 55.3038 301.999C30.1795 282.271 12.2941 254.779 4.43971 223.815C-3.41469 192.851 -0.79612 160.158 11.8867 130.839C24.5695 101.521 46.6027 77.2262 74.5469 61.7483L86.2609 82.8384Z'
			fill='black'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M132.586 168.721V0H156.689V168.721H132.586Z'
			fill='black'
		/>
	</svg>
);

export const PlusSVG = ({ color }: { color?: string }) => (
	<svg
		width='15'
		height='15'
		viewBox='0 0 15 15'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7.5 15C3.3665 15 0 11.6335 0 7.5C0 3.3665 3.3665 0 7.5 0C11.6335 0 15 3.3665 15 7.5C15 11.6335 11.6335 15 7.5 15ZM7.5 1C3.91667 1 1 3.91667 1 7.5C1 11.0833 3.91667 14 7.5 14C11.0833 14 14 11.0833 14 7.5C14 3.91667 11.0833 1 7.5 1ZM7.5 10.8333C7.2168 10.8333 7 10.6165 7 10.3333V8H4.66667C4.38347 8 4.16667 7.7832 4.16667 7.5C4.16667 7.2168 4.38347 7 4.66667 7H7V4.66667C7 4.38347 7.2168 4.16667 7.5 4.16667C7.7832 4.16667 8 4.38347 8 4.66667V7H10.3333C10.6165 7 10.8333 7.2168 10.8333 7.5C10.8333 7.7832 10.6165 8 10.3333 8H8V10.3333C8 10.6165 7.7832 10.8333 7.5 10.8333Z'
			fill={color || 'black'}
		/>
	</svg>
);

export const MinusSVG = ({ color }: { color?: string }) => (
	<svg
		width='15'
		height='15'
		viewBox='0 0 15 15'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7.5 0C3.364 0 0 3.3648 0 7.5C0 11.636 3.364 15 7.5 15C11.636 15 15 11.636 15 7.5C15 3.3648 11.636 0 7.5 0ZM7.5 14.1664C3.8242 14.1664 0.8336 11.1758 0.8336 7.5C0.8336 3.8242 3.8242 0.8336 7.5 0.8336C11.1758 0.8336 14.1664 3.8242 14.1664 7.5C14.1664 11.1758 11.1758 14.1664 7.5 14.1664Z'
			fill={color || 'black'}
		/>
		<path
			d='M9.58358 7.08203H5.41718C5.18672 7.08203 5 7.26875 5 7.49843C5 7.72811 5.18672 7.91483 5.4164 7.91483H9.5828C9.81248 7.91483 9.9992 7.72811 9.9992 7.49843C9.99998 7.26875 9.81326 7.08203 9.58358 7.08203Z'
			fill={color || 'black'}
		/>
	</svg>
);

export const StatusSVG = ({ color }: { color?: string }) => (
	<svg
		width='14'
		height='12'
		viewBox='0 0 14 12'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7.41176 0C4.30588 0 1.73647 2.37176 1.44 5.40706H0.592941C0.268235 5.40706 0 5.67529 0 6C0 6.32471 0.268235 6.59294 0.592941 6.59294H5.16706C5.39294 6.59294 5.59059 6.46588 5.68941 6.26824L6.18353 5.30823L7.69412 8.23059C7.79294 8.42824 7.99059 8.55529 8.21647 8.55529C8.44235 8.55529 8.64 8.42824 8.73882 8.23059L9.58588 6.57882H10.4329C10.7576 6.57882 11.0259 6.31059 11.0259 5.98588C11.0259 5.66118 10.7576 5.39294 10.4329 5.39294H9.23294C9.00706 5.39294 8.80941 5.52 8.71059 5.71765L8.21647 6.67765L6.70588 3.76941C6.50824 3.37412 5.85882 3.37412 5.66118 3.76941L4.81412 5.42118H2.62588C2.92235 3.03529 4.95529 1.18588 7.41176 1.18588C10.0659 1.18588 12.24 3.34588 12.24 6.01412C12.24 8.68235 10.0659 10.8282 7.41176 10.8282C5.40706 10.8282 3.67059 9.58588 2.95059 7.83529H1.69412C2.47059 10.2494 4.74353 12 7.41176 12C10.7153 12 13.4118 9.30353 13.4118 6C13.4118 2.69647 10.7153 0 7.41176 0Z'
			fill='black'
		/>
	</svg>
);

export const ViolationSVG = ({ color }: { color?: string }) => (
	<svg
		width='13'
		height='12'
		viewBox='0 0 13 12'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M10.4002 0.571195L10.1145 0.285709L10.2571 0L8.25781 0.286155L8.40044 0.571641L10.4002 0.571195Z'
			fill='black'
		/>
		<path
			d='M9.91288 2.08044C10.3408 1.75991 10.4493 1.1722 10.1825 0.722656H8.3984C8.1917 1.07243 8.20197 1.52666 8.46023 1.87174C8.80352 2.32999 9.45463 2.42374 9.91288 2.08044Z'
			fill='black'
		/>
		<path
			d='M11.7659 2.35066C11.6342 2.35066 11.5134 2.39798 11.4197 2.477L10.0898 3.80488L8.48424 2.19977C8.3617 2.08214 8.1963 2.00781 8.01081 2.00781L5.49345 2.00848C5.33118 2.00848 5.18721 2.08259 5.09078 2.19754L3.6321 3.87809L3.12988 3.47564C3.05443 3.41515 2.94394 3.42721 2.88345 3.50287C2.82296 3.57854 2.83502 3.68881 2.91069 3.7493L3.40219 4.14326L3.35242 4.20063C3.24394 4.29616 3.17631 4.43545 3.17631 4.59147C3.17631 4.87941 3.40889 5.11289 3.69839 5.11289C3.86067 5.11289 4.00598 5.0399 4.10107 4.92204L4.21289 4.79281L5.57939 5.88765C5.65483 5.94814 5.76532 5.93609 5.82581 5.86042C5.8863 5.78475 5.87425 5.67449 5.79858 5.614L4.44258 4.52741L5.71398 3.05936L6.64321 3.0636L5.07114 4.88633L5.86911 5.52583C5.92916 5.57382 5.96688 5.64257 5.97536 5.71913C5.98384 5.79569 5.96197 5.87069 5.91398 5.93073C5.85884 5.99948 5.77693 6.03876 5.68898 6.03876C5.6238 6.03876 5.55974 6.01622 5.50885 5.97537L4.69771 5.32539L4.69436 5.32271L3.09059 7.18227L0.687513 7.17557C0.632157 7.17401 0.575908 7.17848 0.519212 7.19165C0.158282 7.27178 -0.0655981 7.62579 0.0172129 7.98694C0.087524 8.30323 0.370554 8.51707 0.682825 8.51149L3.47652 8.5068C4.06736 8.52823 4.29057 8.25234 4.29057 8.25234L5.668 6.71643L7.26864 8.27332L6.61999 11.1621C6.60459 11.2155 6.59834 11.2724 6.59834 11.3306C6.59834 11.7007 6.89834 12.0009 7.26886 12.0009C7.59163 12.0009 7.8626 11.7712 7.92532 11.4654L8.71504 7.94453C8.88513 7.39544 8.58826 7.11977 8.58826 7.11977L7.17869 5.71042L8.71705 3.93166L9.70096 4.9207C9.70096 4.9207 10.0931 5.3332 10.58 4.84727L12.184 3.23078C12.2603 3.1377 12.3052 3.02007 12.3052 2.88972C12.3047 2.59262 12.0641 2.35066 11.7659 2.35066Z'
			fill='black'
		/>
	</svg>
);

export const TransactionSVG = ({ color }: { color?: string }) => (
	<svg
		width='9'
		height='11'
		viewBox='0 0 9 11'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7.46662 0.131021C7.26856 -0.0850643 6.98664 -0.0278446 6.83704 0.25824C6.68786 0.544323 6.72706 0.951546 6.92554 1.16763L7.6415 1.94798H0.453551C0.20534 1.94798 0.00390625 2.23833 0.00390625 2.59686C0.00390625 2.95539 0.20534 3.24635 0.453551 3.24635H8.31025C8.88421 3.24635 9.25421 2.22313 8.78687 1.57479L8.76748 1.54801L7.46662 0.131021Z'
			fill='black'
		/>
		<path
			d='M1.53242 10.256C1.73048 10.472 2.01241 10.4148 2.162 10.1287C2.31118 9.84265 2.27157 9.43543 2.07351 9.21934L1.35712 8.43899H8.5455C8.79371 8.43899 8.99515 8.14864 8.99515 7.79011C8.99515 7.43159 8.79371 7.14062 8.5455 7.14062H0.6888C0.114845 7.14062 -0.255152 8.16385 0.212185 8.81218L0.23157 8.83896L1.53242 10.256Z'
			fill='black'
		/>
	</svg>
);

export const MenuToggleSVG = ({ color }: { color?: string }) => {
	const stroke = '#000';
	return (
		<svg
			width='21'
			height='14'
			viewBox='0 0 21 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<rect
				x='0.5'
				y='0.5'
				width='20'
				height='13'
				rx='2.5'
				fill='white'
				stroke={stroke}
			/>
			<line
				x1='5.5'
				x2='5.5'
				y2='13'
				stroke={stroke}
			/>
			<path
				d='M13.4749 9.59597L11 7.12109L13.4749 4.64622'
				stroke={stroke}
			/>
		</svg>
	);
};

export const SwitchOffSVG = ({ color }: { color?: string }) => (
	<svg
		width='11'
		height='12'
		viewBox='0 0 11 12'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M5.17762 12C4.15424 12.0004 3.15371 11.6974 2.3025 11.1293C1.45129 10.5612 0.7876 9.75348 0.395325 8.80827C0.00304991 7.86306 -0.100204 6.82277 0.0986137 5.81889C0.297432 4.81501 0.789396 3.8926 1.51233 3.16826C1.5637 3.11587 1.62494 3.07416 1.69251 3.04553C1.76007 3.01691 1.83264 3.00194 1.90601 3.00148C1.97939 3.00102 2.05214 3.01509 2.12006 3.04287C2.18797 3.07064 2.24973 3.11158 2.30175 3.16333C2.35378 3.21508 2.39506 3.27661 2.4232 3.34437C2.45135 3.41214 2.4658 3.48481 2.46574 3.55819C2.46568 3.63157 2.4511 3.70421 2.42285 3.77193C2.39459 3.83965 2.35321 3.90111 2.3011 3.95277C1.73429 4.52132 1.34867 5.24509 1.19295 6.03266C1.03723 6.82023 1.11839 7.63629 1.42619 8.37777C1.73398 9.11924 2.2546 9.75288 2.92229 10.1986C3.58998 10.6444 4.3748 10.8823 5.17762 10.8823C5.98044 10.8823 6.76525 10.6444 7.43295 10.1986C8.10064 9.75288 8.62125 9.11924 8.92905 8.37777C9.23684 7.63629 9.318 6.82023 9.16228 6.03266C9.00656 5.24509 8.62094 4.52132 8.05413 3.95277C7.95132 3.84793 7.89413 3.70668 7.89505 3.55983C7.89596 3.41299 7.95491 3.27246 8.05903 3.16891C8.16314 3.06535 8.30398 3.00717 8.45083 3.00705C8.59768 3.00692 8.73862 3.06488 8.84291 3.16826C9.56552 3.89272 10.0572 4.81511 10.2558 5.81888C10.4545 6.82266 10.3512 7.86279 9.95895 8.80787C9.56673 9.75296 8.9032 10.5606 8.05218 11.1287C7.20117 11.6969 6.20086 12.0001 5.17762 12ZM5.17762 5.20619C5.02573 5.20602 4.8801 5.14561 4.7727 5.03821C4.6653 4.9308 4.60488 4.78518 4.60471 4.63329V0.572903C4.60471 0.42096 4.66507 0.27524 4.77251 0.167799C4.87995 0.0603593 5.02567 0 5.17762 0C5.32956 0 5.47528 0.0603593 5.58272 0.167799C5.69016 0.27524 5.75052 0.42096 5.75052 0.572903V4.63329C5.75035 4.78518 5.68993 4.9308 5.58253 5.03821C5.47513 5.14561 5.32951 5.20602 5.17762 5.20619Z'
			fill='red'
		/>
	</svg>
);

export const AdminManagementSVG = ({ color }: { color?: string }) => (
	<svg
		width='10'
		height='12'
		viewBox='0 0 10 12'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M9.47381 12C9.2715 12 9.09486 11.8357 9.09486 11.6211V8.84211C9.09486 7.51579 8.00834 6.42922 6.68198 6.42922H3.17078C1.84446 6.42922 0.757895 7.51574 0.757895 8.84211V11.6211C0.757895 11.8234 0.593583 12 0.378947 12C0.164312 12 0 11.8357 0 11.6211V8.84211C0 7.09882 1.41461 5.67133 3.17078 5.67133H6.6696C8.41288 5.67133 9.84038 7.08594 9.84038 8.84211V11.6211C9.83989 11.8357 9.67611 12 9.47381 12ZM7.51592 2.58947C7.51592 1.16198 6.35391 0 4.92644 0C3.49897 0 2.33697 1.162 2.33697 2.58947C2.33697 4.01694 3.49897 5.19183 4.92644 5.19183C6.35391 5.19183 7.51592 4.02933 7.51592 2.58947ZM6.77085 2.58947C6.77085 3.6 5.9498 4.43394 4.92639 4.43394C3.90298 4.43394 3.08193 3.61288 3.08193 2.58947C3.08193 1.57895 3.91581 0.757895 4.92639 0.757895C5.93697 0.757895 6.77085 1.57895 6.77085 2.58947Z'
			fill={color || 'black'}
		/>
	</svg>
);

export const OneColumnSVG = ({ color }: { color?: string }) => (
	<svg
		width='7'
		height='14'
		viewBox='0 0 7 19'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<rect
			x='0.5'
			y='0.5'
			width='5.92308'
			height='17.4615'
			rx='1.5'
			stroke={color || 'black'}
		/>
	</svg>
);

export const TwoColumnSVG = ({ color }: { color?: string }) => (
	<svg
		width='15'
		height='14'
		viewBox='0 0 15 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<rect
			x='0.5'
			y='1.26953'
			width='5.92308'
			height='17.4615'
			rx='1.5'
			stroke={color || 'black'}
		/>
		<rect
			x='8.57617'
			y='1.26953'
			width='5.92308'
			height='17.4615'
			rx='1.5'
			stroke={color || 'black'}
		/>
	</svg>
);

export const LicenseSVG = ({ color }: { color?: string }) => (
	<svg
		width='9'
		height='12'
		viewBox='0 0 9 12'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M8.99783 4.50146C8.99827 3.73055 8.8006 2.97245 8.42379 2.2999C8.04697 1.62735 7.50365 1.06291 6.84596 0.660733C6.18826 0.258553 5.43825 0.0321265 4.66788 0.00317432C3.8975 -0.0257778 3.13261 0.143716 2.44659 0.495395C1.76056 0.847075 1.17641 1.36914 0.750176 2.01151C0.323944 2.65388 0.0699297 3.395 0.0125014 4.16378C-0.0449268 4.93255 0.0961577 5.70319 0.422221 6.40176C0.748284 7.10032 1.24838 7.70338 1.87455 8.15309V11.6247C1.8745 11.6841 1.88855 11.7427 1.91556 11.7956C1.94258 11.8485 1.98177 11.8942 2.02991 11.929C2.07805 11.9638 2.13377 11.9866 2.19248 11.9956C2.25118 12.0047 2.31119 11.9996 2.36756 11.9809L4.49892 11.2705L6.63028 11.9809C6.66833 11.9937 6.70824 12 6.74838 11.9997C6.82715 11.9995 6.90389 11.9746 6.9677 11.9284C7.01581 11.8937 7.05499 11.8481 7.08204 11.7953C7.10909 11.7425 7.12322 11.6841 7.12329 11.6247V8.15309C7.70299 7.73675 8.17533 7.18846 8.50128 6.55352C8.82722 5.91857 8.99743 5.21519 8.99783 4.50146ZM6.37347 11.1055L4.61701 10.5188C4.54018 10.4943 4.45766 10.4943 4.38082 10.5188L2.62437 11.1055V8.58986C3.2123 8.86029 3.85178 9.00031 4.49892 9.00031C5.14606 9.00031 5.78554 8.86029 6.37347 8.58986V11.1055ZM4.49892 8.25056C3.75742 8.25056 3.03257 8.03068 2.41603 7.61872C1.79949 7.20677 1.31896 6.62124 1.0352 5.93618C0.751443 5.25112 0.677198 4.49731 0.821858 3.77005C0.966517 3.0428 1.32358 2.37477 1.8479 1.85045C2.37223 1.32613 3.04025 0.969064 3.7675 0.824405C4.49476 0.679745 5.24858 0.753989 5.93363 1.03775C6.61869 1.32151 7.20422 1.80204 7.61618 2.41858C8.02813 3.03511 8.24801 3.75996 8.24801 4.50146C8.24801 5.49579 7.85302 6.44938 7.14993 7.15248C6.44684 7.85557 5.49324 8.25056 4.49892 8.25056Z'
			fill='black'
		/>
	</svg>
);

export const UploadSVG = ({ color }: { color?: string }) => (
	<svg
		width='22'
		height='22'
		viewBox='0 0 22 22'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M2.75 21.5H18.75C19.4792 21.4995 20.1783 21.2096 20.694 20.694C21.2096 20.1783 21.4995 19.4792 21.5 18.75V15.75C21.5 15.5511 21.421 15.3603 21.2803 15.2197C21.1397 15.079 20.9489 15 20.75 15C20.5511 15 20.3603 15.079 20.2197 15.2197C20.079 15.3603 20 15.5511 20 15.75V18.75C19.9995 19.0814 19.8676 19.399 19.6333 19.6333C19.399 19.8676 19.0814 19.9995 18.75 20H2.75C2.41864 19.9995 2.10101 19.8676 1.8667 19.6333C1.63239 19.399 1.50053 19.0814 1.5 18.75V15.75C1.5 15.5511 1.42098 15.3603 1.28033 15.2197C1.13968 15.079 0.948912 15 0.75 15C0.551088 15 0.360322 15.079 0.21967 15.2197C0.0790177 15.3603 0 15.5511 0 15.75V18.75C0.000529737 19.4792 0.290431 20.1783 0.806041 20.694C1.32165 21.2096 2.02082 21.4995 2.75 21.5Z'
			fill={color || 'black'}
		/>
		<path
			d='M10.75 15.5C10.9489 15.5 11.1396 15.421 11.2803 15.2803C11.4209 15.1397 11.5 14.9489 11.5 14.75V2.35L16.27 6.325C16.4233 6.4467 16.6182 6.50359 16.813 6.48353C17.0078 6.46346 17.187 6.36803 17.3123 6.21762C17.4377 6.0672 17.4992 5.87373 17.4838 5.67854C17.4684 5.48335 17.3773 5.30192 17.23 5.173L11.23 0.173C11.1934 0.146641 11.1542 0.124185 11.113 0.106C11.0838 0.08616 11.053 0.0687675 11.021 0.054C10.9372 0.020521 10.8481 0.00256161 10.758 0.00100005L10.75 0H10.742C10.6518 0.00156156 10.5627 0.0195209 10.479 0.053C10.4469 0.0677675 10.4161 0.0851601 10.387 0.105C10.3457 0.123185 10.3065 0.145641 10.27 0.172L4.26997 5.172C4.1226 5.30092 4.0315 5.48235 4.01611 5.67754C4.00073 5.87273 4.06228 6.0662 4.18763 6.21662C4.31297 6.36703 4.49217 6.46246 4.68693 6.48253C4.8817 6.50259 5.07659 6.4457 5.22997 6.324L9.99997 2.35V14.75C9.99997 14.9489 10.079 15.1397 10.2196 15.2803C10.3603 15.421 10.5511 15.5 10.75 15.5Z'
			fill={color || 'black'}
		/>
	</svg>
);

export const VerificationSVG = ({ color }: { color?: string }) => (
	<svg
		width='11'
		height='12'
		viewBox='0 0 11 12'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M6.12412 5.39367C5.9456 5.57219 5.65616 5.57219 5.47764 5.39367C5.29912 5.21515 5.29912 4.92569 5.47764 4.74717C5.65616 4.56865 5.9456 4.56865 6.12412 4.74717C6.30264 4.92569 6.30264 5.21515 6.12412 5.39367Z'
			fill='black'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M4.06187 3.33295C5.02143 2.37339 6.57719 2.37339 7.53675 3.33295C8.49631 4.29251 8.49631 5.84827 7.53675 6.80783C6.91861 7.42599 6.05345 7.64545 5.26035 7.46793L4.30415 8.42413C3.79089 8.93737 2.95875 8.93737 2.44549 8.42413C1.93223 7.91087 1.93223 7.07871 2.44549 6.56545L3.40175 5.60921C3.22427 4.81615 3.44375 3.95105 4.06187 3.33295ZM6.97107 3.89863C6.32393 3.25149 5.27469 3.25149 4.62755 3.89863C4.16791 4.35827 4.03415 5.02125 4.22857 5.59983C4.27693 5.74377 4.23961 5.90269 4.13223 6.01007L3.01117 7.13115C2.81033 7.33197 2.81033 7.65759 3.01117 7.85843C3.21201 8.05927 3.53763 8.05927 3.73847 7.85843L4.85949 6.73741C4.96687 6.63003 5.12581 6.59273 5.26975 6.64111C5.84837 6.83557 6.51139 6.70183 6.97107 6.24215C7.61821 5.59501 7.61821 4.54577 6.97107 3.89863Z'
			fill='black'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M5.60198 0.051696C5.33836 -0.017232 5.06164 -0.017232 4.79802 0.051696L1.19802 0.99298C0.490266 1.17803 0 1.82123 0 2.55305V5.80643C0 8.14051 1.2481 10.2947 3.26718 11.4386L3.43716 11.5348C4.53196 12.1551 5.86804 12.1551 6.96284 11.5348L7.13282 11.4386C9.1519 10.2947 10.4 8.14051 10.4 5.80643V2.55305C10.4 1.82123 9.90974 1.17803 9.20198 0.99298L5.60198 0.051696ZM5.0004 0.825678C5.13132 0.791442 5.26868 0.791442 5.3996 0.825678L8.9996 1.76697C9.35072 1.85877 9.6 2.18035 9.6 2.55305V5.80643C9.6 7.85503 8.50456 9.74197 6.73848 10.7425L6.56852 10.8388C5.71834 11.3204 4.68166 11.3204 3.83148 10.8388L3.66152 10.7425C1.89544 9.74197 0.8 7.85503 0.8 5.80643V2.55305C0.8 2.18035 1.04928 1.85877 1.4004 1.76697L5.0004 0.825678Z'
			fill='black'
		/>
	</svg>
);

export const RemoveSVG = ({ color }: { color?: string }) => {
	const stroke = color || 'black';
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 16 10'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M13.5033 0H4.91492C4.68616 0.0006316 4.45982 0.0468039 4.24909 0.135823C4.03835 0.224843 3.84746 0.354928 3.68753 0.518493L0.48821 3.80616C0.175313 4.12475 0 4.55345 0 5C0 5.44655 0.175313 5.87525 0.48821 6.19384L3.68787 9.48151C3.84771 9.64509 4.03855 9.77519 4.24922 9.86422C4.4599 9.95324 4.68621 9.9994 4.91492 10H13.5033C13.9572 9.99946 14.3925 9.81888 14.7135 9.49787C15.0345 9.17686 15.2151 8.74164 15.2156 8.28767V1.71233C15.2151 1.25836 15.0345 0.823137 14.7135 0.50213C14.3925 0.181124 13.9572 0.000543787 13.5033 0ZM14.5307 8.29041C14.5307 8.56289 14.4224 8.82422 14.2298 9.01689C14.0371 9.20957 13.7758 9.31781 13.5033 9.31781H4.91492C4.77768 9.31737 4.64189 9.28962 4.51548 9.23617C4.38907 9.18273 4.27456 9.10466 4.17862 9.00651L0.979306 5.71884C0.791485 5.52767 0.686245 5.27039 0.686245 5.0024C0.686245 4.7344 0.791485 4.47713 0.979306 4.28596L4.17828 0.998288C4.2743 0.900161 4.38888 0.822106 4.51534 0.768663C4.6418 0.71522 4.77763 0.687456 4.91492 0.686986H13.5033C13.7758 0.686986 14.0371 0.79523 14.2298 0.987904C14.4224 1.18058 14.5307 1.4419 14.5307 1.71438V8.29041ZM10.2416 3.91164L9.15328 5L10.2416 6.08836C10.3059 6.15262 10.3419 6.23975 10.3419 6.3306C10.3418 6.42145 10.3057 6.50856 10.2415 6.57277C10.1772 6.63699 10.0901 6.67305 9.99922 6.67302C9.90837 6.67298 9.82126 6.63686 9.75705 6.5726L8.66903 5.48425L7.58102 6.5726C7.54922 6.60447 7.51146 6.62976 7.46989 6.64703C7.42832 6.6643 7.38376 6.67321 7.33874 6.67326C7.29373 6.6733 7.24915 6.66449 7.20754 6.6473C7.16594 6.63012 7.12812 6.60491 7.09626 6.57312C7.06439 6.54132 7.03911 6.50356 7.02183 6.46199C7.00456 6.42042 6.99565 6.37586 6.9956 6.33084C6.99556 6.28583 7.00438 6.24125 7.02156 6.19964C7.03874 6.15803 7.06395 6.12022 7.09574 6.08836L8.18479 5L7.09574 3.91164C7.03336 3.84705 6.99884 3.76055 6.99962 3.67075C7.0004 3.58096 7.03642 3.49507 7.09992 3.43157C7.16341 3.36807 7.24931 3.33206 7.3391 3.33128C7.42889 3.3305 7.5154 3.36501 7.57999 3.4274L8.668 4.51575L9.75602 3.4274C9.78782 3.39558 9.82557 3.37033 9.86712 3.35311C9.90867 3.33588 9.95321 3.327 9.99819 3.32699C10.0432 3.32697 10.0877 3.33581 10.1293 3.35301C10.1708 3.37021 10.2086 3.39543 10.2404 3.42723C10.2723 3.45902 10.2975 3.49677 10.3147 3.53833C10.332 3.57988 10.3408 3.62442 10.3408 3.6694C10.3409 3.71438 10.332 3.75893 10.3148 3.80049C10.2976 3.84206 10.2724 3.87983 10.2406 3.91164H10.2416Z'
				fill={stroke}
			/>
		</svg>
	);
};

export const ZoneSVG = ({ color }: { color?: string }) => (
	<svg
		width='16'
		height='20'
		viewBox='0 0 16 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M15.2809 5.88996L7.88636 0.869158L0.401441 5.88942L0 5.29113L7.88888 0L15.6854 5.29419L15.2809 5.88996Z'
			fill='black'
		/>
		<path
			d='M7.84201 7.75323C6.84894 7.75323 6.04102 6.9453 6.04102 5.95224C6.04102 4.95917 6.84894 4.15125 7.84201 4.15125C8.83507 4.15125 9.643 4.95917 9.643 5.95224C9.643 6.9453 8.83507 7.75323 7.84201 7.75323ZM7.84201 4.87164C7.24606 4.87164 6.76141 5.35629 6.76141 5.95224C6.76141 6.54818 7.24606 7.03283 7.84201 7.03283C8.43795 7.03283 8.9226 6.54818 8.9226 5.95224C8.9226 5.35629 8.43795 4.87164 7.84201 4.87164Z'
			fill='black'
		/>
		<path
			d='M6.85126 10.5448H6.13086V20H6.85126V10.5448Z'
			fill='black'
		/>
		<path
			d='M11.2637 14.1468H10.5433V10.0946C10.5433 9.54855 10.0988 9.10406 9.55275 9.10406H6.13086C5.5848 9.10406 5.14032 9.54855 5.14032 10.0946V14.1468H4.41992V10.0946C4.41992 9.15125 5.1875 8.38367 6.13086 8.38367H9.55275C10.4961 8.38367 11.2637 9.15125 11.2637 10.0946V14.1468Z'
			fill='black'
		/>
		<path
			d='M9.5534 10.5448H8.83301V20H9.5534V10.5448Z'
			fill='black'
		/>
	</svg>
);

export const StateSVG = ({ color }: { color?: string }) => (
	<svg
		width='22'
		height='20'
		viewBox='0 0 22 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M20.9901 20C21.0918 19.9983 21.1876 19.95 21.2493 19.8683C21.3109 19.7875 21.3326 19.6825 21.3068 19.5833L17.9734 7.91663C17.9359 7.77163 17.8068 7.66912 17.6568 7.66663H11.9235L11.5401 8.33329H13.1568L12.7068 9.39995L11.8401 9.53328C11.7285 9.55328 11.6343 9.62828 11.5901 9.73328L11.2568 10.5333C11.1976 10.6774 11.246 10.8433 11.3735 10.9333L12.2235 11.5499L11.5401 12.4666L10.7068 12.3333C10.5793 12.3091 10.4493 12.3608 10.3735 12.4666L8.64016 14.9666L8.4235 14.85V14.1666C8.42184 14.0783 8.386 13.995 8.3235 13.9333L7.62352 13.2333L8.52352 11.8667C8.59936 11.7483 8.59269 11.595 8.50686 11.4833L7.99019 10.75L8.44019 10.4667C8.52102 10.4133 8.57519 10.3275 8.58769 10.2317C8.60102 10.1358 8.57102 10.0392 8.50686 9.96667L7.85686 9.25L8.00685 8.35H8.39019L8.0402 7.68333H3.65686C3.50687 7.68583 3.3777 7.78833 3.34019 7.93334L0.00688207 19.6C-0.0131178 19.6967 0.0110487 19.7967 0.0718822 19.8734C0.133548 19.9509 0.225215 19.9967 0.32355 20L20.9901 20ZM12.1067 10.1667L12.9734 10.0333C13.0917 10.0192 13.1934 9.9425 13.2401 9.83333L13.8734 8.33335H17.4066L19.1399 14.4167L18.1066 13.9167L17.3899 12.6667C17.3416 12.5892 17.2633 12.5351 17.1733 12.5167L14.0398 11.8167L12.8232 11.1834L11.9399 10.5334L12.1067 10.1667ZM10.8067 13.0334L11.5901 13.1668C11.7126 13.1843 11.8342 13.1334 11.9067 13.0334L12.7401 11.9001L13.7734 12.4334L13.8567 12.4668L16.8735 13.1334L17.5734 14.3334C17.6043 14.3901 17.6501 14.4359 17.7068 14.4667L19.3734 15.2834L20.5234 19.3333H12.6069C12.6052 19.2866 12.5935 19.2416 12.5735 19.2L12.1235 18.15C12.0944 18.0791 12.041 18.02 11.9735 17.9833L10.1236 16.9666L10.3902 16.35C10.4561 16.1975 10.3994 16.0191 10.2569 15.9333L9.20689 15.3167L10.8067 13.0334ZM3.90673 8.3335H7.34009L7.17343 9.28349C7.15593 9.38599 7.18676 9.49015 7.25676 9.56681L7.75677 10.1168L7.32345 10.3668C7.24511 10.4176 7.19178 10.4985 7.17595 10.5901C7.16012 10.6818 7.18345 10.776 7.24011 10.8502L7.85677 11.6835L7.02345 12.9335H5.32345L4.55678 11.9668L4.24011 11.2668C4.19595 11.1618 4.10178 11.0868 3.99011 11.0668L3.15679 10.9002L3.90673 8.3335ZM2.99006 11.5501L3.70673 11.6835L3.97339 12.2668L4.00673 12.3335L4.89005 13.4668C4.95338 13.5509 5.05172 13.6001 5.15672 13.6001H7.07338L7.77336 14.3001V15.0501C7.77503 15.1676 7.83836 15.2751 7.94003 15.3334L9.69001 16.3501L9.42334 16.9667C9.35001 17.1284 9.41585 17.3184 9.57334 17.4L11.59 18.5167L11.94 19.3334H0.773334L2.99006 11.5501Z'
			fill='black'
		/>
		<path
			d='M9.94057 8.5347e-05C9.02391 8.5347e-05 8.14058 0.48341 7.52395 1.33341C7.12977 1.88758 6.89312 2.5384 6.84062 3.21673C6.78729 3.89506 6.91979 4.57505 7.22396 5.18339C7.45062 5.61006 7.7123 6.01756 8.00729 6.40005C8.21729 6.67838 8.41228 6.96755 8.59063 7.26671C8.99063 7.96669 9.33646 8.69669 9.62397 9.44995C9.67063 9.57578 9.78897 9.66161 9.92395 9.66661C10.0548 9.66411 10.1715 9.58661 10.2239 9.46661C10.5489 8.72078 10.9214 7.99745 11.3406 7.30001C11.5156 7.02334 11.7048 6.75667 11.9073 6.50001C12.2223 6.10919 12.5006 5.69084 12.7406 5.25002C13.0764 4.58169 13.2022 3.82835 13.1014 3.08747C12.9997 2.34663 12.6764 1.6533 12.1739 1.09998C11.6181 0.434152 10.8073 0.0342398 9.94057 8.5347e-05ZM12.1739 4.93339C11.9523 5.33838 11.6956 5.72338 11.4073 6.08338C11.1923 6.36171 10.9914 6.65088 10.8073 6.95004C10.4406 7.56669 10.1573 8.10002 9.97396 8.50002C9.79063 8.10002 9.54064 7.55003 9.19062 6.95004C8.99729 6.62754 8.78564 6.31587 8.55728 6.01671C8.28228 5.66505 8.03729 5.29172 7.82396 4.90004C7.57395 4.3992 7.46562 3.84004 7.50978 3.28173C7.55395 2.72423 7.74895 2.18923 8.07394 1.73341C8.57395 1.05008 9.24061 0.666748 9.95725 0.666748C10.6431 0.690082 11.2856 1.00507 11.7239 1.53341C12.5614 2.46507 12.7406 3.81574 12.1739 4.93339Z'
			fill='black'
		/>
		<path
			d='M9.98985 1.83345C9.35402 1.84012 8.81153 2.29512 8.69403 2.91927C8.57653 3.54427 8.9157 4.16508 9.50569 4.40342C10.0949 4.64092 10.7699 4.42925 11.119 3.89842C11.4673 3.36675 11.3923 2.66259 10.9399 2.21677C10.6882 1.96593 10.3457 1.82763 9.98985 1.83345ZM9.98985 3.83344C9.62151 3.83344 9.32319 3.53511 9.32319 3.16678C9.32319 2.79844 9.62151 2.50011 9.98985 2.50011C10.3582 2.50011 10.6565 2.79844 10.6565 3.16678C10.6565 3.53511 10.3582 3.83344 9.98985 3.83344Z'
			fill='black'
		/>
	</svg>
);

export const LGASVG = ({ color }: { color?: string }) => (
	<svg
		width='14'
		height='20'
		viewBox='0 0 14 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7.32673 14.2668V10.47C9.98857 10.2195 12.0792 7.97395 12.0792 5.24752C12.0792 2.354 9.72502 0 6.83168 0C3.93835 0 1.58416 2.354 1.58416 5.24752C1.58416 7.97395 3.6748 10.2195 6.33663 10.47V14.2668C3.17854 14.3615 0 15.3565 0 17.1287C0 18.9937 3.51988 20 6.83168 20C10.1435 20 13.6634 18.9937 13.6634 17.1287C13.6634 15.3565 10.4848 14.3615 7.32673 14.2668ZM2.57426 5.24752C2.57426 2.89991 4.48407 0.990099 6.83168 0.990099C9.1793 0.990099 11.0891 2.89991 11.0891 5.24752C11.0891 7.59514 9.1793 9.50495 6.83168 9.50495C4.48407 9.50495 2.57426 7.59514 2.57426 5.24752ZM6.83168 19.0099C3.26578 19.0099 0.990099 17.8957 0.990099 17.1287C0.990099 16.3981 3.05814 15.3546 6.33663 15.2571V17.1287C6.33663 17.4022 6.55825 17.6238 6.83168 17.6238C7.10512 17.6238 7.32673 17.4022 7.32673 17.1287V15.2571C10.6052 15.3546 12.6733 16.3981 12.6733 17.1287C12.6733 17.8957 10.3976 19.0099 6.83168 19.0099Z'
			fill='black'
		/>
	</svg>
);

export const WardSVG = ({ color }: { color?: string }) => (
	<svg
		width='21'
		height='20'
		viewBox='0 0 21 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M8.08497 20H1.94482C0.872513 20 0.00488281 19.1279 0.00488281 18.0601V13.1302C0.00488281 12.9566 0.142814 12.8187 0.31634 12.8187C0.489866 12.8187 0.627797 12.9566 0.627797 13.1302V18.0601C0.627797 18.7853 1.21957 19.3771 1.94482 19.3771H8.08497C8.2585 19.3771 8.39643 19.515 8.39643 19.6886C8.39643 19.8621 8.2585 20 8.08497 20Z'
			fill='black'
		/>
		<path
			d='M18.4739 19.7998H13.9221C13.7486 19.7998 13.6107 19.6618 13.6107 19.4883C13.6107 19.3148 13.7486 19.1769 13.9221 19.1769H18.4739C19.1991 19.1769 19.7909 18.5851 19.7909 17.8598V1.93993C19.7909 1.21468 19.1991 0.622914 18.4739 0.622914H1.94438C1.21468 0.622914 0.622914 1.21468 0.622914 1.93993V9.10345C0.622914 9.27697 0.484983 9.4149 0.311457 9.4149C0.137931 9.4149 0 9.27697 0 9.10345V1.93993C0 0.86763 0.87208 0 1.93993 0H18.4694C19.5417 0 20.4093 0.872079 20.4093 1.93993V17.8554C20.4138 18.9277 19.5417 19.7998 18.4739 19.7998Z'
			fill='black'
		/>
		<path
			d='M12.1911 20H8.32904C8.15551 20 8.01758 19.8621 8.01758 19.6885V13.5751C8.01758 13.4015 8.15551 13.2636 8.32904 13.2636H12.1911C12.3646 13.2636 12.5026 13.4015 12.5026 13.5751V19.6885C12.5026 19.8621 12.3646 20 12.1911 20ZM8.64494 19.3771H11.8796V13.8865H8.64049V19.3771H8.64494Z'
			fill='black'
		/>
		<path
			d='M10.247 9.40601C10.0735 9.40601 9.93555 9.26808 9.93555 9.09455V4.11569C9.93555 3.94216 10.0735 3.80423 10.247 3.80423C10.4205 3.80423 10.5585 3.94216 10.5585 4.11569V9.09455C10.5585 9.26363 10.4161 9.40601 10.247 9.40601Z'
			fill='black'
		/>
		<path
			d='M12.7347 6.91436H7.75579C7.58227 6.91436 7.44434 6.77643 7.44434 6.6029C7.44434 6.42937 7.58227 6.29144 7.75579 6.29144H12.7347C12.9082 6.29144 13.0461 6.42937 13.0461 6.6029C13.0461 6.77643 12.9082 6.91436 12.7347 6.91436Z'
			fill='black'
		/>
		<path
			d='M10.2691 10.4916C8.07999 10.4916 6.30469 8.71189 6.30469 6.52724C6.30469 4.34259 8.08444 2.56284 10.2691 2.56284C12.4537 2.56284 14.2335 4.34259 14.2335 6.52724C14.2335 8.71189 12.4537 10.4916 10.2691 10.4916ZM10.2691 3.18575C8.42705 3.18575 6.9276 4.68519 6.9276 6.52724C6.9276 8.36929 8.42705 9.86873 10.2691 9.86873C12.1111 9.86873 13.6106 8.36929 13.6106 6.52724C13.6106 4.68519 12.1111 3.18575 10.2691 3.18575Z'
			fill='black'
		/>
		<path
			d='M5.59772 17.0456H3.01263C2.8391 17.0456 2.70117 16.9077 2.70117 16.7341C2.70117 16.5606 2.8391 16.4227 3.01263 16.4227H5.28627V14.149C5.28627 13.9755 5.4242 13.8376 5.59772 13.8376C5.77125 13.8376 5.90918 13.9755 5.90918 14.149V16.7341C5.90918 16.9032 5.7668 17.0456 5.59772 17.0456Z'
			fill='black'
		/>
		<path
			d='M17.5264 17.0456H14.9413C14.7678 17.0456 14.6299 16.9077 14.6299 16.7341C14.6299 16.5606 14.7678 16.4227 14.9413 16.4227H17.215V14.149C17.215 13.9755 17.3529 13.8376 17.5264 13.8376C17.7 13.8376 17.8379 13.9755 17.8379 14.149V16.7341C17.8379 16.9032 17.7 17.0456 17.5264 17.0456Z'
			fill='black'
		/>
	</svg>
);

export const PollingSVG = ({ color }: { color?: string }) => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M3.29428 1.10016L1.98998 0.721313L0.721313 5.08716L2.02562 5.46626C2.44902 4.01098 2.87089 2.55544 3.29428 1.10016ZM7.53869 13.1348C7.71716 13.1348 7.86203 13.2796 7.86203 13.4581C7.86203 13.6366 7.71716 13.7814 7.53869 13.7814H6.09766L3.93307 17.0378H18.1684L15.9071 13.6361C15.8088 13.4876 15.8495 13.2875 15.998 13.1892C16.1464 13.091 16.3465 13.1317 16.4448 13.2801L19.0259 17.1628C19.0684 17.2178 19.0939 17.2865 19.0939 17.3611V19.6767C19.0939 19.8551 18.949 20 18.7705 20H3.33095C3.15247 20 3.00761 19.8551 3.00761 19.6767V17.3611C3.00761 17.2865 3.03307 17.2178 3.07558 17.1628L5.64372 13.2997C5.69896 13.2015 5.80462 13.1348 5.92556 13.1348H7.53869ZM18.4472 17.6844H3.65429V19.3533H18.4472V17.6844ZM14.8704 15.0863C15.0488 15.0863 15.1937 15.2311 15.1937 15.4096C15.1937 15.5881 15.0488 15.7329 14.8704 15.7329H7.65097C7.47249 15.7329 7.32763 15.5881 7.32763 15.4096C7.32763 15.2311 7.47249 15.0863 7.65097 15.0863H8.92651L6.91976 7.81417C6.54932 7.67643 6.21274 7.56619 5.93498 7.50712C4.12631 7.12293 3.70139 6.75606 2.65244 5.61775L2.55442 5.95509C2.50503 6.12592 2.3263 6.2242 2.15547 6.17481L0.232485 5.61596C0.0616493 5.56657 -0.0366256 5.38784 0.0127664 5.21701L1.46118 0.232485C1.51057 0.0616493 1.6893 -0.0366256 1.86013 0.0127665L3.78311 0.571355C3.95395 0.620747 4.05222 0.799475 4.00283 0.97031L3.92314 1.24477L9.86979 2.68528C10.3451 2.79247 10.7268 2.94778 11.0852 3.18939C11.4394 3.42846 11.7648 3.74849 12.1316 4.18818L16.0942 8.75771C16.6826 9.43621 16.9685 9.94261 17.0248 10.2957C17.0736 10.6025 16.9802 10.8271 16.7709 10.9753C16.6029 11.0949 16.3689 11.1402 16.0873 11.1186C15.6102 11.0822 14.9256 10.8482 14.1738 10.4663L15.2227 13.7769C15.2762 13.9469 15.182 14.1287 15.0119 14.1822L11.7342 15.0863H14.8704ZM9.79341 6.58522C9.61774 6.5567 9.49833 6.39096 9.52685 6.21529C9.55536 6.03962 9.72111 5.92021 9.89678 5.94872C10.0238 5.9696 10.2743 6.05235 10.5788 6.18015L12.5785 6.17506C12.7223 6.17506 12.8445 6.26977 12.8855 6.40013L13.8917 9.57548C14.7919 10.1053 15.6237 10.4358 16.1352 10.4745C16.2684 10.4846 16.3603 10.4768 16.3997 10.449L16.3883 10.3966C16.3501 10.1565 16.111 9.76057 15.6069 9.17932L11.6367 4.60215C11.3085 4.2088 11.0239 3.92671 10.7242 3.72455C10.4337 3.52877 10.1208 3.40198 9.72824 3.31338L3.74314 1.8642L2.86299 4.89316L2.91595 4.95095C4.01989 6.15469 4.34527 6.5096 6.0689 6.87572C6.74562 7.01931 7.73091 7.43634 8.38319 7.70367C9.57038 8.19046 10.8342 8.70857 11.5906 8.71112L11.6359 8.71137C11.9753 8.7129 12.3127 8.71442 12.386 8.3753C12.4046 8.13827 12.1319 7.8465 11.7648 7.57026C11.4111 7.30421 10.3164 6.67102 9.79341 6.58522ZM7.6693 8.10772L9.57471 15.0132L14.5058 13.6526L12.9509 8.7437C12.72 9.36034 12.1787 9.35805 11.6334 9.3555L11.5893 9.35525C10.7051 9.35194 9.38173 8.80914 8.13827 8.29943L7.6693 8.10772ZM12.514 7.36404L12.3417 6.81971L11.8126 6.82123C11.9303 6.89634 12.0443 6.97425 12.1512 7.05495C12.2824 7.15348 12.4048 7.25685 12.514 7.36404Z'
			fill='black'
		/>
	</svg>
);

export const OverviewSVG = ({ color }: { color?: string }) => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7.03699 0H1.85184C0.829625 0 0 0.829625 0 1.85184V7.03699C0 8.05921 0.829625 8.88884 1.85184 8.88884H7.03699C8.05921 8.88884 8.88884 8.05921 8.88884 7.03699V1.85184C8.88884 0.829625 8.05921 0 7.03699 0ZM8.1481 7.03711C8.1481 7.64821 7.6481 8.14822 7.03699 8.14822H1.85184C1.24074 8.14822 0.740736 7.64821 0.740736 7.03711V1.85196C0.740736 1.24086 1.24074 0.740855 1.85184 0.740855H7.03699C7.6481 0.740855 8.1481 1.24086 8.1481 1.85196V7.03711Z'
			fill='black'
		/>
		<path
			d='M18.1483 0H12.9632C11.941 0 11.1113 0.829625 11.1113 1.85184V7.03699C11.1113 8.05921 11.941 8.88884 12.9632 8.88884H18.1483C19.1705 8.88884 20.0002 8.05921 20.0002 7.03699V1.85184C20.0002 0.829625 19.1705 0 18.1483 0ZM19.2594 7.03711C19.2594 7.64821 18.7594 8.14822 18.1483 8.14822H12.9632C12.3521 8.14822 11.8521 7.64821 11.8521 7.03711V1.85196C11.8521 1.24086 12.3521 0.740855 12.9632 0.740855H18.1483C18.7594 0.740855 19.2594 1.24086 19.2594 1.85196V7.03711Z'
			fill='black'
		/>
		<path
			d='M7.03699 11.1111H1.85184C0.829625 11.1111 0 11.9408 0 12.963V18.1481C0 19.1704 0.829625 20 1.85184 20H7.03699C8.05921 20 8.88884 19.1704 8.88884 18.1481V12.963C8.88884 11.9408 8.05921 11.1111 7.03699 11.1111ZM8.1481 18.1483C8.1481 18.7594 7.6481 19.2594 7.03699 19.2594H1.85184C1.24074 19.2594 0.740736 18.7594 0.740736 18.1483V12.9631C0.740736 12.352 1.24074 11.852 1.85184 11.852H7.03699C7.6481 11.852 8.1481 12.352 8.1481 12.9631V18.1483Z'
			fill='black'
		/>
		<path
			d='M18.1483 11.1111H12.9632C11.941 11.1111 11.1113 11.9408 11.1113 12.963V18.1481C11.1113 19.1704 11.941 20 12.9632 20H18.1483C19.1705 20 20.0002 19.1704 20.0002 18.1481V12.963C20.0002 11.9408 19.1705 11.1111 18.1483 11.1111ZM19.2594 18.1483C19.2594 18.7594 18.7594 19.2594 18.1483 19.2594H12.9632C12.3521 19.2594 11.8521 18.7594 11.8521 18.1483V12.9631C11.8521 12.352 12.3521 11.852 12.9632 11.852H18.1483C18.7594 11.852 19.2594 12.352 19.2594 12.9631V18.1483Z'
			fill='black'
		/>
	</svg>
);

export const VerificationRequestSVG = ({ color }: { color?: string }) => (
	<svg
		width='18'
		height='20'
		viewBox='0 0 18 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M10.2049 8.98815C9.90738 9.28568 9.42498 9.28568 9.12745 8.98815C8.82991 8.69062 8.82991 8.20818 9.12745 7.91065C9.42498 7.61312 9.90738 7.61312 10.2049 7.91065C10.5024 8.20818 10.5024 8.69062 10.2049 8.98815Z'
			fill='black'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M6.77109 5.5537C8.37036 3.95443 10.9633 3.95443 12.5626 5.5537C14.1618 7.15297 14.1618 9.7459 12.5626 11.3452C11.5323 12.3754 10.0904 12.7412 8.76856 12.4453L7.17489 14.039C6.31946 14.8944 4.93256 14.8944 4.07712 14.039C3.22169 13.1836 3.22169 11.7966 4.07712 10.9412L5.67089 9.34747C5.37509 8.0257 5.74089 6.58387 6.77109 5.5537ZM11.6198 6.4965C10.5412 5.41793 8.79246 5.41793 7.71389 6.4965C6.94782 7.26257 6.72489 8.36753 7.04892 9.33183C7.12952 9.57173 7.06732 9.8366 6.88836 10.0156L5.01992 11.884C4.68519 12.2187 4.68519 12.7614 5.01992 13.0962C5.35466 13.4309 5.89736 13.4309 6.23209 13.0962L8.10046 11.2278C8.27942 11.0488 8.54432 10.9867 8.78422 11.0673C9.74859 11.3914 10.8536 11.1685 11.6198 10.4024C12.6983 9.3238 12.6983 7.57507 11.6198 6.4965Z'
			fill='black'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M9.33664 0.08616C8.89727 -0.02872 8.43607 -0.02872 7.9967 0.08616L1.9967 1.65497C0.81711 1.96339 0 3.03538 0 4.25509V9.67739C0 13.5675 2.08017 17.1579 5.4453 19.0643L5.7286 19.2247C7.55327 20.2584 9.78007 20.2584 11.6047 19.2247L11.888 19.0643C15.2532 17.1579 17.3333 13.5675 17.3333 9.67739V4.25509C17.3333 3.03538 16.5162 1.96339 15.3366 1.65497L9.33664 0.08616ZM8.334 1.37613C8.5522 1.31907 8.78114 1.31907 8.99934 1.37613L14.9993 2.94495C15.5845 3.09795 16 3.63392 16 4.25509V9.67739C16 13.0917 14.1743 16.2366 11.2308 17.9041L10.9475 18.0646C9.53057 18.8674 7.80277 18.8674 6.3858 18.0646L6.10254 17.9041C3.15907 16.2366 1.33333 13.0917 1.33333 9.67739V4.25509C1.33333 3.63392 1.7488 3.09795 2.334 2.94495L8.334 1.37613Z'
			fill='black'
		/>
	</svg>
);

export const PresidingOfficerSVG = ({ color }: { color?: string }) => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M13.125 12.5H4.375C3.34375 12.5 2.5 11.6562 2.5 10.625V3.75H1.25V10.625C1.25 12.35 2.65 13.75 4.375 13.75H13.125C13.5938 13.75 14.0375 13.8625 14.4375 14.05L10.625 17.8625L11.5062 18.7437L15.45 14.8C15.9437 15.35 16.25 16.0687 16.25 16.8687V18.7437H17.5V16.8687C17.5 14.4562 15.5375 12.4937 13.125 12.4937V12.5Z'
			fill='black'
		/>
		<path
			d='M7.5 15H6.25V18.75H7.5V15Z'
			fill='black'
		/>
		<path
			d='M15.7939 2.525L11.4189 1.275C11.3064 1.24375 11.1876 1.24375 11.0751 1.275L6.70014 2.525C6.37514 2.61875 6.18139 2.95 6.26264 3.275L6.86889 5.7V6.875C6.86889 9.2875 8.83139 11.25 11.2439 11.25C13.6564 11.25 15.6189 9.2875 15.6189 6.875V5.7L16.2251 3.275C16.3064 2.95 16.1126 2.6125 15.7876 2.525H15.7939ZM11.2501 2.525L14.8751 3.5625L14.5126 5H11.8751V3.75H10.6251V5H7.98764L7.62514 3.5625L11.2501 2.525ZM11.2501 10C9.52514 10 8.12514 8.6 8.12514 6.875V6.25H14.3751V6.875C14.3751 8.6 12.9751 10 11.2501 10Z'
			fill='black'
		/>
	</svg>
);

export const ElectionSVG = ({ color }: { color?: string }) => (
	<svg
		width='17'
		height='20'
		viewBox='0 0 17 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M15.7742 20H0.397668C0.178124 20 0 19.8219 0 19.6023V7.40717C0 7.18763 0.178124 7.0095 0.397668 7.0095H15.7742C15.9937 7.0095 16.1718 7.18763 16.1718 7.40717V19.6023C16.1718 19.8219 15.9937 20 15.7742 20ZM0.795337 19.2047H15.3765V7.80484H0.795337V19.2047Z'
			fill='black'
		/>
		<path
			d='M15.7742 10.456H0.397668C0.178124 10.456 0 10.2778 0 10.0583V7.40717C0 7.18763 0.178124 7.0095 0.397668 7.0095H15.7742C15.9937 7.0095 16.1718 7.18763 16.1718 7.40717V10.0583C16.1718 10.2778 15.9937 10.456 15.7742 10.456ZM0.795337 9.66063H15.3765V7.80484H0.795337V9.66063Z'
			fill='black'
		/>
		<path
			d='M9.2289 6.21417H5.81664C5.71205 6.21417 5.61056 6.17171 5.536 6.09714L4.2415 4.80265C4.08617 4.64731 4.08617 4.39565 4.2415 4.24032L8.36718 0.116505C8.52252 -0.038835 8.77418 -0.038835 8.92951 0.116505L11.9295 3.11545C12.0849 3.27079 12.0849 3.52245 11.9295 3.67778L9.51141 6.0959C9.43684 6.1715 9.33536 6.21396 9.22869 6.21396L9.2289 6.21417ZM5.98128 5.41883H9.06427L11.0847 3.39838L8.64796 0.961632L5.08644 4.52209L5.98128 5.41883Z'
			fill='black'
		/>
	</svg>
);

export const PoliticalPartySVG = ({ color }: { color?: string }) => (
	<svg
		width='13'
		height='20'
		viewBox='0 0 13 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M5.09553 15.4579C5.16626 15.5286 5.26984 15.5615 5.33804 15.5615C5.40372 15.5615 5.50477 15.5337 5.58309 15.4579L8.19519 12.8432C8.3316 12.7043 8.3316 12.4946 8.19519 12.3557C8.05625 12.2193 7.84657 12.2193 7.70763 12.3557L5.33804 14.7253L4.61555 14.0003C4.47661 13.8613 4.26693 13.8613 4.12799 14.0003C4.06231 14.0685 4.02441 14.1544 4.02441 14.2428C4.02441 14.3337 4.06231 14.4196 4.12799 14.4853L5.09553 15.4579Z'
			fill='black'
		/>
		<path
			d='M11.7923 8.09903H10.3044C10.1756 6.60351 9.20551 5.45661 7.68473 4.99179C8.38449 4.49918 8.79373 3.72363 8.79373 2.87988V2.56663C8.79373 1.15195 7.64178 0 6.22458 0H5.91133C4.49665 0 3.3447 1.15195 3.3447 2.56663V2.87988C3.3447 3.72363 3.75647 4.49918 4.45371 4.99179C2.93293 5.45661 1.96539 6.60351 1.83403 8.09903H0.34609C0.141467 8.09903 0 8.24302 0 8.44512V9.72591C0 9.90527 0.169256 10.072 0.34609 10.072H1.12416V19.6539C1.12416 19.8585 1.26563 20 1.47025 20H10.6682C10.8728 20 11.0143 19.856 11.0143 19.6539V10.0745H11.7898C11.9944 10.0745 12.1359 9.93053 12.1359 9.72843V8.44764C12.141 8.24302 11.997 8.09903 11.7923 8.09903ZM10.3221 10.0745V19.3103H1.81887V10.0745H10.3221ZM6.07048 5.42377C7.71757 5.42377 9.43287 6.24479 9.6097 8.07377H2.53126C2.7081 6.24226 4.42592 5.42377 6.07048 5.42377ZM4.03941 2.85462V2.54137C4.03941 1.52583 4.89832 0.666919 5.91386 0.666919H6.22711C7.24264 0.666919 8.10155 1.52583 8.10155 2.54137V2.85462C8.10155 3.87015 7.24264 4.72906 6.22711 4.72906H5.91386C4.89832 4.72906 4.03941 3.87268 4.03941 2.85462ZM11.421 8.79373V9.37981H0.694708V8.79373H11.421Z'
			fill='black'
		/>
	</svg>
);

export const FilterSVG = ({ fill }: { fill?: string }) => {
	const filler = fill || 'black';
	return (
		<svg
			width='16'
			height='12'
			viewBox='0 0 16 12'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M9 10C9.55229 10 10 10.4477 10 11C10 11.5523 9.55229 12 9 12H7C6.44771 12 6 11.5523 6 11C6 10.4477 6.44771 10 7 10H9ZM12 5C12.5523 5 13 5.44771 13 6C13 6.55229 12.5523 7 12 7H4C3.44771 7 3 6.55229 3 6C3 5.44771 3.44771 5 4 5H12ZM15 0C15.5523 0 16 0.447715 16 1C16 1.55229 15.5523 2 15 2H1C0.447715 2 0 1.55229 0 1C0 0.447715 0.447715 0 1 0H15Z'
				fill={filler}
			/>
		</svg>
	);
};

export const ConstituencySVG = ({ fill }: { fill?: string }) => (
	<svg
		width='22'
		height='20'
		viewBox='0 0 22 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M21.668 19.257C18.8094 16.3984 15.0873 14.9196 11.333 14.8134V6.09249H17.8607C18.0212 6.09249 18.1688 6.00414 18.2445 5.86271C18.3202 5.72128 18.3115 5.54938 18.2227 5.41622L16.643 3.04624L18.2227 0.676701C18.3115 0.543102 18.3202 0.371642 18.2445 0.230209C18.1688 0.0887764 18.0212 0 17.8607 0H10.8978C10.6576 0 10.4626 0.19496 10.4626 0.435178V14.8134C6.70881 14.9196 2.9863 16.3984 0.127616 19.257C-0.0425386 19.4272 -0.0425386 19.7022 0.127616 19.8724C0.212475 19.9572 0.323881 19.9999 0.435286 19.9999C0.546692 19.9999 0.658097 19.9572 0.742957 19.8724C6.34195 14.2738 15.4524 14.2734 21.0523 19.8724C21.2224 20.0425 21.4974 20.0425 21.6676 19.8724C21.8378 19.7022 21.8382 19.4272 21.668 19.257ZM15.7579 2.80472C15.6604 2.95094 15.6604 3.14111 15.7579 3.28733L17.0478 5.22213H11.333V0.870355H17.0478L15.7579 2.80472Z'
			fill='black'
		/>
	</svg>
);

export const ResultSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='15'
		height='20'
		viewBox='0 0 15 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M12.1322 1.27911H12.7984C13.2939 1.27911 13.7692 1.47602 14.1197 1.82656C14.4703 2.17711 14.6672 2.65235 14.6672 3.14787V18.1312C14.6672 18.6268 14.4703 19.1023 14.1197 19.4525C13.7692 19.8031 13.2939 20 12.7984 20H1.86876C1.37324 20 0.898001 19.8031 0.547456 19.4525C0.196911 19.1023 0 18.6268 0 18.1312V3.14787C0 2.65235 0.196911 2.17711 0.547456 1.82656C0.898001 1.47602 1.37324 1.27911 1.86876 1.27911H2.53496V1.16875C2.53496 0.523108 3.05834 0 3.70371 0H10.9635C11.6088 0 12.1322 0.523108 12.1322 1.16875V1.27911ZM2.53496 1.82008H1.86876C1.51659 1.82008 1.17903 1.96018 0.929919 2.20903C0.681075 2.45814 0.540965 2.79571 0.540965 3.14787V18.1312C0.540965 18.4834 0.681075 18.821 0.929919 19.0701C1.17903 19.3192 1.51659 19.459 1.86876 19.459H12.7984C13.1506 19.459 13.4881 19.3192 13.7373 19.0701C13.9861 18.821 14.1262 18.4834 14.1262 18.1312V3.14787C14.1262 2.79571 13.9861 2.45814 13.7373 2.20903C13.4881 1.96018 13.1506 1.82008 12.7984 1.82008H12.1322V2.1625C12.1322 2.80788 11.6088 3.33125 10.9635 3.33125H3.70371C3.05834 3.33125 2.53496 2.80788 2.53496 2.1625V1.82008ZM11.5912 2.1625V1.16875C11.5912 0.821991 11.3102 0.540965 10.9635 0.540965H3.70371C3.35696 0.540965 3.07592 0.821991 3.07592 1.16875V2.1625C3.07592 2.50926 3.35696 2.79029 3.70371 2.79029H10.9635C11.3102 2.79029 11.5912 2.50926 11.5912 2.1625ZM3.29042 17.597C3.14111 17.597 3.01993 17.4759 3.01993 17.3266C3.01993 17.1773 3.14111 17.0561 3.29042 17.0561H4.27092C4.42022 17.0561 4.5414 17.1773 4.5414 17.3266C4.5414 17.4759 4.42022 17.597 4.27092 17.597H3.29042ZM5.36042 15.9557C5.21111 15.9557 5.08994 15.8346 5.08994 15.6853C5.08994 15.536 5.21111 15.4148 5.36042 15.4148H11.3768C11.5261 15.4148 11.6472 15.536 11.6472 15.6853C11.6472 15.8346 11.5261 15.9557 11.3768 15.9557H5.36042ZM3.29042 14.3145C3.14111 14.3145 3.01993 14.1933 3.01993 14.044C3.01993 13.8947 3.14111 13.7735 3.29042 13.7735H4.27092C4.42022 13.7735 4.5414 13.8947 4.5414 14.044C4.5414 14.1933 4.42022 14.3145 4.27092 14.3145H3.29042ZM5.36042 14.3145C5.21111 14.3145 5.08994 14.1933 5.08994 14.044C5.08994 13.8947 5.21111 13.7735 5.36042 13.7735H11.3768C11.5261 13.7735 11.6472 13.8947 11.6472 14.044C11.6472 14.1933 11.5261 14.3145 11.3768 14.3145H5.36042ZM3.29042 15.9557C3.14111 15.9557 3.01993 15.8346 3.01993 15.6853C3.01993 15.536 3.14111 15.4148 3.29042 15.4148H4.27092C4.42022 15.4148 4.5414 15.536 4.5414 15.6853C4.5414 15.8346 4.42022 15.9557 4.27092 15.9557H3.29042ZM7.33359 4.99364C9.22777 4.99364 10.7655 6.53134 10.7655 8.42552C10.7655 10.3197 9.22777 11.8574 7.33359 11.8574C5.4394 11.8574 3.90171 10.3197 3.90171 8.42552C3.90171 6.53134 5.4394 4.99364 7.33359 4.99364ZM7.33359 5.5346C5.73801 5.5346 4.44267 6.82995 4.44267 8.42552C4.44267 10.0211 5.73801 11.3164 7.33359 11.3164C8.92916 11.3164 10.2245 10.0211 10.2245 8.42552C10.2245 6.82995 8.92916 5.5346 7.33359 5.5346ZM5.20949 8.32517C5.104 8.21941 5.104 8.04819 5.20949 7.9427C5.31498 7.83694 5.48646 7.83694 5.59195 7.9427L6.88378 9.23426L9.07522 7.04282C9.18071 6.93733 9.3522 6.93733 9.45769 7.04282C9.56317 7.14858 9.56317 7.31979 9.45769 7.42554L7.07501 9.80796C6.96952 9.91372 6.79803 9.91372 6.69254 9.80796L5.20949 8.32517ZM5.36042 17.597C5.21111 17.597 5.08994 17.4759 5.08994 17.3266C5.08994 17.1773 5.21111 17.0561 5.36042 17.0561H9.58779C9.73682 17.0561 9.85827 17.1773 9.85827 17.3266C9.85827 17.4759 9.73682 17.597 9.58779 17.597H5.36042Z'
			fill='black'
		/>
	</svg>
);

export const ElectionCycleSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='21'
		height='20'
		viewBox='0 0 21 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M15.9745 11.9999C15.1834 11.9999 14.41 12.2345 13.7523 12.674C13.0945 13.1136 12.5818 13.7382 12.2791 14.4691C11.9763 15.2 11.8971 16.0042 12.0515 16.7801C12.2058 17.556 12.5868 18.2688 13.1461 18.8281C13.7055 19.3875 14.4182 19.7685 15.1941 19.9228C15.97 20.0772 16.7743 19.9979 17.5052 19.6952C18.236 19.3925 18.8607 18.8798 19.3003 18.222C19.7398 17.5642 19.9744 16.7909 19.9744 15.9998C19.9744 14.939 19.5529 13.9216 18.8028 13.1715C18.0527 12.4214 17.0353 11.9999 15.9745 11.9999ZM15.9745 17.9997C15.5789 17.9997 15.1923 17.8824 14.8634 17.6627C14.5345 17.4429 14.2782 17.1306 14.1268 16.7651C13.9754 16.3997 13.9358 15.9976 14.013 15.6096C14.0901 15.2217 14.2806 14.8653 14.5603 14.5856C14.84 14.3059 15.1964 14.1155 15.5843 14.0383C15.9723 13.9611 16.3744 14.0007 16.7398 14.1521C17.1053 14.3035 17.4176 14.5598 17.6374 14.8887C17.8571 15.2176 17.9744 15.6043 17.9744 15.9998C17.9744 16.5302 17.7637 17.0389 17.3886 17.414C17.0136 17.789 16.5049 17.9997 15.9745 17.9997Z'
			fill='black'
		/>
		<path
			d='M15.3882 2.00026H18.6414C18.7816 2.00097 18.9203 1.97219 19.0486 1.9158C19.177 1.85942 19.292 1.77668 19.3863 1.67296C19.4806 1.56924 19.552 1.44685 19.596 1.31374C19.6399 1.18063 19.6554 1.03977 19.6414 0.900298C19.607 0.646502 19.4801 0.414324 19.2851 0.248254C19.0902 0.0821839 18.8408 -0.00609715 18.5847 0.000327544H14.3082C13.6894 0.000327544 13.0959 0.246152 12.6583 0.683723C12.2208 1.12129 11.9749 1.71477 11.9749 2.33358V6.61011C11.9685 6.86615 12.0568 7.11555 12.2229 7.31053C12.3889 7.50551 12.6211 7.63235 12.8749 7.66674C13.0144 7.68076 13.1552 7.6653 13.2884 7.62137C13.4215 7.57743 13.5438 7.506 13.6476 7.41171C13.7513 7.31742 13.834 7.20237 13.8904 7.07404C13.9468 6.9457 13.9756 6.80695 13.9749 6.66678V3.41355L18.6014 8.04006C18.7909 8.2167 19.0417 8.31286 19.3007 8.30829C19.5598 8.30372 19.807 8.19877 19.9902 8.01556C20.1734 7.83235 20.2783 7.58518 20.2829 7.32612C20.2875 7.06706 20.1913 6.81634 20.0147 6.62678L15.3882 2.00026Z'
			fill='black'
		/>
		<path
			d='M8.64101 1.00029C8.64083 0.802647 8.58209 0.609484 8.4722 0.445202C8.36231 0.28092 8.2062 0.152887 8.02359 0.0772746C7.84098 0.00166187 7.64006 -0.0181393 7.4462 0.0203719C7.25234 0.0588832 7.07424 0.153979 6.9344 0.29365L2.30788 4.92017V1.66694C2.30713 1.52715 2.27708 1.38907 2.21966 1.26161C2.16225 1.13416 2.07875 1.02015 1.97456 0.926963C1.79202 0.761039 1.55459 0.668441 1.30791 0.666971H1.20792C0.954119 0.701368 0.721941 0.828208 0.555871 1.02319C0.389801 1.21816 0.30152 1.46757 0.307945 1.7236V6.00013C0.307945 6.61895 0.55377 7.21242 0.99134 7.64999C1.42891 8.08756 2.02238 8.33339 2.6412 8.33339H6.91773C7.17377 8.33981 7.42317 8.25153 7.61815 8.08546C7.81312 7.91939 7.93996 7.68721 7.97436 7.43342C7.98838 7.29395 7.97292 7.15308 7.92898 7.01997C7.88505 6.88686 7.81362 6.76448 7.71932 6.66076C7.62503 6.55704 7.50999 6.4743 7.38165 6.41791C7.25332 6.36152 7.11457 6.33275 6.97439 6.33345H3.72117L8.34768 1.70694C8.53527 1.51959 8.64077 1.26541 8.64101 1.00029Z'
			fill='black'
		/>
		<path
			d='M8.30812 17.6664V13.3899C8.31454 13.1339 8.22626 12.8845 8.06019 12.6895C7.89412 12.4945 7.66194 12.3677 7.40815 12.3333C7.26868 12.3192 7.12781 12.3347 6.9947 12.3786C6.86159 12.4226 6.73921 12.494 6.63549 12.5883C6.53177 12.6826 6.44903 12.7976 6.39264 12.926C6.33625 13.0543 6.30748 13.1931 6.30818 13.3332V16.5865L1.68167 11.9599C1.49211 11.7833 1.24139 11.6871 0.982327 11.6917C0.723267 11.6963 0.476095 11.8012 0.292884 11.9844C0.109672 12.1677 0.0047266 12.4148 0.000155791 12.6739C-0.00441501 12.9329 0.0917458 13.1837 0.26838 13.3732L4.8949 17.9997H1.64167C1.5015 17.999 1.36274 18.0278 1.23441 18.0842C1.10608 18.1406 0.991031 18.2233 0.896739 18.327C0.802448 18.4308 0.731016 18.5532 0.68708 18.6863C0.643143 18.8194 0.627682 18.9602 0.641701 19.0997C0.676098 19.3535 0.802938 19.5857 0.997916 19.7518C1.19289 19.9178 1.4423 20.0061 1.69833 19.9997H5.97486C6.59368 19.9997 7.18715 19.7539 7.62472 19.3163C8.06229 18.8787 8.30812 18.2852 8.30812 17.6664Z'
			fill='black'
		/>
	</svg>
);

export const ReviewSVG = ({ fill }: { fill?: string }) => {
	const fila = fill || 'black';
	return (
		<svg
			width='17.72'
			height='16'
			viewBox='0 0 88 79'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M66.3006 28.7978H48.8396C47.5427 28.7978 46.488 29.8525 46.488 31.1494C46.488 32.4463 47.5427 33.501 48.8396 33.501H66.3006C70.4412 33.3877 73.7694 37.6885 72.6131 41.669L64.949 71.009C64.4529 72.8996 62.742 74.2238 60.7849 74.2238H36.8159C35.2221 74.4855 24.6949 70.4308 22.9959 70.0011V37.1031C33.3049 33.9039 41.0979 25.5011 41.0349 14.3101V5.15391C41.031 4.8336 41.3279 4.68125 41.4763 4.72032C47.7341 5.93122 52.9963 11.3961 51.6363 21.5683C51.4605 24.6581 56.0425 24.9863 56.3277 21.9121C58.2144 7.33407 48.4839 1.20907 42.4917 0.131072C39.4331 -0.626738 36.2417 2.01387 36.3315 5.15447V14.3107C36.3979 22.799 30.6674 29.4127 22.9605 32.0877C22.7808 29.7283 20.8277 27.8611 18.4253 27.8611L4.5703 27.865C2.0508 27.865 0 29.9158 0 32.4353V66.7943C0.066406 69.8763 4.6406 69.8959 4.7031 66.7943V32.5673H18.2931V74.2273H2.3521C-0.7182 74.282 -0.769 78.8562 2.3521 78.9304H18.4301C20.7465 78.9304 22.6489 77.1882 22.9379 74.946L32.9223 78.2976C34.9496 79.5242 58.0703 78.7155 60.7813 78.9343C64.8751 78.9343 68.461 76.1648 69.4922 72.2038L77.1563 42.8638C79.1446 36.0122 73.4336 28.6058 66.2973 28.8048L66.3006 28.7978Z'
				fill={fila}
			/>
			<path
				d='M86.8908 5.99267C86.0197 5.03173 84.5314 4.95747 83.5705 5.82861L70.8715 17.3446L65.5356 12.0126C63.3208 9.86421 60.059 13.1142 62.2114 15.3368L69.1294 22.2548C69.5864 22.7118 70.188 22.9423 70.7935 22.9423C71.3599 22.9423 71.9224 22.7392 72.3716 22.3329L86.7306 9.31293C87.6915 8.44184 87.7658 6.95353 86.8946 5.99263L86.8908 5.99267Z'
				fill={fila}
			/>
		</svg>
	);
};

export const BulbSVG = ({ fill }: { fill?: string }) => {
	const fila = fill || 'black';
	return (
		<svg
			width='12'
			height='17'
			viewBox='0 0 15 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M3.81868 14.8463C3.13986 12.8281 0 11.7647 0 7.24736C0 3.24468 3.24557 0 7.24825 0C11.2509 0 14.4965 3.2449 14.4965 7.24825C14.4965 10.1963 13.1666 11.6632 12.0312 12.9158C11.3324 13.6867 10.7117 14.3716 10.5763 15.2656C10.5884 15.3281 11.0216 16.0139 10.4035 16.6319L10.2256 16.776C10.7126 17.2066 10.7369 17.954 10.2768 18.4141L10.2759 18.4132C9.92089 18.7682 9.58409 18.7439 9.15267 18.7439C9.11968 19.4427 8.53895 20 7.83669 20H6.56673C5.86534 20 5.28374 19.4427 5.24988 18.7448C4.79414 18.7448 4.50247 18.7708 4.12574 18.4132C3.68302 17.9931 3.68129 17.2439 4.14831 16.8021C3.53113 16.408 3.70559 15.4488 3.81844 14.8463L3.81868 14.8463ZM8.68426 18.7447H5.7198C5.75192 19.1849 6.12258 19.5312 6.56616 19.5312H7.83612C8.28057 19.5312 8.65128 19.1849 8.68426 18.7447ZM9.48288 16.9626H4.92131C4.05237 16.9626 4.06539 18.276 4.92131 18.276H9.48199C9.67991 18.276 9.81446 18.2014 9.9464 18.0833L9.94553 18.0824C10.3631 17.6658 10.0584 16.9626 9.48288 16.9626ZM10.1478 15.4626C10.015 15.2899 9.84573 15.1805 9.60875 15.1805H5.31095C5.0028 15.1805 5.0028 14.7117 5.31095 14.7117H9.60875C9.81795 14.7117 10.0133 14.7699 10.1817 14.8697C10.7988 12.5737 14.0272 11.6857 14.0272 7.24726C14.0281 3.50325 10.9926 0.468566 7.24854 0.468566C3.50453 0.468566 0.468957 3.50325 0.468957 7.24815C0.468957 11.1544 2.92986 12.2559 3.98208 14.0833C4.11837 13.5182 4.28331 12.9678 4.46906 12.4418C2.93259 9.578 3.3753 6.56932 6.50378 4.84021C7.49945 4.28985 8.79201 3.84802 10.4387 3.56589C10.5706 3.54332 10.6948 3.63447 10.7113 3.77509C11.1219 6.72466 10.7564 8.85578 9.72775 10.2978C8.71212 11.7214 7.06618 12.461 4.8944 12.6434C4.67304 13.2762 4.00984 15.4376 4.21644 16.1303C4.31279 16.4523 4.56366 16.4931 4.92218 16.4931H9.60975C10.1358 16.494 10.4508 15.8966 10.1478 15.4626ZM4.69202 11.8437C5.33264 10.2196 6.31007 8.52081 7.20581 7.72303C7.43585 7.51817 7.74748 7.868 7.51656 8.07286C6.63809 8.85584 5.67716 10.5798 5.07122 12.1562C6.99572 11.9566 8.44968 11.2803 9.34457 10.026C10.2769 8.7187 10.6198 6.77243 10.2769 4.06931C6.84552 4.70473 3.5155 6.4382 4.15884 10.184C4.2578 10.7508 4.44375 11.3107 4.69202 11.8437Z'
				fill={fila}
			/>
		</svg>
	);
};

export const ExtractSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='66'
		height='66'
		viewBox='0 0 66 66'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M32 3.41422L26.7071 8.70711C26.3166 9.09763 25.6834 9.09763 25.2929 8.70711C24.9024 8.31658 24.9024 7.68342 25.2929 7.29289L32.2929 0.292893C32.6834 -0.0976311 33.3166 -0.0976311 33.7071 0.292893L40.7071 7.29289C41.0976 7.68342 41.0976 8.31658 40.7071 8.70711C40.3166 9.09763 39.6834 9.09763 39.2929 8.70711L34 3.41422V20C34 20.5523 33.5523 21 33 21C32.4477 21 32 20.5523 32 20V3.41422ZM65.7562 44.3451C65.9599 44.5803 66.0541 44.9087 65.9707 45.2425L60.9707 65.2425C60.8594 65.6877 60.4594 66 60.0005 66H6.0005C5.54164 66 5.14164 65.6877 5.03035 65.2425L0.0303496 45.2425C-0.0531174 44.9087 0.0411491 44.5803 0.244766 44.3451L12.2412 30.3492C12.4312 30.1276 12.7086 30 13.0005 30H53.0005C53.2924 30 53.5698 30.1276 53.7598 30.3492L65.7562 44.3451ZM2.28127 46L6.78127 64H59.2197L63.7197 46H47.5005L41.8005 53.6C41.6116 53.8518 41.3153 54 41.0005 54H25.0005C24.6857 54 24.3894 53.8518 24.2005 53.6L18.5005 46H2.28127ZM62.8263 44L52.5406 32H13.4605L3.1747 44H19.0005C19.3153 44 19.6116 44.1482 19.8005 44.4L25.5005 52H40.5005L46.2005 44.4C46.3894 44.1482 46.6857 44 47.0005 44H62.8263Z'
			fill='black'
		/>
	</svg>
);

export const SearchLGSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='15'
		height='15'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M20 19.3578L13.578 12.9358C14.7706 11.5596 15.5963 9.72477 15.5963 7.79817C15.5963 3.48624 12.1101 0 7.79817 0C3.48624 0 0 3.48624 0 7.79817C0 12.1101 3.48624 15.5963 7.79817 15.5963C9.81651 15.5963 11.5596 14.8624 12.9358 13.578L19.3578 20L20 19.3578ZM7.70642 14.6789C3.94495 14.6789 0.825688 11.5596 0.825688 7.79817C0.825688 4.0367 3.94495 0.917431 7.70642 0.917431C11.4679 0.917431 14.5872 4.0367 14.5872 7.79817C14.5872 11.5596 11.4679 14.6789 7.70642 14.6789Z'
			fill='black'
		/>
	</svg>
);

export const EyeSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='15'
		height='10'
		viewBox='0 0 15 10'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0.0469392 4.76242C-0.0156464 4.91468 -0.0156464 5.08532 0.0469392 5.23758C1.20026 8.03151 3.95278 10 7.16146 10C10.3705 10 13.1227 8.03151 14.276 5.23758C14.3386 5.08532 14.3386 4.91468 14.276 4.76242C13.1227 1.96849 10.3705 0 7.16146 0C3.95278 0 1.20026 1.96849 0.0469392 4.76242ZM1.30208 5C2.32306 2.78491 4.564 1.24549 7.16146 1.24549C9.75923 1.24549 11.9999 2.7849 13.0208 4.99969C11.9999 7.2151 9.75923 8.75452 7.16146 8.75452C4.564 8.75452 2.32306 7.21478 1.30208 5Z'
			fill='#5A5A5A'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M7.16104 2.76904C5.95822 2.76904 4.98145 3.74581 4.98145 4.94864C4.98145 6.15147 5.95822 7.12824 7.16104 7.12824C8.36387 7.12824 9.34064 6.15147 9.34064 4.94864C9.34064 3.74581 8.36387 2.76904 7.16104 2.76904ZM7.16104 4.01453C7.67668 4.01453 8.09516 4.43301 8.09516 4.94864C8.09516 5.46427 7.67668 5.88276 7.16104 5.88276C6.64541 5.88276 6.22693 5.46427 6.22693 4.94864C6.22693 4.43301 6.64541 4.01453 7.16104 4.01453Z'
			fill='#5A5A5A'
		/>
	</svg>
);

export const ElectionTypeSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='21'
		height='20'
		viewBox='0 0 21 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M3.08232 14.9635C3.08232 15.7119 2.47658 16.3176 1.72821 16.3176C0.980738 16.3176 0.375 15.7119 0.375 14.9635C0.375 14.216 0.980738 13.6094 1.72821 13.6094C2.47658 13.6094 3.08232 14.216 3.08232 14.9635Z'
			fill='black'
		/>
		<path
			d='M1.72785 16.5273C0.770952 16.5273 0 17.2974 0 18.2552V19.2825C0 20.2394 3.45472 20.2394 3.45472 19.2825V18.2552C3.45563 17.2974 2.68567 16.5273 1.72785 16.5273Z'
			fill='black'
		/>
		<path
			d='M8.2646 14.0061C8.79361 14.5342 8.79361 15.3918 8.2646 15.9209C7.73559 16.449 6.8789 16.449 6.34988 15.9209C5.82087 15.3918 5.82087 14.5342 6.34988 14.0061C6.8789 13.4771 7.73559 13.4771 8.2646 14.0061Z'
			fill='black'
		/>
		<path
			d='M7.30597 16.5273C6.34908 16.5273 5.57812 17.2974 5.57812 18.2552V19.2825C5.57812 20.2394 9.03285 20.2394 9.03285 19.2825V18.2552C9.03285 17.2974 8.26289 16.5273 7.30597 16.5273Z'
			fill='black'
		/>
		<path
			d='M14.2395 14.9635C14.2395 15.7119 13.6328 16.3176 12.8854 16.3176C12.137 16.3176 11.5312 15.7119 11.5312 14.9635C11.5312 14.216 12.137 13.6094 12.8854 13.6094C13.6328 13.6094 14.2395 14.216 14.2395 14.9635Z'
			fill='black'
		/>
		<path
			d='M12.8841 16.5273C11.9272 16.5273 11.1562 17.2974 11.1562 18.2552V19.2825C11.1562 20.2394 14.611 20.2394 14.611 19.2825V18.2552C14.611 17.2974 13.841 16.5273 12.8841 16.5273Z'
			fill='black'
		/>
		<path
			d='M19.7809 14.6488C19.9533 15.3764 19.5029 16.1058 18.7744 16.2773C18.0468 16.4489 17.3173 15.9984 17.1458 15.2708C16.9743 14.5432 17.4247 13.8138 18.1524 13.6422C18.88 13.4698 19.6094 13.9203 19.7809 14.6488Z'
			fill='black'
		/>
		<path
			d='M18.47 16.5273C17.5131 16.5273 16.7422 17.2974 16.7422 18.2552V19.2825C16.7422 20.2394 20.1969 20.2394 20.1969 19.2825V18.2552C20.1969 17.2974 19.427 16.5273 18.47 16.5273Z'
			fill='black'
		/>
		<path
			d='M3.08235 12.3736V2.33594H0.375V12.3736C1.28496 11.8834 2.17234 11.8834 3.08235 12.3736Z'
			fill='black'
		/>
		<path
			d='M8.66047 12.3703V8.16797H5.95312V12.3703C6.86308 11.8801 7.75046 11.8801 8.66047 12.3703Z'
			fill='black'
		/>
		<path
			d='M14.2161 12.372V0H11.5078V12.372C12.4187 11.8818 13.3052 11.8818 14.2161 12.372Z'
			fill='black'
		/>
		<path
			d='M19.8176 12.371V4.66797H17.1094V12.371C18.0202 11.8808 18.9067 11.8808 19.8176 12.371Z'
			fill='black'
		/>
	</svg>
);

export const GridSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='11'
		height='12'
		viewBox='0 0 21 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7.91485 8.63748C5.83196 8.63748 3.74906 8.63748 1.66616 8.63748C1.26101 8.63748 0.824688 8.66864 0.606529 8.23752C0.471478 7.97261 0.528615 7.58824 0.528615 7.29736C0.528615 6.02477 0.528615 4.75737 0.528615 3.48477C0.528615 2.92379 0.528615 2.36281 0.528615 1.79664C0.528615 1.47979 0.471478 1.07463 0.674054 0.804533C0.933767 0.466906 1.34411 0.518849 1.7181 0.518849C2.2583 0.518849 2.8037 0.518849 3.3439 0.518849C4.63208 0.518849 5.92026 0.518849 7.20324 0.518849C7.47334 0.518849 7.7798 0.482489 8.0499 0.529237C8.6005 0.633123 8.64205 1.13177 8.64205 1.57848C8.64205 2.77316 8.64205 3.97303 8.64205 5.16771C8.64205 6.07671 8.67841 6.9909 8.64205 7.89989C8.62647 8.31544 8.3252 8.6219 7.91485 8.63748C7.58242 8.64787 7.58242 9.16729 7.91485 9.15691C8.6836 9.13093 9.16667 8.5284 9.16667 7.79081C9.16667 7.3493 9.16667 6.90779 9.16667 6.46628C9.16667 5.07422 9.16667 3.67696 9.16667 2.2849C9.16667 1.94727 9.17706 1.60445 9.16667 1.26682C9.14589 0.54482 8.5953 0.00981138 7.8733 0.00461712C6.7877 -0.0057714 5.7021 0.00461712 4.6165 0.00461712C3.52051 0.00461712 2.41933 -0.0057714 1.32334 0.00461712C0.601334 0.00981138 0.0351598 0.529238 0.0143827 1.26163C0.00399422 1.58887 0.0143827 1.91611 0.0143827 2.24334C0.0143827 3.63541 0.0143827 5.02747 0.0143827 6.41953C0.0143827 6.87143 0.0143827 7.32333 0.0143827 7.77523C0.0143827 8.46607 0.424729 9.08419 1.15712 9.15171C1.45839 9.17768 1.77004 9.15691 2.07131 9.15691C2.7154 9.15691 3.35429 9.15691 3.99838 9.15691C5.22942 9.15691 6.46565 9.15691 7.69669 9.15691C7.76941 9.15691 7.84213 9.15691 7.91485 9.15691C8.24729 9.15691 8.24729 8.63748 7.91485 8.63748Z'
			fill='black'
		/>
		<path
			d='M7.90509 19.4727C5.82219 19.4727 3.73929 19.4727 1.65639 19.4727C1.25124 19.4727 0.814922 19.5038 0.596763 19.0727C0.461712 18.8078 0.518849 18.4234 0.518849 18.1326C0.518849 16.86 0.518849 15.5926 0.518849 14.32C0.518849 13.759 0.518849 13.198 0.518849 12.6318C0.518849 12.315 0.461712 11.9098 0.664288 11.6397C0.924001 11.3021 1.33435 11.3541 1.70833 11.3541C2.24854 11.3541 2.79394 11.3541 3.33414 11.3541C4.62232 11.3541 5.91049 11.3541 7.19347 11.3541C7.46358 11.3541 7.77004 11.3177 8.04014 11.3644C8.59073 11.4683 8.63228 11.967 8.63228 12.4137C8.63228 13.6084 8.63228 14.8082 8.63228 16.0029C8.63228 16.9119 8.66864 17.8261 8.63228 18.7351C8.6219 19.1506 8.32063 19.4571 7.90509 19.4727C7.57266 19.4831 7.57266 20.0025 7.90509 19.9921C8.67384 19.9661 9.15691 19.3636 9.15691 18.626C9.15691 18.1845 9.15691 17.743 9.15691 17.3015C9.15691 15.9094 9.15691 14.5122 9.15691 13.1201C9.15691 12.7825 9.16729 12.4397 9.15691 12.102C9.13613 11.38 8.58554 10.845 7.86353 10.8398C6.77793 10.8294 5.69233 10.8398 4.60673 10.8398C3.51074 10.8398 2.40956 10.8294 1.31357 10.8398C0.591569 10.845 0.0253942 11.3644 0.00461712 12.0968C-0.0057714 12.4241 0.00461712 12.7513 0.00461712 13.0785C0.00461712 14.4706 0.00461712 15.8627 0.00461712 17.2547C0.00461712 17.7066 0.00461712 18.1585 0.00461712 18.6104C0.00461712 19.3013 0.414964 19.9194 1.14735 19.9869C1.44862 20.0129 1.76028 19.9921 2.06154 19.9921C2.70563 19.9921 3.34453 19.9921 3.98862 19.9921C5.21966 19.9921 6.45589 19.9921 7.68693 19.9921C7.75965 19.9921 7.83237 19.9921 7.90509 19.9921C8.24271 19.9921 8.24271 19.4727 7.90509 19.4727Z'
			fill='black'
		/>
		<path
			d='M18.9324 8.63748C16.8495 8.63748 14.7666 8.63748 12.6837 8.63748C12.2786 8.63748 11.8423 8.66864 11.6241 8.23752C11.4891 7.97261 11.5462 7.58824 11.5462 7.29736C11.5462 6.02477 11.5462 4.75737 11.5462 3.48477C11.5462 2.92379 11.5462 2.36281 11.5462 1.79664C11.5462 1.47979 11.4891 1.07463 11.6916 0.804533C11.9513 0.466906 12.3617 0.518849 12.7357 0.518849C13.2759 0.518849 13.8213 0.518849 14.3615 0.518849C15.6497 0.518849 16.9378 0.518849 18.2208 0.518849C18.4909 0.518849 18.7974 0.482489 19.0675 0.529237C19.6181 0.633123 19.6596 1.13177 19.6596 1.57848C19.6596 2.77316 19.6596 3.97303 19.6596 5.16771C19.6596 6.07671 19.696 6.9909 19.6596 7.89989C19.644 8.31544 19.3428 8.6219 18.9324 8.63748C18.6 8.64787 18.6 9.16729 18.9324 9.15691C19.7012 9.13093 20.1842 8.5284 20.1842 7.79081C20.1842 7.3493 20.1842 6.90779 20.1842 6.46628C20.1842 5.07422 20.1842 3.67696 20.1842 2.2849C20.1842 1.94727 20.1946 1.60445 20.1842 1.26682C20.1635 0.54482 19.6129 0.00981138 18.8909 0.00461712C17.8053 -0.0057714 16.7197 0.00461712 15.6341 0.00461712C14.5381 0.00461712 13.4369 -0.0057714 12.3409 0.00461712C11.6189 0.00981138 11.0527 0.529238 11.032 1.26163C11.0216 1.58887 11.032 1.91611 11.032 2.24334C11.032 3.63541 11.032 5.02747 11.032 6.41953C11.032 6.87143 11.032 7.32333 11.032 7.77523C11.032 8.46607 11.4423 9.08419 12.1747 9.15171C12.476 9.17768 12.7876 9.15691 13.0889 9.15691C13.733 9.15691 14.3719 9.15691 15.016 9.15691C16.247 9.15691 17.4832 9.15691 18.7143 9.15691C18.787 9.15691 18.8597 9.15691 18.9324 9.15691C19.2649 9.15691 19.2649 8.63748 18.9324 8.63748Z'
			fill='black'
		/>
		<path
			d='M18.9227 19.4727C16.8398 19.4727 14.7569 19.4727 12.674 19.4727C12.2688 19.4727 11.8325 19.5039 11.6143 19.0728C11.4793 18.8079 11.5364 18.4235 11.5364 18.1326C11.5364 16.86 11.5364 15.5926 11.5364 14.32C11.5364 13.7591 11.5364 13.1981 11.5364 12.6319C11.5364 12.3151 11.4793 11.9099 11.6819 11.6398C11.9416 11.3022 12.3519 11.3541 12.7259 11.3541C13.2661 11.3541 13.8115 11.3541 14.3517 11.3541C15.6399 11.3541 16.9281 11.3541 18.2111 11.3541C18.4812 11.3541 18.7876 11.3178 19.0577 11.3645C19.6083 11.4684 19.6499 11.967 19.6499 12.4137C19.6499 13.6084 19.6499 14.8083 19.6499 16.003C19.6499 16.912 19.6862 17.8262 19.6499 18.7352C19.6395 19.1507 19.3382 19.4572 18.9227 19.4727C18.5902 19.4831 18.5902 20.0026 18.9227 19.9922C19.6914 19.9662 20.1745 19.3637 20.1745 18.6261C20.1745 18.1846 20.1745 17.7431 20.1745 17.3015C20.1745 15.9095 20.1745 14.5122 20.1745 13.1202C20.1745 12.7825 20.1849 12.4397 20.1745 12.1021C20.1537 11.3801 19.6031 10.8451 18.8811 10.8399C17.7955 10.8295 16.7099 10.8399 15.6243 10.8399C14.5283 10.8399 13.4271 10.8295 12.3311 10.8399C11.6091 10.8451 11.043 11.3645 11.0222 12.0969C11.0118 12.4241 11.0222 12.7514 11.0222 13.0786C11.0222 14.4707 11.0222 15.8627 11.0222 17.2548C11.0222 17.7067 11.0222 18.1586 11.0222 18.6105C11.0222 19.3013 11.4325 19.9194 12.1649 19.987C12.4662 20.0129 12.7779 19.9922 13.0791 19.9922C13.7232 19.9922 14.3621 19.9922 15.0062 19.9922C16.2372 19.9922 17.4735 19.9922 18.7045 19.9922C18.7772 19.9922 18.8499 19.9922 18.9227 19.9922C19.2551 19.9922 19.2603 19.4727 18.9227 19.4727Z'
			fill='black'
		/>
	</svg>
);

export const TableSVG = () => (
	<svg
		width='11'
		height='12'
		viewBox='0 0 25 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M22.4595 3.71822H10.1124C9.23907 3.71822 8.53027 3.00943 8.53027 2.13609C8.53027 1.2625 9.23882 0.553711 10.1124 0.553711H22.4595C23.3331 0.553711 24.0427 1.26225 24.0427 2.13609C24.0427 3.00943 23.3331 3.71822 22.4595 3.71822Z'
			fill='black'
		/>
		<path
			d='M3.99446 4.19865H1.58213C0.708543 4.19865 0 3.49036 0 2.61652V1.58213C0 0.708543 0.708543 0 1.58213 0H3.99446C4.8678 0 5.57659 0.708543 5.57659 1.58213V2.61652C5.57659 3.49036 4.8678 4.19865 3.99446 4.19865Z'
			fill='black'
		/>
		<path
			d='M22.4595 11.582H10.1124C9.23907 11.582 8.53027 10.8733 8.53027 10.0002C8.53027 9.12658 9.23882 8.41779 10.1124 8.41779H22.4595C23.3331 8.41779 24.0427 9.12658 24.0427 10.0002C24.0427 10.8733 23.3331 11.582 22.4595 11.582Z'
			fill='black'
		/>
		<path
			d='M3.99446 12.0996H1.58213C0.708543 12.0996 0 11.391 0 10.5175V9.48306C0 8.60973 0.708543 7.90118 1.58213 7.90118H3.99446C4.8678 7.90118 5.57659 8.60973 5.57659 9.48306V10.5175C5.57659 11.391 4.8678 12.0996 3.99446 12.0996Z'
			fill='black'
		/>
		<path
			d='M22.4595 19.4827H10.1124C9.23907 19.4827 8.53027 18.7744 8.53027 17.9008C8.53027 17.027 9.23882 16.3187 10.1124 16.3187H22.4595C23.3331 16.3187 24.0427 17.027 24.0427 17.9008C24.0427 18.7746 23.3331 19.4827 22.4595 19.4827Z'
			fill='black'
		/>
		<path
			d='M3.99446 20H1.58213C0.708543 20 0 19.2912 0 18.4179V17.3843C0 16.5107 0.708543 15.8019 1.58213 15.8019H3.99446C4.8678 15.8019 5.57659 16.5107 5.57659 17.3843V18.4179C5.57659 19.2912 4.8678 20 3.99446 20Z'
			fill='black'
		/>
	</svg>
);

export const AISVG = ({ fill }: { fill?: string }) => (
	<svg
		width='25'
		height='20'
		viewBox='0 0 25 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M11.7385 5.57707C11.6255 5.61134 11.5215 5.66617 11.429 5.7427C11.3981 5.76783 11.3673 5.79182 11.3399 5.82152C11.2428 5.92775 11.1754 6.04541 11.1331 6.16992C11.084 6.31499 11.0737 6.46577 11.1 6.61198C11.1343 6.80503 11.2302 6.99123 11.3924 7.14087C11.7842 7.47555 12.3497 7.45271 12.7129 7.08832C12.8374 6.95353 12.9128 6.79818 12.9471 6.6371C12.9711 6.5263 12.9722 6.41322 12.9528 6.30242C12.9197 6.10709 12.8237 5.91975 12.6592 5.76783C12.3965 5.54394 12.0447 5.48454 11.7385 5.57707Z'
			fill='white'
		/>
		<path
			d='M13.6405 5.30184C13.7318 5.29841 13.8198 5.26072 13.9009 5.20703C13.9386 5.1819 13.9786 5.16134 14.0117 5.12593C14.1202 5.00827 14.1648 4.8552 14.1522 4.7067C14.1408 4.57305 14.086 4.44283 13.9797 4.34459C13.8986 4.2692 13.8061 4.21208 13.7181 4.14697C13.6108 4.06815 13.5 3.99619 13.3835 3.93451C13.147 3.80885 12.8945 3.71747 12.6307 3.66264C12.3931 3.61238 12.1509 3.58154 11.8996 3.59182C11.6152 3.60324 11.341 3.66949 11.076 3.76087C10.8327 3.8454 10.5997 3.95392 10.3872 4.10129C10.2593 4.19039 10.1416 4.29434 10.0274 4.40515C9.99082 4.4417 9.94742 4.46912 9.91201 4.50796C9.70525 4.73184 9.71896 5.08252 9.94399 5.28929C10.0308 5.37039 10.1382 5.40695 10.2479 5.42066C10.3655 5.43551 10.4832 5.41609 10.5883 5.35669C10.6362 5.32927 10.6854 5.30072 10.7242 5.25845C10.7984 5.17049 10.8818 5.0951 10.9721 5.02885C11.0657 4.95917 11.1663 4.90091 11.2713 4.85408C11.4256 4.78554 11.5935 4.74556 11.766 4.72157C11.8334 4.71243 11.9008 4.69873 11.9704 4.6953C12.0241 4.69301 12.0755 4.70215 12.1292 4.70444C12.5507 4.72386 12.9357 4.88149 13.2578 5.15679C13.3686 5.25846 13.5057 5.30641 13.6405 5.30184Z'
			fill='white'
		/>
		<path
			d='M14.4398 3.83851C14.5152 3.90818 14.6021 3.9436 14.6912 3.96416C14.7346 3.97444 14.7791 3.987 14.8237 3.98586C14.947 3.98129 15.0658 3.92532 15.1641 3.83165C15.1732 3.82252 15.1846 3.81909 15.1938 3.80881C15.4005 3.58492 15.3868 3.23425 15.1618 3.02747C15.059 2.92923 14.9505 2.83785 14.8396 2.74989C14.3039 2.32725 13.6859 2.03938 13.0223 1.89431C12.635 1.80978 12.2318 1.76865 11.8194 1.78465C11.4059 1.80178 11.0027 1.87603 10.6143 1.99711C9.98032 2.19359 9.3909 2.5203 8.88717 2.97148C8.77408 3.072 8.66442 3.17938 8.56047 3.29248C8.55361 3.29933 8.55133 3.30961 8.54562 3.31761C8.42225 3.46611 8.39369 3.65803 8.44852 3.83278C8.47594 3.92188 8.51934 4.00641 8.59245 4.07495C8.64043 4.11949 8.69754 4.1492 8.75466 4.17318C8.88716 4.22916 9.03338 4.2303 9.16587 4.17889C9.2424 4.1492 9.31437 4.10693 9.37377 4.04296C9.42745 3.98471 9.48457 3.93216 9.54169 3.87847C9.76786 3.66258 10.0169 3.47981 10.2853 3.33131C10.5629 3.17824 10.8599 3.06059 11.1729 2.98633C11.3968 2.93379 11.6275 2.90066 11.864 2.89152C12.0468 2.88467 12.2295 2.89495 12.41 2.91551C12.7401 2.95321 13.0623 3.03659 13.3695 3.16225C13.6974 3.29704 14.0058 3.48093 14.2845 3.71055C14.3359 3.75281 14.3896 3.79281 14.4398 3.83851Z'
			fill='white'
		/>
		<path
			d='M16.4125 2.48973C16.6467 2.2647 16.6318 1.914 16.4079 1.70725C15.1469 0.543243 13.4769 -0.0633098 11.7519 0.0052352C10.0282 0.0749148 8.43812 0.812832 7.24794 2.07507C7.04119 2.29896 7.0549 2.64963 7.27993 2.8564C7.39187 2.96035 7.52895 3.00833 7.66374 3.00262C7.79853 2.99691 7.93104 2.93751 8.03384 2.82556C8.56956 2.24527 9.20925 1.80206 9.9095 1.50508C10.4932 1.2572 11.1192 1.10983 11.7692 1.08357C12.0787 1.07101 12.3849 1.09042 12.6864 1.13041C12.8132 1.14754 12.9389 1.17039 13.0634 1.19552C13.1925 1.22179 13.3215 1.25149 13.4483 1.28804C14.2491 1.51765 14.9962 1.93229 15.6324 2.51943C15.8552 2.72847 16.2057 2.71362 16.4125 2.48973Z'
			fill='white'
		/>
		<path
			d='M17.6679 19.9989C19.2625 19.9989 20.559 18.7024 20.559 17.1077L20.5579 10.8638C20.5579 9.26916 19.2613 7.97266 17.6667 7.97266H6.68021C5.08557 7.97266 3.78906 9.26916 3.78906 10.8638V17.1077C3.78906 18.7024 5.08557 19.9989 6.68021 19.9989H17.6679ZM4.3738 17.1077V10.8638C4.3738 9.59241 5.40873 8.55751 6.68009 8.55751H17.6666C18.938 8.55751 19.9729 9.59244 19.9729 10.8638V17.1077C19.9729 18.3791 18.938 19.414 17.6666 19.414H6.68009C5.4087 19.414 4.3738 18.3791 4.3738 17.1077Z'
			fill='white'
		/>
		<path
			d='M0 14.0075C0 15.834 1.48041 17.3154 3.30794 17.3154V10.6992C1.48141 10.6992 0 12.1808 0 14.0072V14.0075Z'
			fill='white'
		/>
		<path
			d='M21.0078 10.6992V17.3142C22.8343 17.3142 24.3158 15.8338 24.3158 14.0063C24.3146 12.1798 22.8342 10.6983 21.0078 10.6992Z'
			fill='white'
		/>
		<path
			d='M8.5485 14.2689C9.20532 14.2689 9.73763 13.7366 9.73763 13.0798C9.73763 12.4229 9.20532 11.8906 8.5485 11.8906C7.89168 11.8906 7.35938 12.4229 7.35938 13.0798C7.35938 13.7366 7.89168 14.2689 8.5485 14.2689Z'
			fill='white'
		/>
		<path
			d='M15.5485 14.2689C16.2053 14.2689 16.7376 13.7366 16.7376 13.0798C16.7376 12.4229 16.2053 11.8906 15.5485 11.8906C14.8917 11.8906 14.3594 12.4229 14.3594 13.0798C14.3605 13.7366 14.8928 14.2689 15.5485 14.2689Z'
			fill='white'
		/>
		<path
			d='M10.875 15.7383H13.5857V17.1433H10.875V15.7383Z'
			fill='white'
		/>
	</svg>
);

export const SearchSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='12'
		height='12'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M20 19.3578L13.578 12.9358C14.7706 11.5596 15.5963 9.72477 15.5963 7.79817C15.5963 3.48624 12.1101 0 7.79817 0C3.48624 0 0 3.48624 0 7.79817C0 12.1101 3.48624 15.5963 7.79817 15.5963C9.81651 15.5963 11.5596 14.8624 12.9358 13.578L19.3578 20L20 19.3578ZM7.70642 14.6789C3.94495 14.6789 0.825688 11.5596 0.825688 7.79817C0.825688 4.0367 3.94495 0.917431 7.70642 0.917431C11.4679 0.917431 14.5872 4.0367 14.5872 7.79817C14.5872 11.5596 11.4679 14.6789 7.70642 14.6789Z'
			fill='black'
		/>
	</svg>
);

export const HistorySVG = ({ fill }: { fill?: string }) => {
	const fila = fill || 'black';
	return (
		<svg
			width='14'
			height='15'
			viewBox='0 0 14 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M7.19383 14.4642C3.52279 14.4642 0.536057 11.4425 0.536057 7.72829C0.491545 2.27761 6.81585 -0.98497 11.1459 2.3138C11.1458 2.3137 9.6149 2.67632 9.6149 2.67632C9.27214 2.76443 9.39647 3.27354 9.73841 3.1975C9.7384 3.1975 11.8017 2.70903 11.8017 2.70903C11.9301 2.67387 12.0223 2.54524 12.0056 2.41389C12.0056 2.4139 11.7217 0.230003 11.7217 0.230003C11.6701 -0.117633 11.1515 -0.0523067 11.1904 0.299089C11.1904 0.299075 11.3886 1.82436 11.3886 1.82436C6.70107 -1.64462 -0.0496882 1.88681 0.00027575 7.72838C0.000224845 11.7379 3.22727 15 7.19384 15C7.54698 14.9934 7.54322 14.4685 7.19383 14.4642Z'
				fill={fila}
			/>
			<path
				d='M7.19272 4.16943C7.04476 4.16943 6.9248 4.28927 6.9248 4.43735V7.72824C6.9248 7.87632 7.04476 7.99615 7.19272 7.99615H9.39637C9.74788 7.99 9.74918 7.46656 9.39636 7.46032C9.39637 7.46032 7.46064 7.46032 7.46064 7.46032V4.43735C7.46064 4.28927 7.34068 4.16943 7.19272 4.16943Z'
				fill={fila}
			/>
			<path
				d='M7.41602 10.4129C7.41602 10.561 7.53598 10.6809 7.68393 10.6809H13.2876C13.4355 10.6809 13.5555 10.561 13.5555 10.4129C13.5555 10.2649 13.4355 10.145 13.2876 10.145H7.68393C7.53598 10.145 7.41602 10.2649 7.41602 10.4129Z'
				fill={fila}
			/>
			<path
				d='M13.2876 11.6473H7.68393C7.53598 11.6473 7.41602 11.7672 7.41602 11.9153C7.41602 12.0633 7.53598 12.1832 7.68393 12.1832H13.2876C13.6379 12.1778 13.6412 11.6534 13.2876 11.6473Z'
				fill={fila}
			/>
			<path
				d='M13.2876 13.15H7.68393C7.53598 13.15 7.41602 13.2699 7.41602 13.4179C7.41602 13.566 7.53598 13.6859 7.68393 13.6859H13.2876C13.6379 13.6805 13.6412 13.156 13.2876 13.15Z'
				fill={fila}
			/>
		</svg>
	);
};

export const HideSearchSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='15'
		height='15'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M1.77784 8.0836C1.77784 9.50209 2.24896 10.8126 3.04255 11.8673L11.8671 3.04277C10.8124 2.24919 9.50209 1.77784 8.0836 1.77784C4.6066 1.77784 1.77784 4.6066 1.77784 8.0836ZM1.40694 15.6492C1.28182 15.6492 1.15782 15.6203 1.04181 15.5681C0.946698 15.525 0.856473 15.467 0.778248 15.3887C0.431125 15.0416 0.431125 14.4789 0.778248 14.1316L1.77473 13.1351C0.665133 11.7511 0 9.99544 0 8.0836C0 3.61923 3.61901 0 8.0836 0C9.99544 0 11.7511 0.665356 13.1349 1.77495L14.1314 0.77847C14.4787 0.431348 15.0414 0.431348 15.3887 0.77847C15.467 0.856695 15.525 0.94692 15.5679 1.04226C15.7156 1.36938 15.6574 1.76673 15.3887 2.03562L2.0354 15.3887C1.86184 15.5623 1.6345 15.6492 1.40694 15.6492ZM19.7395 18.4826C20.0867 18.8297 20.0867 19.3924 19.7395 19.7398C19.566 19.9133 19.3386 20 19.1111 20C18.8835 20 18.656 19.9133 18.4824 19.7398L13.1349 14.3923C11.7511 15.5019 9.99544 16.1672 8.0836 16.1672C7.10535 16.1672 6.16821 15.9925 5.30084 15.6736C4.70082 15.4532 4.54282 14.6752 4.99483 14.2231L5.00306 14.2149C5.25062 13.9671 5.61841 13.8965 5.94775 14.0158C6.84623 14.3407 7.83826 14.4678 8.87252 14.3407C11.7113 13.992 13.9918 11.7117 14.3405 8.87296C14.4676 7.83871 14.3407 6.84645 14.0156 5.94798C13.8965 5.61863 13.9671 5.25084 14.2149 5.00306L14.2229 4.99506C14.6749 4.54304 15.453 4.70105 15.6736 5.30107C15.9923 6.16843 16.167 7.10557 16.167 8.0836C16.167 9.99544 15.5018 11.7511 14.392 13.1351L19.7395 18.4826Z'
			fill='black'
		/>
	</svg>
);

export const ClockSVG = ({ color, width, height }: { color?: string; width?: string; height?: string }) => (
	<svg
		width={width || '21'}
		height={height || '20'}
		viewBox='0 0 21 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M10.1336 0C7.42984 0 4.88641 1.03786 2.97105 2.9265C1.05568 4.81514 0 7.32739 0 10C0 12.6726 1.05568 15.1849 2.97105 17.0735C4.88641 18.9621 7.42539 20 10.1336 20C12.8419 20 15.3808 18.9621 17.2962 17.0735C19.2116 15.1849 20.2673 12.6726 20.2673 10C20.2673 7.32739 19.2116 4.81514 17.2962 2.9265C15.3808 1.03786 12.8374 0 10.1336 0ZM10.1336 18.6637C5.28285 18.6637 1.3363 14.7751 1.3363 10C1.3363 5.22494 5.28285 1.3363 10.1336 1.3363C14.9844 1.3363 18.931 5.22494 18.931 10C18.931 14.7751 14.9844 18.6637 10.1336 18.6637Z'
			fill={color || 'black'}
		/>
		<path
			d='M14.5039 12.8956L10.7133 9.97797V4.21405C10.7133 3.84434 10.4148 3.5459 10.0451 3.5459C9.67539 3.5459 9.37695 3.84434 9.37695 4.21405V10.3076C9.37695 10.5169 9.46604 10.7129 9.63085 10.8377L13.6888 13.9557C13.809 14.0492 13.9516 14.0938 14.0941 14.0938C14.2945 14.0938 14.495 14.0047 14.6286 13.831C14.8513 13.5414 14.7979 13.1227 14.5039 12.8956Z'
			fill={color || 'black'}
		/>
	</svg>
);

export const AddSVG = ({ color, width, height }: { color?: string; width?: string; height?: string }) => (
	<svg
		width='14'
		height='14'
		viewBox='0 0 14 14'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M6 8H0V6H6V0H8V6H14V8H8V14H6V8Z'
			fill='#525252'
		/>
	</svg>
);

export const SettingsSVG = () => (
	<svg
		width='21'
		height='20'
		viewBox='0 0 21 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7.3 20L6.9 16.8C6.68333 16.7167 6.47917 16.6167 6.2875 16.5C6.09583 16.3833 5.90833 16.2583 5.725 16.125L2.75 17.375L0 12.625L2.575 10.675C2.55833 10.5583 2.55 10.4458 2.55 10.3375V9.6625C2.55 9.55417 2.55833 9.44167 2.575 9.325L0 7.375L2.75 2.625L5.725 3.875C5.90833 3.74167 6.1 3.61667 6.3 3.5C6.5 3.38333 6.7 3.28333 6.9 3.2L7.3 0H12.8L13.2 3.2C13.4167 3.28333 13.6208 3.38333 13.8125 3.5C14.0042 3.61667 14.1917 3.74167 14.375 3.875L17.35 2.625L20.1 7.375L17.525 9.325C17.5417 9.44167 17.55 9.55417 17.55 9.6625V10.3375C17.55 10.4458 17.5333 10.5583 17.5 10.675L20.075 12.625L17.325 17.375L14.375 16.125C14.1917 16.2583 14 16.3833 13.8 16.5C13.6 16.6167 13.4 16.7167 13.2 16.8L12.8 20H7.3ZM9.05 18H11.025L11.375 15.35C11.8917 15.2167 12.3708 15.0208 12.8125 14.7625C13.2542 14.5042 13.6583 14.1917 14.025 13.825L16.5 14.85L17.475 13.15L15.325 11.525C15.4083 11.2917 15.4667 11.0458 15.5 10.7875C15.5333 10.5292 15.55 10.2667 15.55 10C15.55 9.73333 15.5333 9.47083 15.5 9.2125C15.4667 8.95417 15.4083 8.70833 15.325 8.475L17.475 6.85L16.5 5.15L14.025 6.2C13.6583 5.81667 13.2542 5.49583 12.8125 5.2375C12.3708 4.97917 11.8917 4.78333 11.375 4.65L11.05 2H9.075L8.725 4.65C8.20833 4.78333 7.72917 4.97917 7.2875 5.2375C6.84583 5.49583 6.44167 5.80833 6.075 6.175L3.6 5.15L2.625 6.85L4.775 8.45C4.69167 8.7 4.63333 8.95 4.6 9.2C4.56667 9.45 4.55 9.71667 4.55 10C4.55 10.2667 4.56667 10.525 4.6 10.775C4.63333 11.025 4.69167 11.275 4.775 11.525L2.625 13.15L3.6 14.85L6.075 13.8C6.44167 14.1833 6.84583 14.5042 7.2875 14.7625C7.72917 15.0208 8.20833 15.2167 8.725 15.35L9.05 18ZM10.1 13.5C11.0667 13.5 11.8917 13.1583 12.575 12.475C13.2583 11.7917 13.6 10.9667 13.6 10C13.6 9.03333 13.2583 8.20833 12.575 7.525C11.8917 6.84167 11.0667 6.5 10.1 6.5C9.11667 6.5 8.2875 6.84167 7.6125 7.525C6.9375 8.20833 6.6 9.03333 6.6 10C6.6 10.9667 6.9375 11.7917 7.6125 12.475C8.2875 13.1583 9.11667 13.5 10.1 13.5Z'
			fill='#525252'
		/>
	</svg>
);

export const UploadIconSVG = ({ color, width, height }: { color?: string; width?: string; height?: string }) => (
	<svg
		width='16'
		height='16'
		viewBox='0 0 16 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7 12V3.85L4.4 6.45L3 5L8 0L13 5L11.6 6.45L9 3.85V12H7ZM2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V11H2V14H14V11H16V14C16 14.55 15.8042 15.0208 15.4125 15.4125C15.0208 15.8042 14.55 16 14 16H2Z'
			fill={color || '#525252'}
		/>
	</svg>
);

export const DivisionsSVG = ({ color, width, height }: { color?: string; width?: string; height?: string }) => (
	<svg
		width='80'
		height='16'
		viewBox='0 0 80 92'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M79.442 22.6343L40.471 0.13425C40.161 -0.04475 39.781 -0.04475 39.471 0.13425L0.5 22.6343C0.19 22.8133 0 23.1432 0 23.5002V68.5003C0 68.8573 0.19 69.1882 0.5 69.3662L39.471 91.8662C39.626 91.9562 39.798 92.0003 39.971 92.0003C40.144 92.0003 40.316 91.9562 40.471 91.8662L79.442 69.3662C79.754 69.1872 79.942 68.8573 79.942 68.5003V23.5002C79.942 23.1432 79.752 22.8133 79.442 22.6343ZM58.291 56.7683L58.748 55.9753L56.582 54.7253L55.832 56.0243L57.707 57.1063L40.971 66.7682V46.7463L41.117 46.4943L60.623 35.2323L60.164 36.0253L62.33 37.2753L63.08 35.9763L61.207 34.8943L77.943 25.2323V45.2553L77.797 45.5063L58.291 56.7683ZM21.183 78.4823L20.736 78.7402L2.146 68.0073L2 67.7552V47.7323L18.736 57.3943L16.862 58.4763L17.612 59.7753L19.778 58.5253L19.32 57.7323L38.221 68.6452L36.347 69.7272L37.097 71.0263L38.971 69.9433V89.2702L21.63 79.2573L21.183 78.4823ZM40.116 2.23925L76.942 23.5002L58.291 34.2683L58.748 33.4753L56.582 32.2243L55.832 33.5233L57.707 34.6053L40.115 44.7623H39.826L22.236 34.6063L24.11 33.5243L23.36 32.2253L21.194 33.4763L21.652 34.2693L3 23.5002L39.826 2.23925H40.116ZM18.735 34.8953L16.861 35.9773L17.611 37.2763L19.777 36.0263L19.319 35.2333L38.826 46.4953L38.971 46.7453V66.7673L22.236 57.1053L24.11 56.0233L23.36 54.7243L21.194 55.9763L21.652 56.7693L2.145 45.5063L2 45.2553V25.2323L18.735 34.8953ZM38.971 69.2702L38.805 68.9813L38.971 69.0783V69.2702ZM40.971 69.0783L41.138 68.9823L40.971 69.2702V69.0783ZM40.971 69.9433L42.846 71.0253L43.596 69.7262L41.722 68.6442L60.623 57.7303L60.166 58.5233L62.332 59.7733L63.082 58.4743L61.207 57.3923L77.943 47.7303V67.7523L77.797 68.0042L59.207 78.7402L58.76 78.4823L58.312 79.2552L40.971 89.2682V69.9433Z'
			fill='black'
		/>
		<path
			d='M40.7207 14.7454H39.2207V17.2464H40.7207V14.7454Z'
			fill='black'
		/>
		<path
			d='M40.7207 34.7563H39.2207V37.2573H40.7207V34.7563Z'
			fill='black'
		/>
		<path
			d='M40.7207 9.74316H39.2207V12.2442H40.7207V9.74316Z'
			fill='black'
		/>
		<path
			d='M40.7207 4.74023H39.2207V7.24123H40.7207V4.74023Z'
			fill='black'
		/>
		<path
			d='M40.7207 29.7542H39.2207V32.2551H40.7207V29.7542Z'
			fill='black'
		/>
		<path
			d='M40.7207 19.7483H39.2207V22.2493H40.7207V19.7483Z'
			fill='black'
		/>
		<path
			d='M39.2204 24.7513V27.2523H40.7204V24.7513H40.6784L41.4174 23.4713L40.3444 22.8513L39.9704 23.5003L39.5954 22.8513L38.5234 23.4713L39.2634 24.7513H39.2204ZM39.9704 24.3663L40.6354 24.7503H39.3054L39.9704 24.3663Z'
			fill='black'
		/>
		<path
			d='M40.7207 39.7593H39.2207V42.2603H40.7207V39.7593Z'
			fill='black'
		/>
		<path
			d='M12.5269 60.9755L13.2773 62.2742L15.4418 61.0234L14.6914 59.7247L12.5269 60.9755Z'
			fill='black'
		/>
		<path
			d='M3.85913 65.9784L4.60938 67.2795L6.77599 66.0303L6.02574 64.7291L3.85913 65.9784Z'
			fill='black'
		/>
		<path
			d='M8.19486 63.4777L8.94531 64.7764L11.1107 63.5251L10.3602 62.2264L8.19486 63.4777Z'
			fill='black'
		/>
		<path
			d='M37.1116 48.5199L36.3613 47.2188L34.1947 48.468L34.945 49.7692L37.1116 48.5199Z'
			fill='black'
		/>
		<path
			d='M32.7755 51.0246L32.0254 49.7256L29.8604 50.9758L30.6105 52.2748L32.7755 51.0246Z'
			fill='black'
		/>
		<path
			d='M28.4435 53.5246L27.6934 52.2256L25.5275 53.4763L26.2776 54.7753L28.4435 53.5246Z'
			fill='black'
		/>
		<path
			d='M76.0808 65.9846L73.916 64.7339L73.1656 66.0327L75.3303 67.2835L76.0808 65.9846Z'
			fill='black'
		/>
		<path
			d='M71.7501 63.4805L69.584 62.2305L68.8343 63.5296L71.0004 64.7796L71.7501 63.4805Z'
			fill='black'
		/>
		<path
			d='M51.4999 53.5271L53.666 54.7771L54.4157 53.4779L52.2496 52.228L51.4999 53.5271Z'
			fill='black'
		/>
		<path
			d='M67.4061 60.9792L65.2422 59.7292L64.4919 61.0281L66.6558 62.2781L67.4061 60.9792Z'
			fill='black'
		/>
		<path
			d='M42.8397 48.5266L45.0059 49.7766L45.7566 48.4757L43.5904 47.2257L42.8397 48.5266Z'
			fill='black'
		/>
		<path
			d='M47.1737 51.0269L49.3398 52.2769L50.0895 50.9777L47.9234 49.7277L47.1737 51.0269Z'
			fill='black'
		/>
		<path
			d='M45.0175 72.2805L47.1836 73.5305L47.9338 72.2305L45.7677 70.9805L45.0175 72.2805Z'
			fill='black'
		/>
		<path
			d='M49.3397 74.7754L51.5059 76.0254L52.2556 74.7262L50.0894 73.4762L49.3397 74.7754Z'
			fill='black'
		/>
		<path
			d='M54.4298 75.9827L53.6797 77.2817L55.8456 78.5325L56.5957 77.2335L54.4298 75.9827Z'
			fill='black'
		/>
		<path
			d='M32.0093 72.2313L32.7598 73.53L34.9251 72.2788L34.1747 70.9801L32.0093 72.2313Z'
			fill='black'
		/>
		<path
			d='M23.3491 77.2324L24.0996 78.5322L26.2646 77.2822L25.5141 75.9824L23.3491 77.2324Z'
			fill='black'
		/>
		<path
			d='M27.6815 74.7252L28.4316 76.0242L30.5975 74.7734L29.8474 73.4744L27.6815 74.7252Z'
			fill='black'
		/>
		<path
			d='M37.1079 26.0221L36.3574 24.7234L34.1921 25.9746L34.9425 27.2733L37.1079 26.0221Z'
			fill='black'
		/>
		<path
			d='M32.7772 28.5228L32.0273 27.2236L29.8612 28.4739L30.6111 29.773L32.7772 28.5228Z'
			fill='black'
		/>
		<path
			d='M28.4393 31.0233L27.6895 29.7241L25.5233 30.9744L26.2732 32.2735L28.4393 31.0233Z'
			fill='black'
		/>
		<path
			d='M15.4455 38.5297L14.6953 37.2307L12.5294 38.4815L13.2796 39.7805L15.4455 38.5297Z'
			fill='black'
		/>
		<path
			d='M11.1137 41.0299L10.3633 39.7312L8.19792 40.9825L8.94837 42.2812L11.1137 41.0299Z'
			fill='black'
		/>
		<path
			d='M4.61709 44.7751L6.7832 43.5251L6.0335 42.226L3.86739 43.476L4.61709 44.7751Z'
			fill='black'
		/>
		<path
			d='M64.5002 38.5273L66.666 39.7778L67.416 38.4788L65.2502 37.2283L64.5002 38.5273Z'
			fill='black'
		/>
		<path
			d='M45.7529 25.9695L43.5859 24.719L42.8362 26.0181L45.0032 27.2686L45.7529 25.9695Z'
			fill='black'
		/>
		<path
			d='M54.4187 30.9758L52.2539 29.7253L51.5036 31.0242L53.6684 32.2747L54.4187 30.9758Z'
			fill='black'
		/>
		<path
			d='M50.0838 28.4741L47.918 27.2236L47.168 28.5226L49.3338 29.7731L50.0838 28.4741Z'
			fill='black'
		/>
		<path
			d='M73.9159 42.2321L73.166 43.5312L75.3321 44.7815L76.082 43.4823L73.9159 42.2321Z'
			fill='black'
		/>
		<path
			d='M68.8341 41.0283L71 42.2788L71.75 40.9798L69.5841 39.7293L68.8341 41.0283Z'
			fill='black'
		/>
	</svg>
);

export const ViewIconSVG = ({ color, width, height }: { color?: string; width?: string; height?: string }) => (
	<svg
		width='22'
		height='15'
		viewBox='0 0 22 15'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M11 12C12.25 12 13.3125 11.5625 14.1875 10.6875C15.0625 9.8125 15.5 8.75 15.5 7.5C15.5 6.25 15.0625 5.1875 14.1875 4.3125C13.3125 3.4375 12.25 3 11 3C9.75 3 8.6875 3.4375 7.8125 4.3125C6.9375 5.1875 6.5 6.25 6.5 7.5C6.5 8.75 6.9375 9.8125 7.8125 10.6875C8.6875 11.5625 9.75 12 11 12ZM11 10.2C10.25 10.2 9.6125 9.9375 9.0875 9.4125C8.5625 8.8875 8.3 8.25 8.3 7.5C8.3 6.75 8.5625 6.1125 9.0875 5.5875C9.6125 5.0625 10.25 4.8 11 4.8C11.75 4.8 12.3875 5.0625 12.9125 5.5875C13.4375 6.1125 13.7 6.75 13.7 7.5C13.7 8.25 13.4375 8.8875 12.9125 9.4125C12.3875 9.9375 11.75 10.2 11 10.2ZM11 15C8.56667 15 6.35 14.3208 4.35 12.9625C2.35 11.6042 0.9 9.78333 0 7.5C0.9 5.21667 2.35 3.39583 4.35 2.0375C6.35 0.679167 8.56667 0 11 0C13.4333 0 15.65 0.679167 17.65 2.0375C19.65 3.39583 21.1 5.21667 22 7.5C21.1 9.78333 19.65 11.6042 17.65 12.9625C15.65 14.3208 13.4333 15 11 15ZM11 13C12.8833 13 14.6125 12.5042 16.1875 11.5125C17.7625 10.5208 18.9667 9.18333 19.8 7.5C18.9667 5.81667 17.7625 4.47917 16.1875 3.4875C14.6125 2.49583 12.8833 2 11 2C9.11667 2 7.3875 2.49583 5.8125 3.4875C4.2375 4.47917 3.03333 5.81667 2.2 7.5C3.03333 9.18333 4.2375 10.5208 5.8125 11.5125C7.3875 12.5042 9.11667 13 11 13Z'
			fill='#525252'
		/>
	</svg>
);

export const TrashSVG = ({ color }: { color?: string }) => (
	<svg
		width='13'
		height='13'
		viewBox='0 0 20 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M17.7351 5.07178L17.0431 21.6796C17.0212 22.2067 16.5657 22.6425 16.0365 22.6425H3.96107C3.43186 22.6425 2.97637 22.2058 2.95444 21.6796L2.26245 5.07178C2.24944 4.75944 1.98568 4.51678 1.67334 4.5298C1.361 4.54281 1.11835 4.80657 1.13136 5.11891L1.82335 21.7267C1.87055 22.8594 2.82507 23.7746 3.96107 23.7746H16.0365C17.1719 23.7746 18.127 22.8609 18.1742 21.7267L18.8662 5.11891C18.8792 4.80657 18.6366 4.54281 18.3242 4.5298C18.0119 4.51678 17.7481 4.75944 17.7351 5.07178Z'
			fill={color || 'black'}
		/>
		<path
			d='M9.62305 7.35901V20.1892C9.62305 20.5018 9.87647 20.7552 10.1891 20.7552C10.5017 20.7552 10.7551 20.5018 10.7551 20.1892V7.35901C10.7551 7.04639 10.5017 6.79297 10.1891 6.79297C9.87647 6.79297 9.62305 7.04639 9.62305 7.35901Z'
			fill={color || 'black'}
		/>
		<path
			d='M5.28345 7.37565L5.66081 20.2058C5.67 20.5183 5.93077 20.7642 6.24324 20.755C6.55572 20.7458 6.80159 20.485 6.7924 20.1726L6.41504 7.34237C6.40585 7.02989 6.14508 6.78403 5.8326 6.79322C5.52013 6.80241 5.27426 7.06317 5.28345 7.37565Z'
			fill={color || 'black'}
		/>
		<path
			d='M13.5846 7.34237L13.2073 20.1726C13.1981 20.485 13.444 20.7458 13.7564 20.755C14.0689 20.7642 14.3297 20.5183 14.3389 20.2058L14.7162 7.37565C14.7254 7.06317 14.4796 6.80241 14.1671 6.79322C13.8546 6.78403 13.5938 7.02989 13.5846 7.34237Z'
			fill={color || 'black'}
		/>
		<path
			d='M0.566038 3.20825H19.434C19.7466 3.20825 20 2.95482 20 2.64221C20 2.3296 19.7466 2.07617 19.434 2.07617H0.566038C0.253424 2.07617 0 2.3296 0 2.64221C0 2.95482 0.253424 3.20825 0.566038 3.20825Z'
			fill={color || 'black'}
		/>
		<path
			d='M6.75228 2.66305L7.15615 1.65337C7.26367 1.38458 7.63668 1.13208 7.92484 1.13208H12.0758C12.366 1.13208 12.7362 1.38271 12.8445 1.65337L13.2483 2.66305L14.2994 2.24261L13.8956 1.23293C13.6154 0.532464 12.8289 0 12.0758 0H7.92484C7.17381 0 6.3845 0.534297 6.10504 1.23293L5.70117 2.24261L6.75228 2.66305Z'
			fill={color || 'black'}
		/>
	</svg>
);

export const ErrorSVG = ({ color }: { color?: string }) => (
	<svg
		width='13'
		height='13'
		viewBox='0 0 83 83'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M41.404 0C18.574 0 0 18.575 0 41.406C0 64.237 18.574 82.811 41.404 82.811C64.235 82.811 82.808 64.237 82.808 41.406C82.809 18.575 64.235 0 41.404 0ZM41.404 77.811C21.331 77.811 5 61.48 5 41.406C5 21.332 21.331 5 41.404 5C61.477 5 77.809 21.332 77.809 41.406C77.809 61.48 61.477 77.811 41.404 77.811Z'
			fill={color || '#000'}
		/>
		<path
			d='M55.0062 27.806C54.0292 26.83 52.4452 26.83 51.4712 27.807L41.4042 37.878L31.3382 27.807C30.3612 26.829 28.7782 26.83 27.8032 27.806C26.8262 28.782 26.8262 30.365 27.8022 31.341L37.8702 41.414L27.8022 51.486C26.8262 52.462 26.8262 54.046 27.8032 55.021C28.2912 55.509 28.9302 55.752 29.5702 55.752C30.2102 55.752 30.8502 55.508 31.3382 55.02L41.4042 44.95L51.4702 55.02C51.9582 55.508 52.5972 55.752 53.2382 55.752C53.8782 55.752 54.5172 55.508 55.0062 55.021C55.9832 54.045 55.9832 52.461 55.0062 51.486L44.9382 41.414L55.0052 31.341C55.9822 30.365 55.9822 28.782 55.0062 27.806Z'
			fill={color || '#000'}
		/>
	</svg>
);

export const FlagSVG = () => (
	<svg
		width='13'
		height='13'
		viewBox='0 0 16 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M12.3999 5.03268L15.9494 1.1832C16.0137 1.0802 16.017 0.950882 15.9584 0.844869C15.8993 0.738856 15.7877 0.673203 15.6667 0.673203H0.666667V0.333333C0.666667 0.148987 0.517647 0 0.333333 0C0.14902 0 0 0.14902 0 0.333333V1.00654V8.05882V9.05882V19.6667C0 19.851 0.148987 20 0.333333 20C0.51768 20 0.666667 19.851 0.666667 19.6667V9.39216H15.6667C15.7877 9.39216 15.8993 9.32647 15.9584 9.22013C16.017 9.11448 16.0137 8.9848 15.9494 8.8818L12.3999 5.03268ZM0.666699 8.72549V8.05882V1.33987H15.065L11.7239 4.85601C11.6562 4.96402 11.6562 5.10134 11.7239 5.20967L15.065 8.72549H0.666699Z'
			fill='black'
		/>
	</svg>
);

export const CautionSvg = ({ ...rest }: SVGComponentProps) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 24 24'
		width='14'
		height='14'
		role='img'
		aria-labelledby='cautionTitle cautionDesc'
		focusable='false'
		style={{ color: '#f6c23e' }}
		{...rest}
	>
		<path
			d='M1 21h22L12 2 1 21z'
			fill='currentColor'
		/>

		<rect
			x='11'
			y='7.5'
			width='2'
			height='6'
			rx='0.6'
			fill='#fff'
		/>
		<circle
			cx='12'
			cy='17.2'
			r='1.2'
			fill='#fff'
		/>
	</svg>
);

export const ArrowDownSvg = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='8'
		height='11'
		viewBox='0 0 8 11'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M4.37616 10.8509L7.82962 7.55087C8.01422 7.3654 8.07742 6.96865 7.87364 6.75165C7.66987 6.53538 7.28292 6.53609 7.07986 6.75452L4.54647 9.17231V0.549997C4.54647 0.246362 4.30222 0 4.00119 0C3.70015 0 3.4559 0.246362 3.4559 0.549997V9.17231L0.922516 6.75452C0.720161 6.53681 0.318306 6.52178 0.128729 6.75165C-0.0459325 6.96362 -0.0537411 7.35823 0.17275 7.55087L3.62621 10.8509C3.76537 10.9912 4.13245 11.1008 4.37598 10.8509H4.37616Z'
			fill='red'
		/>
	</svg>
);

export const ArrowUpSvg = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='8'
		height='11'
		viewBox='0 0 8 11'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M3.62384 0.149141L0.170379 3.44913C-0.0142176 3.6346 -0.0774155 4.03135 0.126359 4.24835C0.330131 4.46462 0.717081 4.46391 0.920145 4.24548L3.45353 1.82769L3.45353 10.45C3.45353 10.7536 3.69778 11 3.99881 11C4.29985 11 4.5441 10.7536 4.5441 10.45L4.5441 1.82769L7.07748 4.24548C7.27984 4.46319 7.68169 4.47822 7.87127 4.24835C8.04593 4.03638 8.05374 3.64177 7.82725 3.44913L4.37379 0.149141C4.23463 0.00877809 3.86755 -0.100796 3.62403 0.149141L3.62384 0.149141Z'
			fill='#0C9F29'
		/>
	</svg>
);

export const NotesSVG = () => (
	<svg
		width='9'
		height='13'
		viewBox='0 0 9 13'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M0.120687 13H8.83346C8.89445 13 8.944 12.9504 8.944 12.8895V0.691577C8.944 0.630587 8.89445 0.581033 8.83346 0.581033H8.07273V0.110543C8.07273 0.0495541 8.02317 0 7.96219 0C7.9012 0 7.85164 0.0495541 7.85164 0.110543V0.581033H5.74594V0.110543C5.74594 0.0495541 5.69638 0 5.6354 0C5.57441 0 5.52485 0.0495541 5.52485 0.110543V0.581033H3.41915V0.110543C3.41915 0.0495541 3.3696 0 3.30861 0C3.24762 0 3.19806 0.0495541 3.19806 0.110543V0.581033H1.09236V0.110543C1.09236 0.0495541 1.04281 0 0.981816 0C0.920827 0 0.871273 0.0495541 0.871273 0.110543V0.581033H0.110544C0.0495542 0.581033 0 0.630587 0 0.691577V12.8895C0 12.9504 0.0495542 13 0.110544 13H0.120687ZM0.23123 2.54467H8.72625V11.0397H7.09425C7.03326 11.0397 6.9837 11.0892 6.9837 11.1502V12.7822H0.231234L0.23123 2.54467ZM0.23123 1.38316H0.884688V1.85365C0.884688 1.91464 0.934242 1.96419 0.995231 1.96419C1.05622 1.96419 1.10577 1.91464 1.10577 1.85365V1.38316H3.21148V1.85365C3.21148 1.91464 3.26103 1.96419 3.32202 1.96419C3.38301 1.96419 3.43256 1.91464 3.43256 1.85365V1.38316H5.53827V1.85365C5.53827 1.91464 5.58782 1.96419 5.64881 1.96419C5.7098 1.96419 5.75935 1.91464 5.75935 1.85365V1.38316H7.86506V1.85365C7.86506 1.91464 7.91461 1.96419 7.9756 1.96419C8.03659 1.96419 8.08614 1.91464 8.08614 1.85365V1.38316H8.7396V2.32686H0.231057L0.23123 1.38316ZM8.57207 11.2574L7.20145 12.6281V11.2574H8.57207ZM7.355 12.7823L8.72562 11.4116V12.7823H7.355ZM8.72562 0.80212V1.16534H8.07217V0.80212H8.72562ZM7.85435 0.80212V1.16534H5.74864V0.80212H7.85435ZM5.53076 0.80212V1.16534H3.42505V0.80212H5.53076ZM3.20716 0.80212V1.16534H1.10146V0.80212H3.20716ZM0.883573 0.80212V1.16534H0.230115V0.80212H0.883573Z'
			fill='black'
		/>
		<path
			d='M1.28242 4.28701H7.6716C7.73259 4.28701 7.78214 4.23745 7.78214 4.17646C7.78214 4.11547 7.73259 4.06592 7.6716 4.06592L1.28242 4.06646C1.22143 4.06646 1.17188 4.11602 1.17188 4.17701C1.17188 4.238 1.22143 4.28755 1.28242 4.28755V4.28701Z'
			fill='black'
		/>
		<path
			d='M1.28242 6.32021H7.6716C7.73259 6.32021 7.78214 6.27065 7.78214 6.20966C7.78214 6.14867 7.73259 6.09912 7.6716 6.09912L1.28242 6.09967C1.22143 6.09967 1.17188 6.14922 1.17188 6.21021C1.17188 6.2712 1.22143 6.32075 1.28242 6.32075V6.32021Z'
			fill='black'
		/>
		<path
			d='M1.28242 8.35341H7.6716C7.73259 8.35341 7.78214 8.30386 7.78214 8.24287C7.78214 8.18188 7.73259 8.13232 7.6716 8.13232H1.28242C1.22143 8.13232 1.17188 8.18188 1.17188 8.24287C1.17188 8.30386 1.22143 8.35341 1.28242 8.35341Z'
			fill='black'
		/>
		<path
			d='M5.9296 10.1655H1.28242C1.22143 10.1655 1.17188 10.2151 1.17188 10.2761C1.17188 10.3371 1.22143 10.3866 1.28242 10.3866H5.92904C5.99003 10.3866 6.03959 10.3371 6.03959 10.2761C6.03959 10.2151 5.99003 10.1655 5.92904 10.1655H5.9296Z'
			fill='black'
		/>
	</svg>
);

export const CameraSVG = ({ color, width, height }: { color?: string; width?: string; height?: string }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '24'}
		height={height || '24'}
		viewBox='0 0 24 24'
		fill='none'
		stroke={color || 'currentColor'}
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
	>
		<path d='M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z' />
		<circle
			cx='12'
			cy='13'
			r='4'
		/>
	</svg>
);

export const PaperclipSVG = ({ color, width, height }: { color?: string; width?: string; height?: string }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '22'}
		height={height || '22'}
		viewBox='0 0 24 24'
		fill='none'
		stroke={color || 'currentColor'}
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
		aria-hidden='true'
	>
		<path d='M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48' />
	</svg>
);

export const DocumentSVG = ({ color, width, height }: { color?: string; width?: string; height?: string }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '28'}
		height={height || '28'}
		viewBox='0 0 24 24'
		fill='none'
		stroke={color || 'currentColor'}
		strokeWidth='1.8'
		strokeLinecap='round'
		strokeLinejoin='round'
		aria-hidden='true'
	>
		<path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' />
		<path d='M14 2v6h6' />
		<path d='M8 13h8M8 17h5' />
	</svg>
);

export const LightbulbSVG = ({ color }: { color?: string }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='20'
		height='20'
		viewBox='0 0 24 24'
		fill='none'
		stroke={color || 'currentColor'}
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
	>
		<line
			x1='9'
			y1='18'
			x2='15'
			y2='18'
		/>
		<line
			x1='10'
			y1='22'
			x2='14'
			y2='22'
		/>
		<path d='M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14' />
	</svg>
);

export const SaveDraftSVG = ({ color, width, height }: { color?: string; width?: string; height?: string }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '18'}
		height={height || '18'}
		viewBox='0 0 24 24'
		fill='none'
		stroke={color || 'currentColor'}
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
	>
		<path d='M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z' />
		<polyline points='17 21 17 13 7 13 7 21' />
		<polyline points='7 3 7 8 15 8' />
	</svg>
);
